// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 *   AdminLTE v2.4.5
 *   Author: Almsaeed Studio
 *	 Website: Almsaeed Studio <https://adminlte.io>
 *   License: Open source - MIT
 *           Please visit http://opensource.org/licenses/MIT for more information
 */
/*
 * Core: General Layout Style
 * -------------------------
 */
html,
body {
    height: 100%;
}

.layout-boxed html,
.layout-boxed body {
    height: 100%;
}

body {
    font-family: 'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: 400;
    overflow-x: hidden;
    overflow-y: auto;
}
/* Layout */
.wrapper {
    height: 100%;
    position: relative;
}

    .wrapper:before,
    .wrapper:after {
        content: " ";
        display: table;
    }

    .wrapper:after {
        clear: both;
    }

.layout-boxed .wrapper {
    max-width: 1250px;
    margin: 0 auto;
    min-height: 100%;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);
    position: relative;
}

.layout-boxed {
    background-color: var(--mu-superficie-sutil, #f9fafc);
}
/*
 * Content Wrapper - contains the main content
 */
.content-wrapper,
.main-footer {
    -webkit-transition: -webkit-transform 0.3s ease-in-out, margin 0.3s ease-in-out;
    -moz-transition: -moz-transform 0.3s ease-in-out, margin 0.3s ease-in-out;
    -o-transition: -o-transform 0.3s ease-in-out, margin 0.3s ease-in-out;
    transition: transform 0.3s ease-in-out, margin 0.3s ease-in-out;
    margin-left: 230px;
    z-index: 820;
}

.layout-top-nav .content-wrapper,
.layout-top-nav .main-footer {
    margin-left: 0;
}

@media (max-width: 767px) {
    .content-wrapper,
    .main-footer {
        margin-left: 0;
    }
}

@media (min-width: 768px) {
    .sidebar-collapse .content-wrapper,
    .sidebar-collapse .main-footer {
        margin-left: 50px;
    }
}

@media (max-width: 767px) {
    .sidebar-open .content-wrapper,
    .sidebar-open .main-footer {
        -webkit-transform: translate(230px, 0);
        -ms-transform: translate(230px, 0);
        -o-transform: translate(230px, 0);
        transform: translate(230px, 0);
    }
}

.content-wrapper {
    min-height: 100%;
    /*background-color: #ecf0f5;*/
    z-index: 800;
}

.main-footer {
    background: var(--mu-superficie, #fff);
    padding: 15px;
    color: var(--mu-texto, #444);
    border-top: 1px solid var(--mu-borda-forte, #d2d6de);
}
/* Fixed layout */
.fixed .main-header,
.fixed .main-sidebar,
.fixed .left-side {
    position: fixed;
}

.wrapword {
    white-space: -moz-pre-wrap !important; /* Mozilla, since 1999 */
    white-space: -pre-wrap; /* Opera 4-6 */
    white-space: -o-pre-wrap; /* Opera 7 */
    white-space: pre-wrap; /* css-3 */
    word-wrap: break-word; /* Internet Explorer 5.5+ */
    white-space: -webkit-pre-wrap; /* Newer versions of Chrome/Safari*/
    word-break: wrapword;
    white-space: normal;
}

.fixed .main-header {
    top: 0;
    right: 0;
    left: 0;
}

.fixed .content-wrapper,
.fixed .right-side {
    padding-top: 100px;
}

@media (max-width: 767px) {
    .fixed .content-wrapper,
    .fixed .right-side {
        padding-top: 100px;
    }
}

.fixed.layout-boxed .wrapper {
    max-width: 100%;
}


.hold-transition .content-wrapper,
.hold-transition .right-side,
.hold-transition .main-footer,
.hold-transition .main-sidebar,
.hold-transition .left-side,
.hold-transition .main-header .navbar,
.hold-transition .main-header .logo,
.hold-transition .menu-open .fa-angle-left {
    /* Fix for IE */
    -webkit-transition: none;
    -o-transition: none;
    transition: none;
}
/* Content */
.content {
    min-height: 250px;
    /*padding: 15px 15px 0 15px;*/
    padding: 1px 10px 0 5px;
    margin-right: auto;
    margin-left: auto;
}
/* H1 - H6 font */
h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
    font-family: 'Source Sans Pro', sans-serif;
}
/* General Links */
a {
    color: #3c8dbc;
}

    a:hover,
    a:active,
    a:focus {
        outline: none;
        text-decoration: none;
        color: #72afd2;
    }
/* Page Header */
.page-header {
    margin: 10px 0 20px 0;
    font-size: 22px;
}

    .page-header > small {
        color: var(--mu-texto-suave, #666);
        display: block;
        margin-top: 5px;
    }
/*
 * Component: Main Header
 * ----------------------
 */
.main-header {
    position: relative;
    max-height: 108px;
    z-index: 1030;
}

    .main-header .navbar {
        -webkit-transition: margin-left 0.3s ease-in-out;
        -o-transition: margin-left 0.3s ease-in-out;
        transition: margin-left 0.3s ease-in-out;
        margin-bottom: 0;
        margin-left: 230px;
        border: none;
        min-height: 50px;
        border-radius: 0;
    }

.layout-top-nav .main-header .navbar {
    margin-left: 0;
}

.main-header #navbar-search-input.form-control {
    background: rgba(255, 255, 255, 0.2);
    border-color: transparent;
}

    .main-header #navbar-search-input.form-control:focus,
    .main-header #navbar-search-input.form-control:active {
        border-color: rgba(0, 0, 0, 0.1);
        background: rgba(255, 255, 255, 0.9);
    }

    .main-header #navbar-search-input.form-control::-moz-placeholder {
        color: var(--mu-texto-desab, #ccc);
        opacity: 1;
    }

    .main-header #navbar-search-input.form-control:-ms-input-placeholder {
        color: var(--mu-texto-desab, #ccc);
    }

    .main-header #navbar-search-input.form-control::-webkit-input-placeholder {
        color: var(--mu-texto-desab, #ccc);
    }

.main-header .navbar-custom-menu,
.main-header .navbar-right {
    float: right;
}

@media (max-width: 991px) {
    .main-header .navbar-custom-menu a,
    .main-header .navbar-right a {
        color: inherit;
        background: transparent;
    }
}

@media (max-width: 767px) {
    .main-header .navbar-right {
        float: none;
    }

    .navbar-collapse .main-header .navbar-right {
        margin: 7.5px -15px;
    }

    .main-header .navbar-right > li {
        color: inherit;
        border: 0;
    }
}

.main-header .sidebar-toggle {
    float: left;
    background-color: transparent;
    background-image: none;
    padding: 15px 15px;
    font-family: fontAwesome;
}

    .main-header .sidebar-toggle:before {
        content: "\\f0c9";
    }

    .main-header .sidebar-toggle:hover {
        color: #fff;
    }

    .main-header .sidebar-toggle:focus,
    .main-header .sidebar-toggle:active {
        background: transparent;
    }

    .main-header .sidebar-toggle .icon-bar {
        display: none;
    }

.main-header .navbar .nav > li.user > a > .fa,
.main-header .navbar .nav > li.user > a > .glyphicon,
.main-header .navbar .nav > li.user > a > .ion {
    margin-right: 5px;
}

.main-header .navbar .nav > li > a > .label {
    position: absolute;
    top: 9px;
    right: 7px;
    text-align: center;
    font-size: 9px;
    padding: 2px 3px;
    line-height: .9;
}

.main-header .logo {
    -webkit-transition: width 0.3s ease-in-out;
    -o-transition: width 0.3s ease-in-out;
    transition: width 0.3s ease-in-out;
    display: block;
    float: left;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    text-align: center;
    width: 230px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    padding: 0 15px;
    font-weight: 300;
    overflow: hidden;
}

    .main-header .logo .logo-lg {
        display: block;
    }

    .main-header .logo .logo-mini {
        display: none;
    }

.main-header .navbar-brand {
    color: #fff;
}

.content-header {
    position: relative;
    padding: 15px 15px 0 15px;
}

    .content-header > h1 {
        margin: 0;
        font-size: 24px;
    }

        .content-header > h1 > small {
            font-size: 15px;
            display: inline-block;
            padding-left: 4px;
            font-weight: 300;
        }

    .content-header > .breadcrumb {
        float: right;
        background: transparent;
        margin-top: 0;
        margin-bottom: 0;
        font-size: 12px;
        padding: 7px 5px;
        position: absolute;
        top: 15px;
        right: 10px;
        border-radius: 2px;
    }

        .content-header > .breadcrumb > li > a {
            color: var(--mu-texto, #444);
            text-decoration: none;
            display: inline-block;
        }

            .content-header > .breadcrumb > li > a > .fa,
            .content-header > .breadcrumb > li > a > .glyphicon,
            .content-header > .breadcrumb > li > a > .ion {
                margin-right: 5px;
            }

        .content-header > .breadcrumb > li + li:before {
            content: '>\\00a0';
        }

@media (max-width: 991px) {
    .content-header > .breadcrumb {
        position: relative;
        margin-top: 5px;
        top: 0;
        right: 0;
        float: none;
        background: var(--mu-superficie-forte, #d2d6de);
        padding-left: 10px;
    }

        .content-header > .breadcrumb li:before {
            color: #97a0b3;
        }
}

.navbar-toggle {
    color: #fff;
    border: 0;
    margin: 0;
    padding: 15px 15px;
}

@media (max-width: 991px) {
    .navbar-custom-menu .navbar-nav > li {
        float: left;
    }

    .navbar-custom-menu .navbar-nav {
        margin: 0;
        float: left;
    }

        .navbar-custom-menu .navbar-nav > li > a {
            padding-top: 15px;
            padding-bottom: 15px;
            line-height: 20px;
        }
}

@media (max-width: 767px) {
    .main-header {
        position: relative;
    }

        .main-header .logo,
        .main-header .navbar {
            width: 100%;
            float: none;
        }

        .main-header .navbar {
            margin: 0;
        }

        .main-header .navbar-custom-menu {
            float: right;
        }
}

@media (max-width: 991px) {
    .navbar-collapse.pull-left {
        float: none !important;
    }

        .navbar-collapse.pull-left + .navbar-custom-menu {
            display: block;
            position: absolute;
            top: 0;
            right: 40px;
        }
}
/*
 * Component: Sidebar
 * ------------------
 */
.main-sidebar {
    background-color: var(--mu-superficie-sutil, #f2f2f2);
    position: absolute;
    top: 0;
    left: 0;
    padding-top: 118px;
    min-height: 100%;
    width: 219px;
    z-index: 810;
    -webkit-transition: -webkit-transform 0.3s ease-in-out, width 0.3s ease-in-out;
    -moz-transition: -moz-transform 0.3s ease-in-out, width 0.3s ease-in-out;
    -o-transition: -o-transform 0.3s ease-in-out, width 0.3s ease-in-out;
    transition: transform 0.3s ease-in-out, width 0.3s ease-in-out;
}

@media (max-width: 767px) {
    .main-sidebar {
        padding-top: 100px;
    }
}
/*@media (max-width: 767px) {
  .main-sidebar {
    -webkit-transform: translate(-230px, 0);
    -ms-transform: translate(-230px, 0);
    -o-transform: translate(-230px, 0);
    transform: translate(-230px, 0);
    background-color: #f2f2f2;
  }
}
@media (min-width: 768px) {
  .sidebar-collapse .main-sidebar {
    -webkit-transform: translate(-230px, 0);
    -ms-transform: translate(-230px, 0);
    -o-transform: translate(-230px, 0);
    transform: translate(-230px, 0);
  }
}
@media (max-width: 767px) {
  .sidebar-open .main-sidebar {
    -webkit-transform: translate(0, 0);
    -ms-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
}*/
.sidebar-inner {
    padding-bottom: 10px;
}

.sidebar-form input:focus {
    border-color: transparent;
}

.user-panel {
    position: relative;
    width: 100%;
    padding: 10px;
    overflow: hidden;
}

    .user-panel:before,
    .user-panel:after {
        content: " ";
        display: table;
    }

    .user-panel:after {
        clear: both;
    }

    .user-panel > .image > img {
        width: 100%;
        max-width: 45px;
        height: auto;
    }

    .user-panel > .info {
        padding: 5px 5px 5px 15px;
        line-height: 1;
        position: absolute;
        left: 55px;
    }

        .user-panel > .info > p {
            font-weight: 600;
            margin-bottom: 9px;
        }

        .user-panel > .info > a {
            text-decoration: none;
            padding-right: 5px;
            margin-top: 3px;
            font-size: 11px;
        }

            .user-panel > .info > a > .fa,
            .user-panel > .info > a > .ion,
            .user-panel > .info > a > .glyphicon {
                margin-right: 3px;
            }

.sidebar-menu {
    list-style: none;
    margin: 0;
    padding: 0;
}

    .sidebar-menu > li {
        position: relative;
        margin: 0;
        padding: 0;
    }

        .sidebar-menu > li > a {
            padding: 12px 5px 12px 15px;
            display: block;
        }

            /* 493427 — item ATIVO (a tela aberta) do menu esquerdo. O \`ativo\` vai no <li>, nao no
               <a> (ver orcamentoController.tsx: \`\$("[item-menu]").parent().addClass("ativo")\`), e
               quem pintava era \`li.ativo a\` em estilo.css, com --mu-superficie-media. No claro isso
               da #e4e6e8, que funciona; no ESCURO da #171c20 — mais escuro que o proprio fundo do
               menu (--mu-superficie-sutil, #1c2126) — e a linha ativa ficava indistinguivel.

               Regra propria aqui em vez de mexer em --mu-superficie-media, que e compartilhada com
               cabecalho de tabela e barra de ferramentas: mudar o token move tudo isso junto. O
               valor claro repete o #e4e6e8 de hoje, ou seja, no tema claro nada muda. */
            .sidebar-menu > li.ativo > a[item-menu] {
                background-color: var(--mu-menu-esquerdo-ativo, #e4e6e8);
            }

            /* Realce da linha inteira ao passar o mouse no item do menu esquerdo. O <a> ja e
               \`display: block\`, entao o fundo cobre a largura toda da linha.

               A cor e SEMPRE MAIS CLARA que a do item ativo acima, nos dois temas: e o que deixa
               distinguir "linha sob o mouse" de "tela aberta". Antes o hover usava exatamente o
               mesmo #e4e6e8 do ativo no claro, e os dois se confundiam.

               Vem DEPOIS da regra do ativo de proposito: as duas tem a mesma especificidade, entao
               quem estiver por ultimo vence — assim passar o mouse na propria linha ativa tambem
               clareia, em vez de ficar sem resposta.

               O gatilho e \`li:hover\`, e nao \`a[item-menu]:hover\`: a estrela de "menu favorito" e um
               <a> IRMAO dentro do mesmo <li> (flutuando a direita, puxado para cima), entao com o
               gatilho no proprio <a> passar o mouse na estrela deixava a linha sem realce mesmo com
               o ponteiro dentro dela. Quem PINTA continua sendo so o \`a[item-menu]\` — a estrela nao
               ganha fundo proprio (ver regra seguinte).

               \`:focus\` fica no proprio <a> porque foco e por elemento, nao pela linha; estes itens
               tem accesskey e sao alcancaveis por Tab, e o mesmo realce serve de indicacao de foco. */
            .sidebar-menu > li:hover > a[item-menu],
            .sidebar-menu > li > a[item-menu]:focus {
                background-color: var(--mu-menu-item-hover, #fff);
            }

            /* A estrela de "menu favorito" NUNCA pinta fundo proprio: ela e desenhada por cima do
               <a> da linha (mesma <li>, \`position: relative\` com \`top\` negativo), entao sem fundo
               ela mostra o fundo da linha e acompanha hover/ativo de graca.

               Sem isto ela destoava nos dois estados: no HOVER ficava transparente e aparecia o
               cinza do menu no lugar do realce (um retangulo mais escuro na ponta direita da linha),
               e no ATIVO herdava \`li.ativo a\` de estilo.css — que pinta TODO <a> dentro do <li>
               ativo com --mu-superficie-media, um tom que a linha ja nao usa mais.

               Especificidade (0,2,2) > (0,1,2) do \`li.ativo a\`, entao vence sem \`!important\`. */
            .sidebar-menu > li > a[menu-inicial-favorito] {
                background-color: transparent;
            }

            .sidebar-menu > li > a > .fa,
            .sidebar-menu > li > a > .glyphicon,
            .sidebar-menu > li > a > .ion {
                width: 20px;
            }

        .sidebar-menu > li .label,
        .sidebar-menu > li .badge {
            margin-right: 5px;
        }

        .sidebar-menu > li .badge {
            margin-top: 3px;
        }

    .sidebar-menu li.header {
        padding: 10px 25px 10px 15px;
        font-size: 12px;
    }

    .sidebar-menu li > a > .fa-angle-left,
    .sidebar-menu li > a > .pull-right-container > .fa-angle-left {
        width: auto;
        height: auto;
        padding: 0;
        margin-right: 10px;
        -webkit-transition: transform 0.5s ease;
        -o-transition: transform 0.5s ease;
        transition: transform 0.5s ease;
    }

    .sidebar-menu li > a > .fa-angle-left {
        position: absolute;
        top: 50%;
        right: 10px;
        margin-top: -8px;
    }

    .sidebar-menu .menu-open > a > .fa-angle-left,
    .sidebar-menu .menu-open > a > .pull-right-container > .fa-angle-left {
        -webkit-transform: rotate(-90deg);
        -ms-transform: rotate(-90deg);
        -o-transform: rotate(-90deg);
        transform: rotate(-90deg);
    }

    .sidebar-menu .active > .treeview-menu {
        display: block;
    }
/*
 * Component: Sidebar Mini
 */
.sidebar-mini.sidebar-collapse .content-wrapper,
.sidebar-mini.sidebar-collapse .right-side,
.sidebar-mini.sidebar-collapse .main-footer {
    margin-left: 50px;
    z-index: 840;
}

.sidebar-mini.sidebar-collapse .main-sidebar {
    -webkit-transform: translate(0, 0);
    -ms-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
    width: 50px !important;
    z-index: 850;
}

.sidebar-mini.sidebar-collapse .sidebar-menu > li {
    position: relative;
}

    .sidebar-mini.sidebar-collapse .sidebar-menu > li > a {
        margin-right: 0;
    }

        .sidebar-mini.sidebar-collapse .sidebar-menu > li > a > span {
            border-top-right-radius: 4px;
        }

    .sidebar-mini.sidebar-collapse .sidebar-menu > li:not(.treeview) > a > span {
        border-bottom-right-radius: 4px;
    }

    .sidebar-mini.sidebar-collapse .sidebar-menu > li > .treeview-menu {
        padding-top: 5px;
        padding-bottom: 5px;
        border-bottom-right-radius: 4px;
    }

    .sidebar-mini.sidebar-collapse .main-sidebar .user-panel > .info,
    .sidebar-mini.sidebar-collapse .sidebar-form,
    .sidebar-mini.sidebar-collapse .sidebar-menu > li > a > span,
    .sidebar-mini.sidebar-collapse .sidebar-menu > li > a > u,
    .sidebar-mini.sidebar-collapse .sidebar-menu > li > .treeview-menu,
    .sidebar-mini.sidebar-collapse .sidebar-menu > li > a > .pull-right,
    .sidebar-mini.sidebar-collapse .sidebar-menu li.header {
        display: none !important;
        -webkit-transform: translateZ(0);
    }

.sidebar-mini.sidebar-collapse .main-header .logo {
    width: 50px;
}

    .sidebar-mini.sidebar-collapse .main-header .logo > .logo-mini {
        display: block;
        margin-left: -15px;
        margin-right: -15px;
        font-size: 18px;
    }

    .sidebar-mini.sidebar-collapse .main-header .logo > .logo-lg {
        display: none;
    }

.sidebar-mini.sidebar-collapse .main-header .navbar {
    margin-left: 50px;
}

.sidebar-mini:not(.sidebar-mini-expand-feature).sidebar-collapse .sidebar-menu > li:hover > a > span:not(.pull-right),
.sidebar-mini:not(.sidebar-mini-expand-feature).sidebar-collapse .sidebar-menu > li:hover > a > u,
.sidebar-mini:not(.sidebar-mini-expand-feature).sidebar-collapse .sidebar-menu > li:hover > .treeview-menu {
    display: block !important;
    position: absolute;
    width: 180px;
    left: 50px;
}

.sidebar-mini:not(.sidebar-mini-expand-feature).sidebar-collapse .sidebar-menu > li:hover > a > span,
.sidebar-mini:not(.sidebar-mini-expand-feature).sidebar-collapse .sidebar-menu > li:hover > a > u {
    top: 0;
    margin-left: -3px;
    padding: 12px 5px 12px 20px;
    background-color: inherit;
}

.sidebar-mini:not(.sidebar-mini-expand-feature).sidebar-collapse .sidebar-menu > li:hover > a > .pull-right-container {
    position: relative !important;
    float: right;
    width: auto !important;
    left: 180px !important;
    top: -22px !important;
    z-index: 900;
}

    .sidebar-mini:not(.sidebar-mini-expand-feature).sidebar-collapse .sidebar-menu > li:hover > a > .pull-right-container > .label:not(:first-of-type) {
        display: none;
    }

.sidebar-mini:not(.sidebar-mini-expand-feature).sidebar-collapse .sidebar-menu > li:hover > .treeview-menu {
    top: 44px;
    margin-left: 0;
}

.sidebar-expanded-on-hover .main-footer,
.sidebar-expanded-on-hover .content-wrapper {
    margin-left: 50px;
}

.sidebar-expanded-on-hover .main-sidebar {
    box-shadow: 3px 0 8px rgba(0, 0, 0, 0.125);
}

.sidebar-menu,
.main-sidebar .user-panel,
.sidebar-menu > li.header {
    white-space: nowrap;
    overflow: hidden;
}

    .sidebar-form,
    .sidebar-menu > li.header {
        overflow: hidden;
        text-overflow: clip;
    }

    .sidebar-menu li > a {
        position: relative;
    }

        .sidebar-menu li > a > .pull-right-container {
            position: absolute;
            right: 10px;
            top: 50%;
            margin-top: -7px;
        }
/*
 * Component: Control sidebar. By default, this is the right sidebar.
 */
.control-sidebar-bg {
    position: fixed;
    z-index: 1000;
    bottom: 0;
}

.control-sidebar-bg,
.control-sidebar {
    padding-left: 0;
    top: 0;
    right: -245px;
    /*width: 230px;*/
    -webkit-transition: right 0.3s ease-in-out;
    -o-transition: right 0.3s ease-in-out;
    transition: right 0.3s ease-in-out;
}

.control-sidebar {
    position: absolute;
    padding-top: 105px;
    z-index: 999;
}

@media (max-width: 767px) {
    .control-sidebar {
        padding-top: 100px;
    }
}

.control-sidebar > .tab-content {
    padding: 10px 15px;
}

.control-sidebar.control-sidebar-open,
.control-sidebar.control-sidebar-open + .control-sidebar-bg {
    right: 0;
}

.control-sidebar-open .control-sidebar-bg,
.control-sidebar-open .control-sidebar {
    right: 0;
}

@media (min-width: 768px) {
    .control-sidebar-open .content-wrapper,
    .control-sidebar-open .right-side,
    .control-sidebar-open .main-footer {
        margin-right: 230px;
    }
}

.fixed .control-sidebar {
    position: fixed;
    height: 100%;
    overflow-y: auto;
}

.nav-tabs.control-sidebar-tabs > li:first-of-type > a,
.nav-tabs.control-sidebar-tabs > li:first-of-type > a:hover,
.nav-tabs.control-sidebar-tabs > li:first-of-type > a:focus {
    border-left-width: 0;
}

.nav-tabs.control-sidebar-tabs > li > a {
    border-radius: 0;
}

    .nav-tabs.control-sidebar-tabs > li > a,
    .nav-tabs.control-sidebar-tabs > li > a:hover {
        border-top: none;
        border-right: none;
        border-left: 1px solid transparent;
        border-bottom: 1px solid transparent;
    }

        .nav-tabs.control-sidebar-tabs > li > a .icon {
            font-size: 16px;
        }

.nav-tabs.control-sidebar-tabs > li.active > a,
.nav-tabs.control-sidebar-tabs > li.active > a:hover,
.nav-tabs.control-sidebar-tabs > li.active > a:focus,
.nav-tabs.control-sidebar-tabs > li.active > a:active {
    border-top: none;
    border-right: none;
    border-bottom: none;
}

@media (max-width: 768px) {
    .nav-tabs.control-sidebar-tabs {
        display: table;
    }

        .nav-tabs.control-sidebar-tabs > li {
            display: table-cell;
        }
}

.control-sidebar-heading {
    font-weight: 400;
    font-size: 16px;
    padding: 10px 0;
    margin-bottom: 10px;
}

.control-sidebar-subheading {
    display: block;
    font-weight: 400;
    font-size: 14px;
}

.control-sidebar-menu {
    list-style: none;
    padding: 0;
    margin: 0 -15px;
}

    .control-sidebar-menu > li > a {
        display: block;
        padding: 10px 15px;
    }

        .control-sidebar-menu > li > a:before,
        .control-sidebar-menu > li > a:after {
            content: " ";
            display: table;
        }

        .control-sidebar-menu > li > a:after {
            clear: both;
        }

        .control-sidebar-menu > li > a > .control-sidebar-subheading {
            margin-top: 0;
        }

    .control-sidebar-menu .menu-icon {
        float: left;
        width: 35px;
        height: 35px;
        border-radius: 50%;
        text-align: center;
        line-height: 35px;
    }

    .control-sidebar-menu .menu-info {
        margin-left: 45px;
        margin-top: 3px;
    }

        .control-sidebar-menu .menu-info > .control-sidebar-subheading {
            margin: 0;
        }

        .control-sidebar-menu .menu-info > p {
            margin: 0;
            font-size: 11px;
        }

    .control-sidebar-menu .progress {
        margin: 0;
    }

.control-sidebar-dark {
    color: #b8c7ce;
}

    .control-sidebar-dark,
    .control-sidebar-dark + .control-sidebar-bg {
        background: #222d32;
    }

        .control-sidebar-dark .nav-tabs.control-sidebar-tabs {
            border-bottom: #1c2529;
        }

            .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a {
                background: #181f23;
                color: #b8c7ce;
            }

                .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a,
                .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a:hover,
                .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a:focus {
                    border-left-color: #141a1d;
                    border-bottom-color: #141a1d;
                }

                    .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a:hover,
                    .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a:focus,
                    .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a:active {
                        background: #1c2529;
                    }

                    .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a:hover {
                        color: #fff;
                    }

            .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li.active > a,
            .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li.active > a:hover,
            .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li.active > a:focus,
            .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li.active > a:active {
                background: #222d32;
                color: #fff;
            }

        .control-sidebar-dark .control-sidebar-heading,
        .control-sidebar-dark .control-sidebar-subheading {
            color: #fff;
        }

        .control-sidebar-dark .control-sidebar-menu > li > a:hover {
            background: #1e282c;
        }

        .control-sidebar-dark .control-sidebar-menu > li > a .menu-info > p {
            color: #b8c7ce;
        }

.control-sidebar-light {
    color: #5e5e5e;
}

    .control-sidebar-light,
    .control-sidebar-light + .control-sidebar-bg {
        background: var(--mu-superficie-sutil, #f9fafc);
        border-left: 1px solid var(--mu-borda-forte, #d2d6de);
    }

        .control-sidebar-light .nav-tabs.control-sidebar-tabs {
            border-bottom: var(--mu-borda-forte, #d2d6de);
        }

            .control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a {
                background: var(--mu-superficie-azul, #e8ecf4);
                color: var(--mu-texto, #444444);
            }

                .control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a,
                .control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a:hover,
                .control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a:focus {
                    border-left-color: var(--mu-borda-forte, #d2d6de);
                    border-bottom-color: var(--mu-borda-forte, #d2d6de);
                }

                    .control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a:hover,
                    .control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a:focus,
                    .control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a:active {
                        background: var(--mu-superficie-azul, #eff1f7);
                    }

            .control-sidebar-light .nav-tabs.control-sidebar-tabs > li.active > a,
            .control-sidebar-light .nav-tabs.control-sidebar-tabs > li.active > a:hover,
            .control-sidebar-light .nav-tabs.control-sidebar-tabs > li.active > a:focus,
            .control-sidebar-light .nav-tabs.control-sidebar-tabs > li.active > a:active {
                background: var(--mu-superficie-sutil, #f9fafc);
                color: var(--mu-texto, #111);
            }

        .control-sidebar-light .control-sidebar-heading,
        .control-sidebar-light .control-sidebar-subheading {
            color: var(--mu-texto, #111);
        }

        .control-sidebar-light .control-sidebar-menu {
            margin-left: -14px;
        }

            .control-sidebar-light .control-sidebar-menu > li > a:hover {
                background: var(--mu-superficie-sutil, #f4f4f5);
            }

            .control-sidebar-light .control-sidebar-menu > li > a .menu-info > p {
                color: #5e5e5e;
            }
/*
 * Component: Dropdown menus
 * -------------------------
 */
/*Dropdowns in general*/
.dropdown-menu {
    box-shadow: none;
    border-color: var(--mu-borda-sutil, #eee);
}

    .dropdown-menu > li > a {
        color: var(--mu-texto-suave, #777);
    }

        .dropdown-menu > li > a > .glyphicon,
        .dropdown-menu > li > a > .fa,
        .dropdown-menu > li > a > .ion {
            margin-right: 10px;
        }

        .dropdown-menu > li > a:hover {
            background-color: var(--mu-superficie-media, #e1e3e9);
            color: var(--mu-texto, #333);
        }

    .dropdown-menu > .divider {
        background-color: var(--mu-superficie-media, #eee);
    }

.navbar-nav > .notifications-menu > .dropdown-menu,
.navbar-nav > .messages-menu > .dropdown-menu,
.navbar-nav > .tasks-menu > .dropdown-menu {
    width: 280px;
    padding: 0 0 0 0;
    margin: 0;
    top: 100%;
}

    .navbar-nav > .notifications-menu > .dropdown-menu > li,
    .navbar-nav > .messages-menu > .dropdown-menu > li,
    .navbar-nav > .tasks-menu > .dropdown-menu > li {
        position: relative;
    }

        .navbar-nav > .notifications-menu > .dropdown-menu > li.header,
        .navbar-nav > .messages-menu > .dropdown-menu > li.header,
        .navbar-nav > .tasks-menu > .dropdown-menu > li.header {
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
            background-color: var(--mu-superficie, #ffffff);
            padding: 7px 10px;
            border-bottom: 1px solid var(--mu-borda-sutil, #f4f4f4);
            color: var(--mu-texto, #444444);
            font-size: 14px;
        }

        .navbar-nav > .notifications-menu > .dropdown-menu > li.footer > a,
        .navbar-nav > .messages-menu > .dropdown-menu > li.footer > a,
        .navbar-nav > .tasks-menu > .dropdown-menu > li.footer > a {
            border-top-left-radius: 0;
            border-top-right-radius: 0;
            border-bottom-right-radius: 4px;
            border-bottom-left-radius: 4px;
            font-size: 12px;
            background-color: var(--mu-superficie, #fff);
            padding: 7px 10px;
            border-bottom: 1px solid var(--mu-borda-sutil, #eeeeee);
            color: var(--mu-texto, #444) !important;
            text-align: center;
        }

@media (max-width: 991px) {
    .navbar-nav > .notifications-menu > .dropdown-menu > li.footer > a,
    .navbar-nav > .messages-menu > .dropdown-menu > li.footer > a,
    .navbar-nav > .tasks-menu > .dropdown-menu > li.footer > a {
        background: var(--mu-superficie, #fff) !important;
        color: var(--mu-texto, #444) !important;
    }
}

.navbar-nav > .notifications-menu > .dropdown-menu > li.footer > a:hover,
.navbar-nav > .messages-menu > .dropdown-menu > li.footer > a:hover,
.navbar-nav > .tasks-menu > .dropdown-menu > li.footer > a:hover {
    text-decoration: none;
    font-weight: normal;
}

.navbar-nav > .notifications-menu > .dropdown-menu > li .menu,
.navbar-nav > .messages-menu > .dropdown-menu > li .menu,
.navbar-nav > .tasks-menu > .dropdown-menu > li .menu {
    max-height: 200px;
    margin: 0;
    padding: 0;
    list-style: none;
    overflow-x: hidden;
}

    .navbar-nav > .notifications-menu > .dropdown-menu > li .menu > li > a,
    .navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a,
    .navbar-nav > .tasks-menu > .dropdown-menu > li .menu > li > a {
        display: block;
        white-space: nowrap;
        /* Prevent text from breaking */
        border-bottom: 1px solid var(--mu-borda-sutil, #f4f4f4);
    }

        .navbar-nav > .notifications-menu > .dropdown-menu > li .menu > li > a:hover,
        .navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a:hover,
        .navbar-nav > .tasks-menu > .dropdown-menu > li .menu > li > a:hover {
            background: var(--mu-superficie-sutil, #f4f4f4);
            text-decoration: none;
        }

    .navbar-nav > .notifications-menu > .dropdown-menu > li .menu > li > a {
        color: var(--mu-texto, #444444);
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 10px;
    }

        .navbar-nav > .notifications-menu > .dropdown-menu > li .menu > li > a > .glyphicon,
        .navbar-nav > .notifications-menu > .dropdown-menu > li .menu > li > a > .fa,
        .navbar-nav > .notifications-menu > .dropdown-menu > li .menu > li > a > .ion {
            width: 20px;
        }

    .navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a {
        margin: 0;
        padding: 10px 10px;
    }

        .navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a > div > img {
            margin: auto 10px auto auto;
            width: 40px;
            height: 40px;
        }

        .navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a > h4 {
            padding: 0;
            margin: 0 0 0 45px;
            color: var(--mu-texto, #444444);
            font-size: 15px;
            position: relative;
        }

            .navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a > h4 > small {
                color: var(--mu-texto-suave, #999999);
                font-size: 10px;
                position: absolute;
                top: 0;
                right: 0;
            }

        .navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a > p {
            margin: 0 0 0 45px;
            font-size: 12px;
            color: #888888;
        }

        .navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a:before,
        .navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a:after {
            content: " ";
            display: table;
        }

        .navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a:after {
            clear: both;
        }

    .navbar-nav > .tasks-menu > .dropdown-menu > li .menu > li > a {
        padding: 10px;
    }

        .navbar-nav > .tasks-menu > .dropdown-menu > li .menu > li > a > h3 {
            font-size: 14px;
            padding: 0;
            margin: 0 0 10px 0;
            color: var(--mu-texto-suave, #666666);
        }

        .navbar-nav > .tasks-menu > .dropdown-menu > li .menu > li > a > .progress {
            padding: 0;
            margin: 0;
        }

.navbar-nav > .user-menu > .dropdown-menu {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
    padding: 1px 0 0 0;
    border-top-width: 0;
    width: 280px;
}

    .navbar-nav > .user-menu > .dropdown-menu,
    .navbar-nav > .user-menu > .dropdown-menu > .user-body {
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
    }

        .navbar-nav > .user-menu > .dropdown-menu > li.user-header {
            height: 175px;
            padding: 10px;
            text-align: center;
        }

            .navbar-nav > .user-menu > .dropdown-menu > li.user-header > img {
                z-index: 5;
                height: 90px;
                width: 90px;
                border: 3px solid;
                border-color: transparent;
                border-color: rgba(255, 255, 255, 0.2);
            }

            .navbar-nav > .user-menu > .dropdown-menu > li.user-header > p {
                z-index: 5;
                color: #fff;
                color: rgba(255, 255, 255, 0.8);
                font-size: 17px;
                margin-top: 10px;
            }

                .navbar-nav > .user-menu > .dropdown-menu > li.user-header > p > small {
                    display: block;
                    font-size: 12px;
                }

        .navbar-nav > .user-menu > .dropdown-menu > .user-body {
            padding: 15px;
            border-bottom: 1px solid var(--mu-borda-sutil, #f4f4f4);
            border-top: 1px solid var(--mu-borda-media, #dddddd);
        }

            .navbar-nav > .user-menu > .dropdown-menu > .user-body:before,
            .navbar-nav > .user-menu > .dropdown-menu > .user-body:after {
                content: " ";
                display: table;
            }

            .navbar-nav > .user-menu > .dropdown-menu > .user-body:after {
                clear: both;
            }

            .navbar-nav > .user-menu > .dropdown-menu > .user-body a {
                color: var(--mu-texto, #444) !important;
            }

@media (max-width: 991px) {
    .navbar-nav > .user-menu > .dropdown-menu > .user-body a {
        background: var(--mu-superficie, #fff) !important;
        color: var(--mu-texto, #444) !important;
    }
}

.navbar-nav > .user-menu > .dropdown-menu > .user-footer {
    background-color: var(--mu-superficie-sutil, #f9f9f9);
    padding: 10px;
}

    .navbar-nav > .user-menu > .dropdown-menu > .user-footer:before,
    .navbar-nav > .user-menu > .dropdown-menu > .user-footer:after {
        content: " ";
        display: table;
    }

    .navbar-nav > .user-menu > .dropdown-menu > .user-footer:after {
        clear: both;
    }

    .navbar-nav > .user-menu > .dropdown-menu > .user-footer .btn-default {
        color: var(--mu-texto-suave, #666666);
    }

@media (max-width: 991px) {
    .navbar-nav > .user-menu > .dropdown-menu > .user-footer .btn-default:hover {
        background-color: var(--mu-superficie-sutil, #f9f9f9);
    }
}

.navbar-nav > .user-menu .user-image {
    float: left;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    margin-right: 10px;
    margin-top: -2px;
}

@media (max-width: 767px) {
    .navbar-nav > .user-menu .user-image {
        float: none;
        margin-right: 0;
        margin-top: -8px;
        line-height: 10px;
    }
}
/* Add fade animation to dropdown menus by appending
 the class .animated-dropdown-menu to the .dropdown-menu ul (or ol)*/
.open:not(.dropup) > .animated-dropdown-menu {
    backface-visibility: visible !important;
    -webkit-animation: flipInX 0.7s both;
    -o-animation: flipInX 0.7s both;
    animation: flipInX 0.7s both;
}

@keyframes flipInX {
    0% {
        transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
        transition-timing-function: ease-in;
        opacity: 0;
    }

    40% {
        transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
        transition-timing-function: ease-in;
    }

    60% {
        transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
        opacity: 1;
    }

    80% {
        transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
    }

    100% {
        transform: perspective(400px);
    }
}

@-webkit-keyframes flipInX {
    0% {
        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
        -webkit-transition-timing-function: ease-in;
        opacity: 0;
    }

    40% {
        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
        -webkit-transition-timing-function: ease-in;
    }

    60% {
        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
        opacity: 1;
    }

    80% {
        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
    }

    100% {
        -webkit-transform: perspective(400px);
    }
}
/* Fix dropdown menu in navbars */
.navbar-custom-menu > .navbar-nav > li {
    position: relative;
}

    .navbar-custom-menu > .navbar-nav > li > .dropdown-menu {
        position: absolute;
        right: 0;
        left: auto;
    }

@media (max-width: 991px) {
    .navbar-custom-menu > .navbar-nav {
        float: right;
    }

        .navbar-custom-menu > .navbar-nav > li {
            position: static;
        }

            .navbar-custom-menu > .navbar-nav > li > .dropdown-menu {
                position: absolute;
                right: 5%;
                left: auto;
                border: 1px solid var(--mu-borda-media, #ddd);
                background: var(--mu-superficie, #fff);
            }
}
/*
 * Component: Form
 * ---------------
 */
.form-control {
    border-radius: 0;
    box-shadow: none;
    border-color: var(--mu-borda-forte, #d2d6de);
}

    .form-control:focus {
        border-color: #3c8dbc;
        box-shadow: none;
    }

    .form-control::-moz-placeholder,
    .form-control:-ms-input-placeholder,
    .form-control::-webkit-input-placeholder {
        color: var(--mu-texto-desab, #bbb);
        opacity: 1;
    }

    .form-control:not(select) {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }

.form-group.has-success label {
    color: #00a65a;
}

.form-group.has-success .form-control,
.form-group.has-success .input-group-addon {
    border-color: #00a65a;
    box-shadow: none;
}

.form-group.has-success .help-block {
    color: #00a65a;
}

.form-group.has-warning label {
    color: #f39c12;
}

.form-group.has-warning .form-control,
.form-group.has-warning .input-group-addon {
    border-color: #f39c12;
    box-shadow: none;
}

.form-group.has-warning .help-block {
    color: #f39c12;
}

.form-group.has-error label {
    color: #dd4b39;
}

.form-group.has-error .form-control,
.form-group.has-error .input-group-addon {
    border-color: #dd4b39;
    box-shadow: none;
}

.form-group.has-error .help-block {
    color: #dd4b39;
}
/* Input group */
.input-group .input-group-addon {
    border-radius: 0;
    border-color: var(--mu-borda-forte, #d2d6de);
    background-color: var(--mu-superficie, #fff);
}
/* button groups */
.btn-group-vertical .btn.btn-flat:first-of-type,
.btn-group-vertical .btn.btn-flat:last-of-type {
    border-radius: 0;
}

.icheck > label {
    padding-left: 0;
}
/* support Font Awesome icons in form-control */
.form-control-feedback.fa {
    line-height: 34px;
}

.input-lg + .form-control-feedback.fa,
.input-group-lg + .form-control-feedback.fa,
.form-group-lg .form-control + .form-control-feedback.fa {
    line-height: 46px;
}

.input-sm + .form-control-feedback.fa,
.input-group-sm + .form-control-feedback.fa,
.form-group-sm .form-control + .form-control-feedback.fa {
    line-height: 30px;
}
/*
 * Component: Progress Bar
 * -----------------------
 */
.progress,
.progress > .progress-bar {
    -webkit-box-shadow: none;
    box-shadow: none;
}

    .progress,
    .progress > .progress-bar,
    .progress .progress-bar,
    .progress > .progress-bar .progress-bar {
        border-radius: 1px;
    }
        /* size variation */
        .progress.sm,
        .progress-sm {
            height: 10px;
        }

            .progress.sm,
            .progress-sm,
            .progress.sm .progress-bar,
            .progress-sm .progress-bar {
                border-radius: 1px;
            }

        .progress.xs,
        .progress-xs {
            height: 7px;
        }

            .progress.xs,
            .progress-xs,
            .progress.xs .progress-bar,
            .progress-xs .progress-bar {
                border-radius: 1px;
            }

        .progress.xxs,
        .progress-xxs {
            height: 3px;
        }

            .progress.xxs,
            .progress-xxs,
            .progress.xxs .progress-bar,
            .progress-xxs .progress-bar {
                border-radius: 1px;
            }
        /* Vertical bars */
        .progress.vertical {
            position: relative;
            width: 30px;
            height: 200px;
            display: inline-block;
            margin-right: 10px;
        }

            .progress.vertical > .progress-bar {
                width: 100%;
                position: absolute;
                bottom: 0;
            }

            .progress.vertical.sm,
            .progress.vertical.progress-sm {
                width: 20px;
            }

            .progress.vertical.xs,
            .progress.vertical.progress-xs {
                width: 10px;
            }

            .progress.vertical.xxs,
            .progress.vertical.progress-xxs {
                width: 3px;
            }

.progress-group .progress-text {
    font-weight: 600;
}

.progress-group .progress-number {
    float: right;
}
/* Remove margins from progress bars when put in a table */
.table tr > td .progress {
    margin: 0;
}

.progress-bar-light-blue,
.progress-bar-primary {
    background-color: #3c8dbc;
}

.progress-striped .progress-bar-light-blue,
.progress-striped .progress-bar-primary {
    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
}

.progress-bar-green,
.progress-bar-success {
    background-color: #00a65a;
}

.progress-striped .progress-bar-green,
.progress-striped .progress-bar-success {
    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
}

.progress-bar-aqua,
.progress-bar-info {
    background-color: #00c0ef;
}

.progress-striped .progress-bar-aqua,
.progress-striped .progress-bar-info {
    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
}

.progress-bar-yellow,
.progress-bar-warning {
    background-color: #f39c12;
}

.progress-striped .progress-bar-yellow,
.progress-striped .progress-bar-warning {
    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
}

.progress-bar-red,
.progress-bar-danger {
    background-color: #dd4b39;
}

.progress-striped .progress-bar-red,
.progress-striped .progress-bar-danger {
    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
}
/*
 * Component: Small Box
 * --------------------
 */
.small-box {
    border-radius: 2px;
    position: relative;
    display: block;
    margin-bottom: 20px;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}

    .small-box > .inner {
        padding: 10px;
    }

    .small-box > .small-box-footer {
        position: relative;
        text-align: center;
        padding: 3px 0;
        color: #fff;
        color: rgba(255, 255, 255, 0.8);
        display: block;
        z-index: 10;
        background: rgba(0, 0, 0, 0.1);
        text-decoration: none;
    }

        .small-box > .small-box-footer:hover {
            color: #fff;
            background: rgba(0, 0, 0, 0.15);
        }

    .small-box h3 {
        font-size: 38px;
        font-weight: bold;
        margin: 0 0 10px 0;
        white-space: nowrap;
        padding: 0;
    }

    .small-box p {
        font-size: 15px;
    }

        .small-box p > small {
            display: block;
            color: #f9f9f9;
            font-size: 13px;
            margin-top: 5px;
        }

    .small-box h3,
    .small-box p {
        z-index: 5;
    }

    .small-box .icon {
        -webkit-transition: all 0.3s linear;
        -o-transition: all 0.3s linear;
        transition: all 0.3s linear;
        position: absolute;
        top: -10px;
        right: 10px;
        z-index: 0;
        font-size: 90px;
        color: rgba(0, 0, 0, 0.15);
    }

    .small-box:hover {
        text-decoration: none;
        color: #f9f9f9;
    }

        .small-box:hover .icon {
            font-size: 95px;
        }

@media (max-width: 767px) {
    .small-box {
        text-align: center;
    }

        .small-box .icon {
            display: none;
        }

        .small-box p {
            font-size: 12px;
        }
}
/*
 * Component: Box
 * --------------
 */
.box {
    position: relative;
    border-radius: 3px;
    background: var(--mu-superficie, #ffffff);
    border-top: 3px solid var(--mu-borda-forte, #d2d6de);
    margin-bottom: 20px;
    width: 100%;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}

    .box.box-primary {
        border-top-color: #3c8dbc;
    }

    .box.box-info {
        border-top-color: #00c0ef;
    }

    .box.box-danger {
        border-top-color: #dd4b39;
    }

    .box.box-warning {
        border-top-color: #f39c12;
    }

    .box.box-success {
        border-top-color: #00a65a;
    }

    .box.box-default {
        border-top-color: var(--mu-borda-forte, #d2d6de);
    }

    .box.collapsed-box .box-body,
    .box.collapsed-box .box-footer {
        display: none;
    }

    .box .nav-stacked > li {
        border-bottom: 1px solid var(--mu-borda-sutil, #f4f4f4);
        margin: 0;
    }

        .box .nav-stacked > li:last-of-type {
            border-bottom: none;
        }

    .box.height-control .box-body {
        max-height: 300px;
        overflow: auto;
    }

    .box .border-right {
        border-right: 1px solid var(--mu-borda-sutil, #f4f4f4);
    }

    .box .border-left {
        border-left: 1px solid var(--mu-borda-sutil, #f4f4f4);
    }

    .box.box-solid {
        border-top: 0;
    }

        .box.box-solid > .box-header .btn.btn-default {
            background: transparent;
        }

        .box.box-solid > .box-header .btn:hover,
        .box.box-solid > .box-header a:hover {
            background: rgba(0, 0, 0, 0.1);
        }

        .box.box-solid.box-default {
            border: 1px solid var(--mu-borda-forte, #d2d6de);
        }

            .box.box-solid.box-default > .box-header {
                color: var(--mu-texto, #444444);
                background: var(--mu-superficie-forte, #d2d6de);
                background-color: var(--mu-superficie-forte, #d2d6de);
            }

                .box.box-solid.box-default > .box-header a,
                .box.box-solid.box-default > .box-header .btn {
                    color: var(--mu-texto, #444444);
                }

        .box.box-solid.box-primary {
            border: 1px solid #3c8dbc;
        }

            .box.box-solid.box-primary > .box-header {
                color: #ffffff;
                background: #3c8dbc;
                background-color: #3c8dbc;
            }

                .box.box-solid.box-primary > .box-header a,
                .box.box-solid.box-primary > .box-header .btn {
                    color: #ffffff;
                }

        .box.box-solid.box-info {
            border: 1px solid #00c0ef;
        }

            .box.box-solid.box-info > .box-header {
                color: #ffffff;
                background: #00c0ef;
                background-color: #00c0ef;
            }

                .box.box-solid.box-info > .box-header a,
                .box.box-solid.box-info > .box-header .btn {
                    color: #ffffff;
                }

        .box.box-solid.box-danger {
            border: 1px solid #dd4b39;
        }

            .box.box-solid.box-danger > .box-header {
                color: #ffffff;
                background: #dd4b39;
                background-color: #dd4b39;
            }

                .box.box-solid.box-danger > .box-header a,
                .box.box-solid.box-danger > .box-header .btn {
                    color: #ffffff;
                }

        .box.box-solid.box-warning {
            border: 1px solid #f39c12;
        }

            .box.box-solid.box-warning > .box-header {
                color: #ffffff;
                background: #f39c12;
                background-color: #f39c12;
            }

                .box.box-solid.box-warning > .box-header a,
                .box.box-solid.box-warning > .box-header .btn {
                    color: #ffffff;
                }

        .box.box-solid.box-success {
            border: 1px solid #00a65a;
        }

            .box.box-solid.box-success > .box-header {
                color: #ffffff;
                background: #00a65a;
                background-color: #00a65a;
            }

                .box.box-solid.box-success > .box-header a,
                .box.box-solid.box-success > .box-header .btn {
                    color: #ffffff;
                }

        .box.box-solid > .box-header > .box-tools .btn {
            border: 0;
            box-shadow: none;
        }

        .box.box-solid[class*='bg'] > .box-header {
            color: #fff;
        }

    .box .box-group > .box {
        margin-bottom: 5px;
    }

    .box .knob-label {
        text-align: center;
        color: var(--mu-texto, #333);
        font-weight: 100;
        font-size: 12px;
        margin-bottom: 0.3em;
    }

    .box > .overlay,
    .overlay-wrapper > .overlay,
    .box > .loading-img,
    .overlay-wrapper > .loading-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .box .overlay,
    .overlay-wrapper .overlay {
        z-index: 50;
        background: rgba(255, 255, 255, 0.7);
        border-radius: 3px;
    }

        .box .overlay > .fa,
        .overlay-wrapper .overlay > .fa {
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -15px;
            margin-top: -15px;
            color: var(--mu-texto, #000);
            font-size: 30px;
        }

        .box .overlay.dark,
        .overlay-wrapper .overlay.dark {
            background: rgba(0, 0, 0, 0.5);
        }

.box-header:before,
.box-body:before,
.box-footer:before,
.box-header:after,
.box-body:after,
.box-footer:after {
    content: " ";
    display: table;
}

.box-header:after,
.box-body:after,
.box-footer:after {
    clear: both;
}

.box-header {
    color: var(--mu-texto, #444);
    display: block;
    padding: 10px;
    position: relative;
}

    .box-header.with-border {
        border-bottom: 1px solid var(--mu-borda-sutil, #f4f4f4);
    }

.collapsed-box .box-header.with-border {
    border-bottom: none;
}

.box-header > .fa,
.box-header > .glyphicon,
.box-header > .ion,
.box-header .box-title {
    display: inline-block;
    font-size: 18px;
    margin: 0;
    line-height: 1;
}

.box-header > .fa,
.box-header > .glyphicon,
.box-header > .ion {
    margin-right: 5px;
}

.box-header > .box-tools {
    position: absolute;
    right: 10px;
    top: 5px;
}

    .box-header > .box-tools [data-toggle="tooltip"] {
        position: relative;
    }

    .box-header > .box-tools.pull-right .dropdown-menu {
        right: 0;
        left: auto;
    }

    .box-header > .box-tools .dropdown-menu > li > a {
        color: var(--mu-texto, #444) !important;
    }

.btn-box-tool {
    padding: 5px;
    font-size: 12px;
    background: transparent;
    color: #97a0b3;
}

    .open .btn-box-tool,
    .btn-box-tool:hover {
        color: #606c84;
    }

    .btn-box-tool.btn:active {
        box-shadow: none;
    }

.box-body {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 3px;
    border-bottom-left-radius: 3px;
    padding: 10px;
}

.no-header .box-body {
    border-top-right-radius: 3px;
    border-top-left-radius: 3px;
}

.box-body > .table {
    margin-bottom: 0;
}

.box-body .fc {
    margin-top: 5px;
}

.box-body .full-width-chart {
    margin: -19px;
}

.box-body.no-padding .full-width-chart {
    margin: -9px;
}

.box-body .box-pane {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 3px;
}

.box-body .box-pane-right {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 3px;
    border-bottom-left-radius: 0;
}

.box-footer {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 3px;
    border-bottom-left-radius: 3px;
    border-top: 1px solid var(--mu-borda-sutil, #f4f4f4);
    padding: 10px;
    background-color: var(--mu-superficie, #ffffff);
}

.chart-legend {
    margin: 10px 0;
}

@media (max-width: 991px) {
    .chart-legend > li {
        float: left;
        margin-right: 10px;
    }
}

.box-comments {
    background: var(--mu-superficie-sutil, #f7f7f7);
}

    .box-comments .box-comment {
        padding: 8px 0;
        border-bottom: 1px solid var(--mu-borda-sutil, #eee);
    }

        .box-comments .box-comment:before,
        .box-comments .box-comment:after {
            content: " ";
            display: table;
        }

        .box-comments .box-comment:after {
            clear: both;
        }

        .box-comments .box-comment:last-of-type {
            border-bottom: 0;
        }

        .box-comments .box-comment:first-of-type {
            padding-top: 0;
        }

        .box-comments .box-comment img {
            float: left;
        }

    .box-comments .comment-text {
        margin-left: 40px;
        color: var(--mu-texto-suave, #555);
    }

    .box-comments .username {
        color: var(--mu-texto, #444);
        display: block;
        font-weight: 600;
    }

    .box-comments .text-muted {
        font-weight: 400;
        font-size: 12px;
    }
/* Widget: TODO LIST */
.todo-list {
    margin: 0;
    padding: 0;
    list-style: none;
    overflow: auto;
}

    .todo-list > li {
        border-radius: 2px;
        padding: 10px;
        background: var(--mu-superficie-sutil, #f4f4f4);
        margin-bottom: 2px;
        border-left: 2px solid #e6e7e8;
        color: var(--mu-texto, #444);
    }

        .todo-list > li:last-of-type {
            margin-bottom: 0;
        }

        .todo-list > li > input[type='checkbox'] {
            margin: 0 10px 0 5px;
        }

        .todo-list > li .text {
            display: inline-block;
            margin-left: 5px;
            font-weight: 600;
        }

        .todo-list > li .label {
            margin-left: 10px;
            font-size: 9px;
        }

        .todo-list > li .tools {
            display: none;
            float: right;
            color: #dd4b39;
        }

            .todo-list > li .tools > .fa,
            .todo-list > li .tools > .glyphicon,
            .todo-list > li .tools > .ion {
                margin-right: 5px;
                cursor: pointer;
            }

        .todo-list > li:hover .tools {
            display: inline-block;
        }

        .todo-list > li.done {
            color: var(--mu-texto-suave, #999);
        }

            .todo-list > li.done .text {
                text-decoration: line-through;
                font-weight: 500;
            }

            .todo-list > li.done .label {
                background: var(--mu-superficie-forte, #d2d6de) !important;
            }

    .todo-list .danger {
        border-left-color: #dd4b39;
    }

    .todo-list .warning {
        border-left-color: #f39c12;
    }

    .todo-list .info {
        border-left-color: #00c0ef;
    }

    .todo-list .success {
        border-left-color: #00a65a;
    }

    .todo-list .primary {
        border-left-color: #3c8dbc;
    }

    .todo-list .handle {
        display: inline-block;
        cursor: move;
        margin: 0 5px;
    }
/* Chat widget (DEPRECATED - this will be removed in the next major release. Use Direct Chat instead)*/
.chat {
    padding: 5px 20px 5px 10px;
}

    .chat .item {
        margin-bottom: 10px;
    }

        .chat .item:before,
        .chat .item:after {
            content: " ";
            display: table;
        }

        .chat .item:after {
            clear: both;
        }

        .chat .item > img {
            width: 40px;
            height: 40px;
            border: 2px solid transparent;
            border-radius: 50%;
        }

        .chat .item > .online {
            border: 2px solid #00a65a;
        }

        .chat .item > .offline {
            border: 2px solid #dd4b39;
        }

        .chat .item > .message {
            margin-left: 55px;
            margin-top: -40px;
        }

            .chat .item > .message > .name {
                display: block;
                font-weight: 600;
            }

        .chat .item > .attachment {
            border-radius: 3px;
            background: var(--mu-superficie-sutil, #f4f4f4);
            margin-left: 65px;
            margin-right: 15px;
            padding: 10px;
        }

            .chat .item > .attachment > h4 {
                margin: 0 0 5px 0;
                font-weight: 600;
                font-size: 14px;
            }

            .chat .item > .attachment > p,
            .chat .item > .attachment > .filename {
                font-weight: 600;
                font-size: 13px;
                font-style: italic;
                margin: 0;
            }

            .chat .item > .attachment:before,
            .chat .item > .attachment:after {
                content: " ";
                display: table;
            }

            .chat .item > .attachment:after {
                clear: both;
            }

.box-input {
    max-width: 200px;
}

.modal .panel-body {
    color: var(--mu-texto, #444);
}
/*
 * Component: Info Box
 * -------------------
 */
.info-box {
    display: block;
    min-height: 90px;
    background: var(--mu-superficie, #fff);
    width: 100%;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    margin-bottom: 15px;
}

    .info-box small {
        font-size: 14px;
    }

    .info-box .progress {
        background: rgba(0, 0, 0, 0.2);
        margin: 5px -10px 5px -10px;
        height: 2px;
    }

        .info-box .progress,
        .info-box .progress .progress-bar {
            border-radius: 0;
        }

            .info-box .progress .progress-bar {
                background: var(--mu-superficie, #fff);
            }

.info-box-icon {
    border-top-left-radius: 2px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 2px;
    display: block;
    float: left;
    height: 90px;
    width: 90px;
    text-align: center;
    font-size: 45px;
    line-height: 90px;
    background: rgba(0, 0, 0, 0.2);
}

    .info-box-icon > img {
        max-width: 100%;
    }

.info-box-content {
    padding: 5px 10px;
    margin-left: 90px;
}

.info-box-number {
    display: block;
    font-weight: bold;
    font-size: 18px;
}

.progress-description,
.info-box-text {
    display: block;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.info-box-text {
    text-transform: uppercase;
}

.info-box-more {
    display: block;
}

.progress-description {
    margin: 0;
}
/*
 * Component: Timeline
 * -------------------
 */
.timeline {
    position: relative;
    margin: 0 0 30px 0;
    padding: 0;
    list-style: none;
}

    .timeline:before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        width: 4px;
        background: var(--mu-superficie-forte, #ddd);
        left: 31px;
        margin: 0;
        border-radius: 2px;
    }

    .timeline > li {
        position: relative;
        margin-right: 10px;
        margin-bottom: 15px;
    }

        .timeline > li:before,
        .timeline > li:after {
            content: " ";
            display: table;
        }

        .timeline > li:after {
            clear: both;
        }

        .timeline > li > .timeline-item {
            -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
            box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
            border-radius: 3px;
            margin-top: 0;
            background: var(--mu-superficie, #fff);
            color: var(--mu-texto, #444);
            margin-left: 60px;
            margin-right: 15px;
            padding: 0;
            position: relative;
        }

            .timeline > li > .timeline-item > .time {
                color: var(--mu-texto-suave, #999);
                float: right;
                padding: 10px;
                font-size: 12px;
            }

            .timeline > li > .timeline-item > .timeline-header {
                margin: 0;
                color: var(--mu-texto-suave, #555);
                border-bottom: 1px solid var(--mu-borda-sutil, #f4f4f4);
                padding: 10px;
                font-size: 16px;
                line-height: 1.1;
            }

                .timeline > li > .timeline-item > .timeline-header > a {
                    font-weight: 600;
                }

            .timeline > li > .timeline-item > .timeline-body,
            .timeline > li > .timeline-item > .timeline-footer {
                padding: 10px;
            }

        .timeline > li > .fa,
        .timeline > li > .glyphicon,
        .timeline > li > .ion {
            width: 30px;
            height: 30px;
            font-size: 15px;
            line-height: 30px;
            position: absolute;
            color: var(--mu-texto-suave, #666);
            background: var(--mu-superficie-forte, #d2d6de);
            border-radius: 50%;
            text-align: center;
            left: 18px;
            top: 0;
        }

    .timeline > .time-label > span {
        font-weight: 600;
        padding: 5px;
        display: inline-block;
        background-color: var(--mu-superficie, #fff);
        border-radius: 4px;
    }

.timeline-inverse > li > .timeline-item {
    background: var(--mu-superficie-sutil, #f0f0f0);
    border: 1px solid var(--mu-borda-media, #ddd);
    -webkit-box-shadow: none;
    box-shadow: none;
}

    .timeline-inverse > li > .timeline-item > .timeline-header {
        border-bottom-color: var(--mu-borda-media, #ddd);
    }
/*
 * Component: Button
 * -----------------
 */
.btn {
    border-radius: 3px;
    -webkit-box-shadow: none;
    box-shadow: none;
    border: 1px solid transparent;
}

    .btn.uppercase {
        text-transform: uppercase;
    }

    .btn.btn-flat {
        border-radius: 0;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
        border-width: 1px;
    }

    .btn:active {
        -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        -moz-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    }

    .btn:focus {
        outline: none;
    }

    .btn.btn-file {
        position: relative;
        overflow: hidden;
    }

        .btn.btn-file > input[type='file'] {
            position: absolute;
            top: 0;
            right: 0;
            min-width: 100%;
            min-height: 100%;
            font-size: 100px;
            text-align: right;
            opacity: 0;
            filter: alpha(opacity=0);
            outline: none;
            background: var(--mu-superficie, white);
            cursor: inherit;
            display: block;
        }

.btn-default {
    background-color: var(--mu-superficie-sutil, #f4f4f4);
    color: var(--mu-texto, #444);
    border-color: var(--mu-borda-media, #ddd);
}

    .btn-default:hover,
    .btn-default:active,
    .btn-default.hover {
        background-color: var(--mu-superficie-sutil, #e7e7e7);
    }

.btn-primary {
    background-color: #3c8dbc;
    border-color: #367fa9;
}

    .btn-primary:hover,
    .btn-primary:active,
    .btn-primary.hover {
        background-color: #367fa9;
    }

.btn-success {
    background-color: #00a65a;
    border-color: #008d4c;
}

    .btn-success:hover,
    .btn-success:active,
    .btn-success.hover {
        background-color: #008d4c;
    }

.btn-info {
    background-color: #00c0ef;
    border-color: #00acd6;
}

    .btn-info:hover,
    .btn-info:active,
    .btn-info.hover {
        background-color: #00acd6;
    }

.btn-danger {
    background-color: #dd4b39;
    border-color: #d73925;
}

    .btn-danger:hover,
    .btn-danger:active,
    .btn-danger.hover {
        background-color: #d73925;
    }

.btn-warning {
    background-color: #f39c12;
    border-color: #e08e0b;
}

    .btn-warning:hover,
    .btn-warning:active,
    .btn-warning.hover {
        background-color: #e08e0b;
    }

.btn-outline {
    border: 1px solid #fff;
    background: transparent;
    color: #fff;
}

    .btn-outline:hover,
    .btn-outline:focus,
    .btn-outline:active {
        color: rgba(255, 255, 255, 0.7);
        border-color: rgba(255, 255, 255, 0.7);
    }

.btn-link {
    -webkit-box-shadow: none;
    box-shadow: none;
}

.btn[class*='bg-']:hover {
    -webkit-box-shadow: inset 0 0 100px rgba(0, 0, 0, 0.2);
    box-shadow: inset 0 0 100px rgba(0, 0, 0, 0.2);
}

.btn-app {
    border-radius: 3px;
    position: relative;
    padding: 15px 5px;
    margin: 0 0 10px 10px;
    min-width: 80px;
    height: 60px;
    text-align: center;
    color: var(--mu-texto-suave, #666);
    border: 1px solid var(--mu-borda-media, #ddd);
    background-color: var(--mu-superficie-sutil, #f4f4f4);
    font-size: 12px;
}

    .btn-app > .fa,
    .btn-app > .glyphicon,
    .btn-app > .ion {
        font-size: 20px;
        display: block;
    }

    .btn-app:hover {
        background: var(--mu-superficie-sutil, #f4f4f4);
        color: var(--mu-texto, #444);
        border-color: #aaa;
    }

    .btn-app:active,
    .btn-app:focus {
        -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        -moz-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    }

    .btn-app > .badge {
        position: absolute;
        top: -3px;
        right: -10px;
        font-size: 10px;
        font-weight: 400;
    }
/*
 * Component: Callout
 * ------------------
 */
.callout {
    border-radius: 3px;
    margin: 0 0 20px 0;
    padding: 15px 30px 15px 15px;
    border-left: 5px solid var(--mu-borda-sutil, #eee);
}

    .callout a {
        color: #fff;
        text-decoration: underline;
    }

        .callout a:hover {
            color: #eee;
        }

    .callout h4 {
        margin-top: 0;
        font-weight: 600;
    }

    .callout p:last-child {
        margin-bottom: 0;
    }

    .callout code,
    .callout .highlight {
        background-color: var(--mu-superficie, #fff);
    }

    .callout.callout-danger {
        border-color: #c23321;
    }

    .callout.callout-warning {
        border-color: #c87f0a;
    }

    .callout.callout-info {
        border-color: #0097bc;
    }

    .callout.callout-success {
        border-color: #00733e;
    }
/*
 * Component: alert
 * ----------------
 */
.alert {
    border-radius: 3px;
}

    .alert h4 {
        font-weight: 600;
    }

    .alert .icon {
        margin-right: 10px;
    }

    .alert .close {
        color: var(--mu-texto, #000);
        opacity: 0.2;
        filter: alpha(opacity=20);
    }

        .alert .close:hover {
            opacity: 0.5;
            filter: alpha(opacity=50);
        }

    .alert a {
        color: #fff;
        text-decoration: underline;
    }

.alert-success {
    border-color: #008d4c;
}

.alert-danger,
.alert-error {
    border-color: #d73925;
}

.alert-warning {
    border-color: #e08e0b;
}

.alert-info {
    border-color: #00acd6;
}
/*
 * Component: Nav
 * --------------
 */
.nav > li > a:hover,
.nav > li > a:active,
.nav > li > a:focus {
    color: var(--mu-texto, #444);
    background: var(--mu-superficie-sutil, #f7f7f7);
}
/* NAV PILLS */
.nav-pills > li > a {
    border-radius: 0;
    border-top: 3px solid transparent;
    color: var(--mu-texto, #444);
}

    .nav-pills > li > a > .fa,
    .nav-pills > li > a > .glyphicon,
    .nav-pills > li > a > .ion {
        margin-right: 5px;
    }

.nav-pills > li.active > a,
.nav-pills > li.active > a:hover,
.nav-pills > li.active > a:focus {
    border-top-color: #3c8dbc;
}

.nav-pills > li.active > a {
    font-weight: 600;
}
/* NAV STACKED */
.nav-stacked > li > a {
    border-radius: 0;
    border-top: 0;
    border-left: 3px solid transparent;
    color: var(--mu-texto, #444);
}

.nav-stacked > li.active > a,
.nav-stacked > li.active > a:hover {
    background: transparent;
    color: var(--mu-texto, #444);
    border-top: 0;
    border-left-color: #3c8dbc;
}

.nav-stacked > li.header {
    border-bottom: 1px solid var(--mu-borda-media, #ddd);
    color: var(--mu-texto-suave, #777);
    margin-bottom: 10px;
    padding: 5px 10px;
    text-transform: uppercase;
}
/* NAV TABS */
.nav-tabs-custom {
    margin-bottom: 20px;
    background: var(--mu-superficie, #fff);
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
}

    .nav-tabs-custom > .nav-tabs {
        margin: 0;
        border-bottom-color: var(--mu-borda-sutil, #f4f4f4);
        border-top-right-radius: 3px;
        border-top-left-radius: 3px;
    }

        .nav-tabs-custom > .nav-tabs > li {
            border-top: 3px solid transparent;
            margin-bottom: -2px;
            margin-right: 5px;
        }

            .nav-tabs-custom > .nav-tabs > li.disabled > a {
                color: var(--mu-texto-suave, #777);
            }

            .nav-tabs-custom > .nav-tabs > li > a {
                color: var(--mu-texto, #444);
                border-radius: 0;
            }

                .nav-tabs-custom > .nav-tabs > li > a.text-muted {
                    color: var(--mu-texto-suave, #999);
                }

                .nav-tabs-custom > .nav-tabs > li > a,
                .nav-tabs-custom > .nav-tabs > li > a:hover {
                    background: transparent;
                    margin: 0;
                }

                    .nav-tabs-custom > .nav-tabs > li > a:hover {
                        color: var(--mu-texto-suave, #999);
                    }

            .nav-tabs-custom > .nav-tabs > li:not(.active) > a:hover,
            .nav-tabs-custom > .nav-tabs > li:not(.active) > a:focus,
            .nav-tabs-custom > .nav-tabs > li:not(.active) > a:active {
                border-color: transparent;
            }

            .nav-tabs-custom > .nav-tabs > li.active {
                border-top-color: #3c8dbc;
            }

                .nav-tabs-custom > .nav-tabs > li.active > a,
                .nav-tabs-custom > .nav-tabs > li.active:hover > a {
                    background-color: var(--mu-superficie, #fff);
                    color: var(--mu-texto, #444);
                }

                .nav-tabs-custom > .nav-tabs > li.active > a {
                    border-top-color: transparent;
                    border-left-color: var(--mu-borda-sutil, #f4f4f4);
                    border-right-color: var(--mu-borda-sutil, #f4f4f4);
                }

            .nav-tabs-custom > .nav-tabs > li:first-of-type {
                margin-left: 0;
            }

                .nav-tabs-custom > .nav-tabs > li:first-of-type.active > a {
                    border-left-color: transparent;
                }

        .nav-tabs-custom > .nav-tabs.pull-right {
            float: none !important;
        }

            .nav-tabs-custom > .nav-tabs.pull-right > li {
                float: right;
            }

                .nav-tabs-custom > .nav-tabs.pull-right > li:first-of-type {
                    margin-right: 0;
                }

                    .nav-tabs-custom > .nav-tabs.pull-right > li:first-of-type > a {
                        border-left-width: 1px;
                    }

                    .nav-tabs-custom > .nav-tabs.pull-right > li:first-of-type.active > a {
                        border-left-color: var(--mu-borda-sutil, #f4f4f4);
                        border-right-color: transparent;
                    }

        .nav-tabs-custom > .nav-tabs > li.header {
            line-height: 35px;
            padding: 0 10px;
            font-size: 20px;
            color: var(--mu-texto, #444);
        }

            .nav-tabs-custom > .nav-tabs > li.header > .fa,
            .nav-tabs-custom > .nav-tabs > li.header > .glyphicon,
            .nav-tabs-custom > .nav-tabs > li.header > .ion {
                margin-right: 5px;
            }

    .nav-tabs-custom > .tab-content {
        background: var(--mu-superficie, #fff);
        padding: 10px;
        border-bottom-right-radius: 3px;
        border-bottom-left-radius: 3px;
    }

    .nav-tabs-custom .dropdown.open > a:active,
    .nav-tabs-custom .dropdown.open > a:focus {
        background: transparent;
        color: var(--mu-texto-suave, #999);
    }

    .nav-tabs-custom.tab-primary > .nav-tabs > li.active {
        border-top-color: #3c8dbc;
    }

    .nav-tabs-custom.tab-info > .nav-tabs > li.active {
        border-top-color: #00c0ef;
    }

    .nav-tabs-custom.tab-danger > .nav-tabs > li.active {
        border-top-color: #dd4b39;
    }

    .nav-tabs-custom.tab-warning > .nav-tabs > li.active {
        border-top-color: #f39c12;
    }

    .nav-tabs-custom.tab-success > .nav-tabs > li.active {
        border-top-color: #00a65a;
    }

    .nav-tabs-custom.tab-default > .nav-tabs > li.active {
        border-top-color: var(--mu-borda-forte, #d2d6de);
    }
/* PAGINATION */
.pagination > li > a {
    background: var(--mu-superficie-sutil, #fafafa);
    color: var(--mu-texto-suave, #666);
}

.pagination.pagination-flat > li > a {
    border-radius: 0 !important;
}
/*
 * Component: Products List
 * ------------------------
 */
.products-list {
    list-style: none;
    margin: 0;
    padding: 0;
}

    .products-list > .item {
        border-radius: 3px;
        -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
        padding: 10px 0;
        background: var(--mu-superficie, #fff);
    }

        .products-list > .item:before,
        .products-list > .item:after {
            content: " ";
            display: table;
        }

        .products-list > .item:after {
            clear: both;
        }

    .products-list .product-img {
        float: left;
    }

        .products-list .product-img img {
            width: 50px;
            height: 50px;
        }

    .products-list .product-info {
        margin-left: 60px;
    }

    .products-list .product-title {
        font-weight: 600;
    }

    .products-list .product-description {
        display: block;
        color: var(--mu-texto-suave, #999);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

.product-list-in-box > .item {
    -webkit-box-shadow: none;
    box-shadow: none;
    border-radius: 0;
    border-bottom: 1px solid var(--mu-borda-sutil, #f4f4f4);
}

    .product-list-in-box > .item:last-of-type {
        border-bottom-width: 0;
    }
/*
 * Component: Table
 * ----------------
 */
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
    border-top: 1px solid var(--mu-borda-sutil, #f4f4f4);
}

.table > thead > tr > th {
    border-bottom: 2px solid var(--mu-borda-sutil, #f4f4f4);
}

.table tr td .progress {
    margin-top: 5px;
}

.table-bordered {
    border: 1px solid var(--mu-borda-sutil, #f4f4f4);
}

    .table-bordered > thead > tr > th,
    .table-bordered > tbody > tr > th,
    .table-bordered > tfoot > tr > th,
    .table-bordered > thead > tr > td,
    .table-bordered > tbody > tr > td,
    .table-bordered > tfoot > tr > td {
        border: 1px solid var(--mu-borda-sutil, #f4f4f4);
    }

    .table-bordered > thead > tr > th,
    .table-bordered > thead > tr > td {
        border-bottom-width: 2px;
    }

.table.no-border,
.table.no-border td,
.table.no-border th {
    border: 0;
}
/* .text-center in tables */
table.text-center,
table.text-center td,
table.text-center th {
    text-align: center;
}

.table.align th {
    text-align: left;
}

.table.align td {
    text-align: right;
}
/*
 * Component: Label
 * ----------------
 */
.label-default {
    background-color: var(--mu-superficie-forte, #d2d6de);
    color: var(--mu-texto, #444);
}
/*
 * Component: Direct Chat
 * ----------------------
 */
.direct-chat .box-body {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    position: relative;
    overflow-x: hidden;
    padding: 0;
}

.direct-chat.chat-pane-open .direct-chat-contacts {
    -webkit-transform: translate(0, 0);
    -ms-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
}

.direct-chat-messages {
    -webkit-transform: translate(0, 0);
    -ms-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
    padding: 10px;
    height: 250px;
    overflow: auto;
}

.direct-chat-msg,
.direct-chat-text {
    display: block;
}

.direct-chat-msg {
    margin-bottom: 10px;
}

    .direct-chat-msg:before,
    .direct-chat-msg:after {
        content: " ";
        display: table;
    }

    .direct-chat-msg:after {
        clear: both;
    }

.direct-chat-messages,
.direct-chat-contacts {
    -webkit-transition: -webkit-transform 0.5s ease-in-out;
    -moz-transition: -moz-transform 0.5s ease-in-out;
    -o-transition: -o-transform 0.5s ease-in-out;
    transition: transform 0.5s ease-in-out;
}

.direct-chat-text {
    border-radius: 5px;
    position: relative;
    padding: 5px 10px;
    background: var(--mu-superficie-forte, #d2d6de);
    border: 1px solid var(--mu-borda-forte, #d2d6de);
    margin: 5px 0 0 50px;
    color: var(--mu-texto, #444444);
}

    .direct-chat-text:after,
    .direct-chat-text:before {
        position: absolute;
        right: 100%;
        top: 15px;
        border: solid transparent;
        border-right-color: var(--mu-borda-forte, #d2d6de);
        content: ' ';
        height: 0;
        width: 0;
        pointer-events: none;
    }

    .direct-chat-text:after {
        border-width: 5px;
        margin-top: -5px;
    }

    .direct-chat-text:before {
        border-width: 6px;
        margin-top: -6px;
    }

.right .direct-chat-text {
    margin-right: 50px;
    margin-left: 0;
}

    .right .direct-chat-text:after,
    .right .direct-chat-text:before {
        right: auto;
        left: 100%;
        border-right-color: transparent;
        border-left-color: var(--mu-borda-forte, #d2d6de);
    }

.direct-chat-img {
    border-radius: 50%;
    float: left;
    width: 40px;
    height: 40px;
}

.right .direct-chat-img {
    float: right;
}

.direct-chat-info {
    display: block;
    margin-bottom: 2px;
    font-size: 12px;
}

.direct-chat-name {
    font-weight: 600;
}

.direct-chat-timestamp {
    color: var(--mu-texto-suave, #999);
}

.direct-chat-contacts-open .direct-chat-contacts {
    -webkit-transform: translate(0, 0);
    -ms-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
}

.direct-chat-contacts {
    -webkit-transform: translate(101%, 0);
    -ms-transform: translate(101%, 0);
    -o-transform: translate(101%, 0);
    transform: translate(101%, 0);
    position: absolute;
    top: 0;
    bottom: 0;
    height: 250px;
    width: 100%;
    background: #222d32;
    color: #fff;
    overflow: auto;
}

.contacts-list > li {
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    padding: 10px;
    margin: 0;
}

    .contacts-list > li:before,
    .contacts-list > li:after {
        content: " ";
        display: table;
    }

    .contacts-list > li:after {
        clear: both;
    }

    .contacts-list > li:last-of-type {
        border-bottom: none;
    }

.contacts-list-img {
    border-radius: 50%;
    width: 40px;
    float: left;
}

.contacts-list-info {
    margin-left: 45px;
    color: #fff;
}

.contacts-list-name,
.contacts-list-status {
    display: block;
}

.contacts-list-name {
    font-weight: 600;
}

.contacts-list-status {
    font-size: 12px;
}

.contacts-list-date {
    color: #aaa;
    font-weight: normal;
}

.contacts-list-msg {
    color: var(--mu-texto-suave, #999);
}

.direct-chat-danger .right > .direct-chat-text {
    background: #dd4b39;
    border-color: #dd4b39;
    color: #ffffff;
}

    .direct-chat-danger .right > .direct-chat-text:after,
    .direct-chat-danger .right > .direct-chat-text:before {
        border-left-color: #dd4b39;
    }

.direct-chat-primary .right > .direct-chat-text {
    background: #3c8dbc;
    border-color: #3c8dbc;
    color: #ffffff;
}

    .direct-chat-primary .right > .direct-chat-text:after,
    .direct-chat-primary .right > .direct-chat-text:before {
        border-left-color: #3c8dbc;
    }

.direct-chat-warning .right > .direct-chat-text {
    background: #f39c12;
    border-color: #f39c12;
    color: #ffffff;
}

    .direct-chat-warning .right > .direct-chat-text:after,
    .direct-chat-warning .right > .direct-chat-text:before {
        border-left-color: #f39c12;
    }

.direct-chat-info .right > .direct-chat-text {
    background: #00c0ef;
    border-color: #00c0ef;
    color: #ffffff;
}

    .direct-chat-info .right > .direct-chat-text:after,
    .direct-chat-info .right > .direct-chat-text:before {
        border-left-color: #00c0ef;
    }

.direct-chat-success .right > .direct-chat-text {
    background: #00a65a;
    border-color: #00a65a;
    color: #ffffff;
}

    .direct-chat-success .right > .direct-chat-text:after,
    .direct-chat-success .right > .direct-chat-text:before {
        border-left-color: #00a65a;
    }
/*
 * Component: Users List
 * ---------------------
 */
.users-list > li {
    width: 25%;
    float: left;
    padding: 10px;
    text-align: center;
}

    .users-list > li img {
        border-radius: 50%;
        max-width: 100%;
        height: auto;
    }

    .users-list > li > a:hover,
    .users-list > li > a:hover .users-list-name {
        color: var(--mu-texto-suave, #999);
    }

.users-list-name,
.users-list-date {
    display: block;
}

.users-list-name {
    font-weight: 600;
    color: var(--mu-texto, #444);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.users-list-date {
    color: var(--mu-texto-suave, #999);
    font-size: 12px;
}
/*
 * Component: Carousel
 * -------------------
 */
.carousel-control.left,
.carousel-control.right {
    background-image: none;
}

.carousel-control > .fa {
    font-size: 40px;
    position: absolute;
    top: 50%;
    z-index: 5;
    display: inline-block;
    margin-top: -20px;
}
/*
 * Component: modal
 * ----------------
 */
.modal {
    background: rgba(0, 0, 0, 0.3);
}

.modal-content {
    border-radius: 5px;
    -webkit-box-shadow: 0 2px 3px rgba(0, 0, 0, 0.125);
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.125);
    border: 0;
}

@media (min-width: 768px) {
    .modal-content {
        -webkit-box-shadow: 0 2px 3px rgba(0, 0, 0, 0.125);
        box-shadow: 0 2px 3px rgba(0, 0, 0, 0.125);
    }
}

.modal-header {
    border-bottom-color: var(--mu-borda-sutil, #f4f4f4);
}

.modal-footer {
    border-top-color: var(--mu-borda-sutil, #f4f4f4);
}

.modal-primary .modal-header,
.modal-primary .modal-footer {
    border-color: #307095;
}

.modal-warning .modal-header,
.modal-warning .modal-footer {
    border-color: #c87f0a;
}

.modal-info .modal-header,
.modal-info .modal-footer {
    border-color: #0097bc;
}

.modal-success .modal-header,
.modal-success .modal-footer {
    border-color: #00733e;
}

.modal-danger .modal-header,
.modal-danger .modal-footer {
    border-color: #c23321;
}
/*
 * Component: Social Widgets
 * -------------------------
 */
.box-widget {
    border: none;
    position: relative;
}

.widget-user .widget-user-header {
    padding: 20px;
    height: 120px;
    border-top-right-radius: 3px;
    border-top-left-radius: 3px;
}

.widget-user .widget-user-username {
    margin-top: 0;
    margin-bottom: 5px;
    font-size: 25px;
    font-weight: 300;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
}

.widget-user .widget-user-desc {
    margin-top: 0;
}

.widget-user .widget-user-image {
    position: absolute;
    top: 65px;
    left: 50%;
    margin-left: -45px;
}

    .widget-user .widget-user-image > img {
        width: 90px;
        height: auto;
        border: 3px solid #fff;
    }

.widget-user .box-footer {
    padding-top: 30px;
}

.widget-user-2 .widget-user-header {
    padding: 20px;
    border-top-right-radius: 3px;
    border-top-left-radius: 3px;
}

.widget-user-2 .widget-user-username {
    margin-top: 5px;
    margin-bottom: 5px;
    font-size: 25px;
    font-weight: 300;
}

.widget-user-2 .widget-user-desc {
    margin-top: 0;
}

.widget-user-2 .widget-user-username,
.widget-user-2 .widget-user-desc {
    margin-left: 75px;
}

.widget-user-2 .widget-user-image > img {
    width: 65px;
    height: auto;
    float: left;
}

.treeview-menu {
    display: none;
    list-style: none;
    padding: 0;
    margin: 0;
    padding-left: 5px;
}

    .treeview-menu .treeview-menu {
        padding-left: 20px;
    }

    .treeview-menu > li {
        margin: 0;
    }

        .treeview-menu > li > a {
            padding: 5px 5px 5px 15px;
            display: block;
            font-size: 14px;
        }

            .treeview-menu > li > a > .fa,
            .treeview-menu > li > a > .glyphicon,
            .treeview-menu > li > a > .ion {
                width: 20px;
            }

            .treeview-menu > li > a > .pull-right-container > .fa-angle-left,
            .treeview-menu > li > a > .pull-right-container > .fa-angle-down,
            .treeview-menu > li > a > .fa-angle-left,
            .treeview-menu > li > a > .fa-angle-down {
                width: auto;
            }
/*
 * Page: Mailbox
 * -------------
 */
.mailbox-messages > .table {
    margin: 0;
}

.mailbox-controls {
    padding: 5px;
}

    .mailbox-controls.with-border {
        border-bottom: 1px solid var(--mu-borda-sutil, #f4f4f4);
    }

.mailbox-read-info {
    border-bottom: 1px solid var(--mu-borda-sutil, #f4f4f4);
    padding: 10px;
}

    .mailbox-read-info h3 {
        font-size: 20px;
        margin: 0;
    }

    .mailbox-read-info h5 {
        margin: 0;
        padding: 5px 0 0 0;
    }

.mailbox-read-time {
    color: var(--mu-texto-suave, #999);
    font-size: 13px;
}

.mailbox-read-message {
    padding: 10px;
}

.mailbox-attachments li {
    float: left;
    width: 200px;
    border: 1px solid var(--mu-borda-sutil, #eee);
    margin-bottom: 10px;
    margin-right: 10px;
}

.mailbox-attachment-name {
    font-weight: bold;
    color: var(--mu-texto-suave, #666);
}

.mailbox-attachment-icon,
.mailbox-attachment-info,
.mailbox-attachment-size {
    display: block;
}

.mailbox-attachment-info {
    padding: 10px;
    background: var(--mu-superficie-sutil, #f4f4f4);
}

.mailbox-attachment-size {
    color: var(--mu-texto-suave, #999);
    font-size: 12px;
}

.mailbox-attachment-icon {
    text-align: center;
    font-size: 65px;
    color: var(--mu-texto-suave, #666);
    padding: 20px 10px;
}

    .mailbox-attachment-icon.has-img {
        padding: 0;
    }

        .mailbox-attachment-icon.has-img > img {
            max-width: 100%;
            height: auto;
        }
/*
 * Page: Lock Screen
 * -----------------
 */
/* ADD THIS CLASS TO THE <BODY> TAG */
.lockscreen {
    background: var(--mu-superficie-forte, #d2d6de);
}

.lockscreen-logo {
    font-size: 35px;
    text-align: center;
    margin-bottom: 25px;
    font-weight: 300;
}

    .lockscreen-logo a {
        color: var(--mu-texto, #444);
    }

.lockscreen-wrapper {
    max-width: 400px;
    margin: 0 auto;
    margin-top: 10%;
}
/* User name [optional] */
.lockscreen .lockscreen-name {
    text-align: center;
    font-weight: 600;
}
/* Will contain the image and the sign in form */
.lockscreen-item {
    border-radius: 4px;
    padding: 0;
    background: var(--mu-superficie, #fff);
    position: relative;
    margin: 10px auto 30px auto;
    width: 290px;
}
/* User image */
.lockscreen-image {
    border-radius: 50%;
    position: absolute;
    left: -10px;
    top: -25px;
    background: var(--mu-superficie, #fff);
    padding: 5px;
    z-index: 10;
}

    .lockscreen-image > img {
        border-radius: 50%;
        width: 70px;
        height: 70px;
    }
/* Contains the password input and the login button */
.lockscreen-credentials {
    margin-left: 70px;
}

    .lockscreen-credentials .form-control {
        border: 0;
    }

    .lockscreen-credentials .btn {
        background-color: var(--mu-superficie, #fff);
        border: 0;
        padding: 0 10px;
    }

.lockscreen-footer {
    margin-top: 10px;
}
/*
 * Page: Login & Register
 * ----------------------
 */
.login-logo,
.register-logo {
    font-size: 35px;
    text-align: center;
    margin-bottom: 25px;
    font-weight: 300;
}

    .login-logo a,
    .register-logo a {
        color: var(--mu-texto, #444);
    }

.login-page,
.register-page {
    background: var(--mu-superficie-forte, #d2d6de);
}

.login-box,
.register-box {
    width: 360px;
    margin: 7% auto;
}

@media (max-width: 768px) {
    .login-box,
    .register-box {
        width: 90%;
        margin-top: 20px;
    }
}

.login-box-body,
.register-box-body {
    background: var(--mu-superficie, #fff);
    padding: 20px;
    border-top: 0;
    color: var(--mu-texto-suave, #666);
}

    .login-box-body .form-control-feedback,
    .register-box-body .form-control-feedback {
        color: var(--mu-texto-suave, #777);
    }

.login-box-msg,
.register-box-msg {
    margin: 0;
    text-align: center;
    padding: 0 20px 20px 20px;
}

.social-auth-links {
    margin: 10px 0;
}
/*
 * Page: 400 and 500 error pages
 * ------------------------------
 */
.error-page {
    width: 600px;
    margin: 20px auto 0 auto;
}

@media (max-width: 991px) {
    .error-page {
        width: 100%;
    }
}

.error-page > .headline {
    float: left;
    font-size: 100px;
    font-weight: 300;
}

@media (max-width: 991px) {
    .error-page > .headline {
        float: none;
        text-align: center;
    }
}

.error-page > .error-content {
    margin-left: 190px;
    display: block;
}

@media (max-width: 991px) {
    .error-page > .error-content {
        margin-left: 0;
    }
}

.error-page > .error-content > h3 {
    font-weight: 300;
    font-size: 25px;
}

@media (max-width: 991px) {
    .error-page > .error-content > h3 {
        text-align: center;
    }
}
/*
 * Page: Invoice
 * -------------
 */
.invoice {
    position: relative;
    background: var(--mu-superficie, #fff);
    border: 1px solid var(--mu-borda-sutil, #f4f4f4);
    padding: 20px;
    margin: 10px 25px;
}

.invoice-title {
    margin-top: 0;
}
/*
 * Page: Profile
 * -------------
 */
.profile-user-img {
    margin: 0 auto;
    width: 100px;
    padding: 3px;
    border: 3px solid var(--mu-borda-forte, #d2d6de);
}

.profile-username {
    font-size: 21px;
    margin-top: 5px;
}

.post {
    border-bottom: 1px solid var(--mu-borda-forte, #d2d6de);
    margin-bottom: 15px;
    padding-bottom: 15px;
    color: var(--mu-texto-suave, #666);
}

    .post:last-of-type {
        border-bottom: 0;
        margin-bottom: 0;
        padding-bottom: 0;
    }

    .post .user-block {
        margin-bottom: 15px;
    }
/*
 * Social Buttons for Bootstrap
 *
 * Copyright 2013-2015 Panayiotis Lipiridis
 * Licensed under the MIT License
 *
 * https://github.com/lipis/bootstrap-social
 */
.btn-social {
    position: relative;
    padding-left: 44px;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

    .btn-social > :first-child {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 32px;
        line-height: 34px;
        font-size: 1.6em;
        text-align: center;
        border-right: 1px solid rgba(0, 0, 0, 0.2);
    }

    .btn-social.btn-lg {
        padding-left: 61px;
    }

        .btn-social.btn-lg > :first-child {
            line-height: 45px;
            width: 45px;
            font-size: 1.8em;
        }

    .btn-social.btn-sm {
        padding-left: 38px;
    }

        .btn-social.btn-sm > :first-child {
            line-height: 28px;
            width: 28px;
            font-size: 1.4em;
        }

    .btn-social.btn-xs {
        padding-left: 30px;
    }

        .btn-social.btn-xs > :first-child {
            line-height: 20px;
            width: 20px;
            font-size: 1.2em;
        }

.btn-social-icon {
    position: relative;
    padding-left: 44px;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 34px;
    width: 34px;
    padding: 0;
}

    .btn-social-icon > :first-child {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 32px;
        line-height: 34px;
        font-size: 1.6em;
        text-align: center;
        border-right: 1px solid rgba(0, 0, 0, 0.2);
    }

    .btn-social-icon.btn-lg {
        padding-left: 61px;
    }

        .btn-social-icon.btn-lg > :first-child {
            line-height: 45px;
            width: 45px;
            font-size: 1.8em;
        }

    .btn-social-icon.btn-sm {
        padding-left: 38px;
    }

        .btn-social-icon.btn-sm > :first-child {
            line-height: 28px;
            width: 28px;
            font-size: 1.4em;
        }

    .btn-social-icon.btn-xs {
        padding-left: 30px;
    }

        .btn-social-icon.btn-xs > :first-child {
            line-height: 20px;
            width: 20px;
            font-size: 1.2em;
        }

    .btn-social-icon > :first-child {
        border: none;
        text-align: center;
        width: 100%;
    }

    .btn-social-icon.btn-lg {
        height: 45px;
        width: 45px;
        padding-left: 0;
        padding-right: 0;
    }

    .btn-social-icon.btn-sm {
        height: 30px;
        width: 30px;
        padding-left: 0;
        padding-right: 0;
    }

    .btn-social-icon.btn-xs {
        height: 22px;
        width: 22px;
        padding-left: 0;
        padding-right: 0;
    }

.btn-adn {
    color: #ffffff;
    background-color: #d87a68;
    border-color: rgba(0, 0, 0, 0.2);
}

    .btn-adn:focus,
    .btn-adn.focus {
        color: #ffffff;
        background-color: #ce563f;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-adn:hover {
        color: #ffffff;
        background-color: #ce563f;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-adn:active,
    .btn-adn.active,
    .open > .dropdown-toggle.btn-adn {
        color: #ffffff;
        background-color: #ce563f;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-adn:active,
    .btn-adn.active,
    .open > .dropdown-toggle.btn-adn {
        background-image: none;
    }

    .btn-adn .badge {
        color: #d87a68;
        background-color: var(--mu-superficie, #ffffff);
    }

.btn-bitbucket {
    color: #ffffff;
    background-color: #205081;
    border-color: rgba(0, 0, 0, 0.2);
}

    .btn-bitbucket:focus,
    .btn-bitbucket.focus {
        color: #ffffff;
        background-color: #163758;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-bitbucket:hover {
        color: #ffffff;
        background-color: #163758;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-bitbucket:active,
    .btn-bitbucket.active,
    .open > .dropdown-toggle.btn-bitbucket {
        color: #ffffff;
        background-color: #163758;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-bitbucket:active,
    .btn-bitbucket.active,
    .open > .dropdown-toggle.btn-bitbucket {
        background-image: none;
    }

    .btn-bitbucket .badge {
        color: #205081;
        background-color: var(--mu-superficie, #ffffff);
    }

.btn-dropbox {
    color: #ffffff;
    background-color: #1087dd;
    border-color: rgba(0, 0, 0, 0.2);
}

    .btn-dropbox:focus,
    .btn-dropbox.focus {
        color: #ffffff;
        background-color: #0d6aad;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-dropbox:hover {
        color: #ffffff;
        background-color: #0d6aad;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-dropbox:active,
    .btn-dropbox.active,
    .open > .dropdown-toggle.btn-dropbox {
        color: #ffffff;
        background-color: #0d6aad;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-dropbox:active,
    .btn-dropbox.active,
    .open > .dropdown-toggle.btn-dropbox {
        background-image: none;
    }

    .btn-dropbox .badge {
        color: #1087dd;
        background-color: var(--mu-superficie, #ffffff);
    }

.btn-facebook {
    color: #ffffff;
    background-color: #3b5998;
    border-color: rgba(0, 0, 0, 0.2);
}

    .btn-facebook:focus,
    .btn-facebook.focus {
        color: #ffffff;
        background-color: #2d4373;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-facebook:hover {
        color: #ffffff;
        background-color: #2d4373;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-facebook:active,
    .btn-facebook.active,
    .open > .dropdown-toggle.btn-facebook {
        color: #ffffff;
        background-color: #2d4373;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-facebook:active,
    .btn-facebook.active,
    .open > .dropdown-toggle.btn-facebook {
        background-image: none;
    }

    .btn-facebook .badge {
        color: #3b5998;
        background-color: var(--mu-superficie, #ffffff);
    }

.btn-flickr {
    color: #ffffff;
    background-color: #ff0084;
    border-color: rgba(0, 0, 0, 0.2);
}

    .btn-flickr:focus,
    .btn-flickr.focus {
        color: #ffffff;
        background-color: #cc006a;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-flickr:hover {
        color: #ffffff;
        background-color: #cc006a;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-flickr:active,
    .btn-flickr.active,
    .open > .dropdown-toggle.btn-flickr {
        color: #ffffff;
        background-color: #cc006a;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-flickr:active,
    .btn-flickr.active,
    .open > .dropdown-toggle.btn-flickr {
        background-image: none;
    }

    .btn-flickr .badge {
        color: #ff0084;
        background-color: var(--mu-superficie, #ffffff);
    }

.btn-foursquare {
    color: #ffffff;
    background-color: #f94877;
    border-color: rgba(0, 0, 0, 0.2);
}

    .btn-foursquare:focus,
    .btn-foursquare.focus {
        color: #ffffff;
        background-color: #f71752;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-foursquare:hover {
        color: #ffffff;
        background-color: #f71752;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-foursquare:active,
    .btn-foursquare.active,
    .open > .dropdown-toggle.btn-foursquare {
        color: #ffffff;
        background-color: #f71752;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-foursquare:active,
    .btn-foursquare.active,
    .open > .dropdown-toggle.btn-foursquare {
        background-image: none;
    }

    .btn-foursquare .badge {
        color: #f94877;
        background-color: var(--mu-superficie, #ffffff);
    }

.btn-github {
    color: #ffffff;
    background-color: #444444;
    border-color: rgba(0, 0, 0, 0.2);
}

    .btn-github:focus,
    .btn-github.focus {
        color: #ffffff;
        background-color: #2b2b2b;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-github:hover {
        color: #ffffff;
        background-color: #2b2b2b;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-github:active,
    .btn-github.active,
    .open > .dropdown-toggle.btn-github {
        color: #ffffff;
        background-color: #2b2b2b;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-github:active,
    .btn-github.active,
    .open > .dropdown-toggle.btn-github {
        background-image: none;
    }

    .btn-github .badge {
        color: var(--mu-texto, #444444);
        background-color: var(--mu-superficie, #ffffff);
    }

.btn-google {
    color: #ffffff;
    background-color: #dd4b39;
    border-color: rgba(0, 0, 0, 0.2);
}

    .btn-google:focus,
    .btn-google.focus {
        color: #ffffff;
        background-color: #c23321;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-google:hover {
        color: #ffffff;
        background-color: #c23321;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-google:active,
    .btn-google.active,
    .open > .dropdown-toggle.btn-google {
        color: #ffffff;
        background-color: #c23321;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-google:active,
    .btn-google.active,
    .open > .dropdown-toggle.btn-google {
        background-image: none;
    }

    .btn-google .badge {
        color: #dd4b39;
        background-color: var(--mu-superficie, #ffffff);
    }

.btn-instagram {
    color: #ffffff;
    background-color: #3f729b;
    border-color: rgba(0, 0, 0, 0.2);
}

    .btn-instagram:focus,
    .btn-instagram.focus {
        color: #ffffff;
        background-color: #305777;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-instagram:hover {
        color: #ffffff;
        background-color: #305777;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-instagram:active,
    .btn-instagram.active,
    .open > .dropdown-toggle.btn-instagram {
        color: #ffffff;
        background-color: #305777;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-instagram:active,
    .btn-instagram.active,
    .open > .dropdown-toggle.btn-instagram {
        background-image: none;
    }

    .btn-instagram .badge {
        color: #3f729b;
        background-color: var(--mu-superficie, #ffffff);
    }

.btn-linkedin {
    color: #ffffff;
    background-color: #007bb6;
    border-color: rgba(0, 0, 0, 0.2);
}

    .btn-linkedin:focus,
    .btn-linkedin.focus {
        color: #ffffff;
        background-color: #005983;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-linkedin:hover {
        color: #ffffff;
        background-color: #005983;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-linkedin:active,
    .btn-linkedin.active,
    .open > .dropdown-toggle.btn-linkedin {
        color: #ffffff;
        background-color: #005983;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-linkedin:active,
    .btn-linkedin.active,
    .open > .dropdown-toggle.btn-linkedin {
        background-image: none;
    }

    .btn-linkedin .badge {
        color: #007bb6;
        background-color: var(--mu-superficie, #ffffff);
    }

.btn-microsoft {
    color: #ffffff;
    background-color: #2672ec;
    border-color: rgba(0, 0, 0, 0.2);
}

    .btn-microsoft:focus,
    .btn-microsoft.focus {
        color: #ffffff;
        background-color: #125acd;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-microsoft:hover {
        color: #ffffff;
        background-color: #125acd;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-microsoft:active,
    .btn-microsoft.active,
    .open > .dropdown-toggle.btn-microsoft {
        color: #ffffff;
        background-color: #125acd;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-microsoft:active,
    .btn-microsoft.active,
    .open > .dropdown-toggle.btn-microsoft {
        background-image: none;
    }

    .btn-microsoft .badge {
        color: #2672ec;
        background-color: var(--mu-superficie, #ffffff);
    }

.btn-openid {
    color: #ffffff;
    background-color: #f7931e;
    border-color: rgba(0, 0, 0, 0.2);
}

    .btn-openid:focus,
    .btn-openid.focus {
        color: #ffffff;
        background-color: #da7908;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-openid:hover {
        color: #ffffff;
        background-color: #da7908;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-openid:active,
    .btn-openid.active,
    .open > .dropdown-toggle.btn-openid {
        color: #ffffff;
        background-color: #da7908;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-openid:active,
    .btn-openid.active,
    .open > .dropdown-toggle.btn-openid {
        background-image: none;
    }

    .btn-openid .badge {
        color: #f7931e;
        background-color: var(--mu-superficie, #ffffff);
    }

.btn-pinterest {
    color: #ffffff;
    background-color: #cb2027;
    border-color: rgba(0, 0, 0, 0.2);
}

    .btn-pinterest:focus,
    .btn-pinterest.focus {
        color: #ffffff;
        background-color: #9f191f;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-pinterest:hover {
        color: #ffffff;
        background-color: #9f191f;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-pinterest:active,
    .btn-pinterest.active,
    .open > .dropdown-toggle.btn-pinterest {
        color: #ffffff;
        background-color: #9f191f;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-pinterest:active,
    .btn-pinterest.active,
    .open > .dropdown-toggle.btn-pinterest {
        background-image: none;
    }

    .btn-pinterest .badge {
        color: #cb2027;
        background-color: var(--mu-superficie, #ffffff);
    }

.btn-reddit {
    color: var(--mu-texto, #000000);
    background-color: var(--mu-superficie-azul, #eff7ff);
    border-color: rgba(0, 0, 0, 0.2);
}

    .btn-reddit:focus,
    .btn-reddit.focus {
        color: var(--mu-texto, #000000);
        background-color: var(--mu-superficie-azul, #bcddff);
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-reddit:hover {
        color: var(--mu-texto, #000000);
        background-color: var(--mu-superficie-azul, #bcddff);
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-reddit:active,
    .btn-reddit.active,
    .open > .dropdown-toggle.btn-reddit {
        color: var(--mu-texto, #000000);
        background-color: var(--mu-superficie-azul, #bcddff);
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-reddit:active,
    .btn-reddit.active,
    .open > .dropdown-toggle.btn-reddit {
        background-image: none;
    }

    .btn-reddit .badge {
        color: #eff7ff;
        background-color: #000000;
    }

.btn-soundcloud {
    color: #ffffff;
    background-color: #ff5500;
    border-color: rgba(0, 0, 0, 0.2);
}

    .btn-soundcloud:focus,
    .btn-soundcloud.focus {
        color: #ffffff;
        background-color: #cc4400;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-soundcloud:hover {
        color: #ffffff;
        background-color: #cc4400;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-soundcloud:active,
    .btn-soundcloud.active,
    .open > .dropdown-toggle.btn-soundcloud {
        color: #ffffff;
        background-color: #cc4400;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-soundcloud:active,
    .btn-soundcloud.active,
    .open > .dropdown-toggle.btn-soundcloud {
        background-image: none;
    }

    .btn-soundcloud .badge {
        color: #ff5500;
        background-color: var(--mu-superficie, #ffffff);
    }

.btn-tumblr {
    color: #ffffff;
    background-color: #2c4762;
    border-color: rgba(0, 0, 0, 0.2);
}

    .btn-tumblr:focus,
    .btn-tumblr.focus {
        color: #ffffff;
        background-color: #1c2d3f;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-tumblr:hover {
        color: #ffffff;
        background-color: #1c2d3f;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-tumblr:active,
    .btn-tumblr.active,
    .open > .dropdown-toggle.btn-tumblr {
        color: #ffffff;
        background-color: #1c2d3f;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-tumblr:active,
    .btn-tumblr.active,
    .open > .dropdown-toggle.btn-tumblr {
        background-image: none;
    }

    .btn-tumblr .badge {
        color: #2c4762;
        background-color: var(--mu-superficie, #ffffff);
    }

.btn-twitter {
    color: #ffffff;
    background-color: #55acee;
    border-color: rgba(0, 0, 0, 0.2);
}

    .btn-twitter:focus,
    .btn-twitter.focus {
        color: #ffffff;
        background-color: #2795e9;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-twitter:hover {
        color: #ffffff;
        background-color: #2795e9;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-twitter:active,
    .btn-twitter.active,
    .open > .dropdown-toggle.btn-twitter {
        color: #ffffff;
        background-color: #2795e9;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-twitter:active,
    .btn-twitter.active,
    .open > .dropdown-toggle.btn-twitter {
        background-image: none;
    }

    .btn-twitter .badge {
        color: #55acee;
        background-color: var(--mu-superficie, #ffffff);
    }

.btn-vimeo {
    color: #ffffff;
    background-color: #1ab7ea;
    border-color: rgba(0, 0, 0, 0.2);
}

    .btn-vimeo:focus,
    .btn-vimeo.focus {
        color: #ffffff;
        background-color: #1295bf;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-vimeo:hover {
        color: #ffffff;
        background-color: #1295bf;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-vimeo:active,
    .btn-vimeo.active,
    .open > .dropdown-toggle.btn-vimeo {
        color: #ffffff;
        background-color: #1295bf;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-vimeo:active,
    .btn-vimeo.active,
    .open > .dropdown-toggle.btn-vimeo {
        background-image: none;
    }

    .btn-vimeo .badge {
        color: #1ab7ea;
        background-color: var(--mu-superficie, #ffffff);
    }

.btn-vk {
    color: #ffffff;
    background-color: #587ea3;
    border-color: rgba(0, 0, 0, 0.2);
}

    .btn-vk:focus,
    .btn-vk.focus {
        color: #ffffff;
        background-color: #466482;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-vk:hover {
        color: #ffffff;
        background-color: #466482;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-vk:active,
    .btn-vk.active,
    .open > .dropdown-toggle.btn-vk {
        color: #ffffff;
        background-color: #466482;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-vk:active,
    .btn-vk.active,
    .open > .dropdown-toggle.btn-vk {
        background-image: none;
    }

    .btn-vk .badge {
        color: #587ea3;
        background-color: var(--mu-superficie, #ffffff);
    }

.btn-yahoo {
    color: #ffffff;
    background-color: #720e9e;
    border-color: rgba(0, 0, 0, 0.2);
}

    .btn-yahoo:focus,
    .btn-yahoo.focus {
        color: #ffffff;
        background-color: #500a6f;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-yahoo:hover {
        color: #ffffff;
        background-color: #500a6f;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-yahoo:active,
    .btn-yahoo.active,
    .open > .dropdown-toggle.btn-yahoo {
        color: #ffffff;
        background-color: #500a6f;
        border-color: rgba(0, 0, 0, 0.2);
    }

    .btn-yahoo:active,
    .btn-yahoo.active,
    .open > .dropdown-toggle.btn-yahoo {
        background-image: none;
    }

    .btn-yahoo .badge {
        color: #720e9e;
        background-color: var(--mu-superficie, #ffffff);
    }
/*
 * Plugin: Full Calendar
 * ---------------------
 */
.fc-button {
    background: var(--mu-superficie-sutil, #f4f4f4);
    background-image: none;
    color: var(--mu-texto, #444);
    border-color: var(--mu-borda-media, #ddd);
    border-bottom-color: var(--mu-borda-media, #ddd);
}

    .fc-button:hover,
    .fc-button:active,
    .fc-button.hover {
        background-color: var(--mu-superficie-sutil, #e9e9e9);
    }

.fc-header-title h2 {
    font-size: 15px;
    line-height: 1.6em;
    color: var(--mu-texto-suave, #666);
    margin-left: 10px;
}

.fc-header-right {
    padding-right: 10px;
}

.fc-header-left {
    padding-left: 10px;
}

.fc-widget-header {
    background: var(--mu-superficie-sutil, #fafafa);
}

.fc-grid {
    width: 100%;
    border: 0;
}

.fc-widget-header:first-of-type,
.fc-widget-content:first-of-type {
    border-left: 0;
    border-right: 0;
}

.fc-widget-header:last-of-type,
.fc-widget-content:last-of-type {
    border-right: 0;
}

.fc-toolbar {
    padding: 10px;
    margin: 0;
}

.fc-day-number {
    font-size: 20px;
    font-weight: 300;
    padding-right: 10px;
}

.fc-color-picker {
    list-style: none;
    margin: 0;
    padding: 0;
}

    .fc-color-picker > li {
        float: left;
        font-size: 30px;
        margin-right: 5px;
        line-height: 30px;
    }

        .fc-color-picker > li .fa {
            -webkit-transition: -webkit-transform linear 0.3s;
            -moz-transition: -moz-transform linear 0.3s;
            -o-transition: -o-transform linear 0.3s;
            transition: transform linear 0.3s;
        }

            .fc-color-picker > li .fa:hover {
                -webkit-transform: rotate(30deg);
                -ms-transform: rotate(30deg);
                -o-transform: rotate(30deg);
                transform: rotate(30deg);
            }

#add-new-event {
    -webkit-transition: all linear 0.3s;
    -o-transition: all linear 0.3s;
    transition: all linear 0.3s;
}

.external-event {
    padding: 5px 10px;
    font-weight: bold;
    margin-bottom: 4px;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    cursor: move;
}

    .external-event:hover {
        box-shadow: inset 0 0 90px rgba(0, 0, 0, 0.2);
    }
/*
 * Plugin: Select2
 * ---------------
 */
.select2-container--default.select2-container--focus,
.select2-selection.select2-container--focus,
.select2-container--default:focus,
.select2-selection:focus,
.select2-container--default:active,
.select2-selection:active {
    outline: none;
}

.select2-container--default .select2-selection--single,
.select2-selection .select2-selection--single {
    border: 1px solid var(--mu-borda-forte, #d2d6de);
    border-radius: 0;
    /*padding: 6px 12px;*/
    padding: 4px 1px 2px 0px;
    height: 34px;
}

.select2-container--default.select2-container--open {
    border-color: #3c8dbc;
}

.select2-dropdown {
    border: 1px solid var(--mu-borda-forte, #d2d6de);
    border-radius: 0;
    min-width: 270px !important; /*FNX-5270*/
}

.select2-container--default .select2-results__option--highlighted[aria-selected] {
    background-color: #3c8dbc;
    color: white;
}

.select2-results__option {
    padding: 6px 12px;
    user-select: none;
    -webkit-user-select: none;
}

.select2-container .select2-selection--single .select2-selection__rendered {
    padding-left: 0;
    padding-right: 0;
    height: auto;
    margin-top: -4px;
}

.select2-container[dir="rtl"] .select2-selection--single .select2-selection__rendered {
    padding-right: 1px;
    padding-left: 20px;
}

.select2-container--default .select2-selection--single .select2-selection__arrow {
    height: 28px;
    right: 3px;
}

    .select2-container--default .select2-selection--single .select2-selection__arrow b {
        margin-top: 0;
    }

.select2-dropdown .select2-search__field,
.select2-search--inline .select2-search__field {
    border: 1px solid var(--mu-borda-forte, #d2d6de);
}

    .select2-dropdown .select2-search__field:focus,
    .select2-search--inline .select2-search__field:focus {
        outline: none;
    }

.select2-container--default.select2-container--focus .select2-selection--multiple,
.select2-container--default .select2-search--dropdown .select2-search__field {
    border-color: #3c8dbc !important;
}

.select2-container--default .select2-results__option[aria-disabled=true] {
    color: var(--mu-texto-suave, #999);
}

.select2-container--default .select2-results__option[aria-selected=true] {
    background-color: var(--mu-superficie-forte, #ddd);
}

    .select2-container--default .select2-results__option[aria-selected=true],
    .select2-container--default .select2-results__option[aria-selected=true]:hover {
        color: var(--mu-texto, #444);
    }

.select2-container--default .select2-selection--multiple {
    border: 1px solid var(--mu-borda-forte, #d2d6de);
    border-radius: 0;
}

    .select2-container--default .select2-selection--multiple:focus {
        border-color: #3c8dbc;
    }

.select2-container--default.select2-container--focus .select2-selection--multiple {
    border-color: var(--mu-borda-forte, #d2d6de);
}

.select2-container--default .select2-selection--multiple .select2-selection__choice {
    background-color: #3c8dbc;
    border-color: #367fa9;
    padding: 1px 10px;
    color: #fff;
}

.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
    margin-right: 5px;
    color: rgba(255, 255, 255, 0.7);
}

    .select2-container--default .select2-selection--multiple .select2-selection__choice__remove:hover {
        color: #fff;
    }

.select2-container .select2-selection--single .select2-selection__rendered {
    padding-right: 10px;
}

.box .datepicker-inline,
.box .datepicker-inline .datepicker-days,
.box .datepicker-inline > table,
.box .datepicker-inline .datepicker-days > table {
    width: 100%;
}

    .box .datepicker-inline td:hover,
    .box .datepicker-inline .datepicker-days td:hover,
    .box .datepicker-inline > table td:hover,
    .box .datepicker-inline .datepicker-days > table td:hover {
        background-color: rgba(255, 255, 255, 0.3);
    }

    .box .datepicker-inline td.day.old,
    .box .datepicker-inline .datepicker-days td.day.old,
    .box .datepicker-inline > table td.day.old,
    .box .datepicker-inline .datepicker-days > table td.day.old,
    .box .datepicker-inline td.day.new,
    .box .datepicker-inline .datepicker-days td.day.new,
    .box .datepicker-inline > table td.day.new,
    .box .datepicker-inline .datepicker-days > table td.day.new {
        color: var(--mu-texto-suave, #777);
    }
/*
 * General: Miscellaneous
 * ----------------------
 */
.pad {
    padding: 10px;
}

.margin {
    margin: 10px;
}

.margin-bottom {
    margin-bottom: 20px;
}

.margin-bottom-none {
    margin-bottom: 0;
}

.margin-r-5 {
    margin-right: 5px;
}

.inline {
    display: inline;
}

.description-block {
    display: block;
    margin: 10px 0;
    text-align: center;
}

    .description-block.margin-bottom {
        margin-bottom: 25px;
    }

    .description-block > .description-header {
        margin: 0;
        padding: 0;
        font-weight: 600;
        font-size: 16px;
    }

    .description-block > .description-text {
        text-transform: uppercase;
    }

.bg-red,
.bg-yellow,
.bg-aqua,
.bg-blue,
.bg-light-blue,
.bg-green,
.bg-navy,
.bg-teal,
.bg-olive,
.bg-lime,
.bg-orange,
.bg-fuchsia,
.bg-purple,
.bg-maroon,
.bg-black,
.bg-red-active,
.bg-yellow-active,
.bg-aqua-active,
.bg-blue-active,
.bg-light-blue-active,
.bg-green-active,
.bg-navy-active,
.bg-teal-active,
.bg-olive-active,
.bg-lime-active,
.bg-orange-active,
.bg-fuchsia-active,
.bg-purple-active,
.bg-maroon-active,
.bg-black-active,
.callout.callout-danger,
.callout.callout-warning,
.callout.callout-info,
.callout.callout-success,
.alert-success,
.alert-danger,
.alert-error,
.alert-warning,
.alert-info,
.label-danger,
.label-info,
.label-warning,
.label-primary,
.label-success,
.modal-primary .modal-body,
.modal-primary .modal-header,
.modal-primary .modal-footer,
.modal-warning .modal-body,
.modal-warning .modal-header,
.modal-warning .modal-footer,
.modal-info .modal-body,
.modal-info .modal-header,
.modal-info .modal-footer,
.modal-success .modal-body,
.modal-success .modal-header,
.modal-success .modal-footer,
.modal-danger .modal-body,
.modal-danger .modal-header,
.modal-danger .modal-footer {
    color: #fff !important;
}

.bg-gray {
    color: var(--mu-texto, #000);
    background-color: var(--mu-superficie-forte, #d2d6de) !important;
}

.bg-gray-light {
    background-color: var(--mu-superficie-sutil, #f7f7f7);
}

.bg-black {
    background-color: #111111 !important;
}

.bg-red,
.callout.callout-danger,
.alert-danger,
.alert-error,
.label-danger,
.modal-danger .modal-body {
    background-color: #dd4b39 !important;
}

.bg-yellow,
.callout.callout-warning,
.alert-warning,
.label-warning,
.modal-warning .modal-body {
    background-color: #f39c12 !important;
}

.bg-aqua,
.callout.callout-info,
.alert-info,
.label-info,
.modal-info .modal-body {
    background-color: #00c0ef !important;
}

.bg-blue {
    background-color: #0073b7 !important;
}

.bg-light-blue,
.label-primary,
.modal-primary .modal-body {
    background-color: #3c8dbc !important;
}

.bg-green,
.callout.callout-success,
.alert-success,
.label-success,
.modal-success .modal-body {
    background-color: #00a65a !important;
}

.bg-navy {
    background-color: #001f3f !important;
}

.bg-teal {
    background-color: #39cccc !important;
}

.bg-olive {
    background-color: #3d9970 !important;
}

.bg-lime {
    background-color: #01ff70 !important;
}

.bg-orange {
    background-color: #ff851b !important;
}

.bg-fuchsia {
    background-color: #f012be !important;
}

.bg-purple {
    background-color: #605ca8 !important;
}

.bg-maroon {
    background-color: #d81b60 !important;
}

.bg-gray-active {
    color: var(--mu-texto, #000);
    background-color: var(--mu-superficie-escura, #b5bbc8) !important;
}

.bg-black-active {
    background-color: #000000 !important;
}

.bg-red-active,
.modal-danger .modal-header,
.modal-danger .modal-footer {
    background-color: #d33724 !important;
}

.bg-yellow-active,
.modal-warning .modal-header,
.modal-warning .modal-footer {
    background-color: #db8b0b !important;
}

.bg-aqua-active,
.modal-info .modal-header,
.modal-info .modal-footer {
    background-color: #00a7d0 !important;
}

.bg-blue-active {
    background-color: #005384 !important;
}

.bg-light-blue-active,
.modal-primary .modal-header,
.modal-primary .modal-footer {
    background-color: #357ca5 !important;
}

.bg-green-active,
.modal-success .modal-header,
.modal-success .modal-footer {
    background-color: #008d4c !important;
}

.bg-navy-active {
    background-color: #001a35 !important;
}

.bg-teal-active {
    background-color: #30bbbb !important;
}

.bg-olive-active {
    background-color: #368763 !important;
}

.bg-lime-active {
    background-color: #00e765 !important;
}

.bg-orange-active {
    background-color: #ff7701 !important;
}

.bg-fuchsia-active {
    background-color: #db0ead !important;
}

.bg-purple-active {
    background-color: #555299 !important;
}

.bg-maroon-active {
    background-color: #ca195a !important;
}

[class^="bg-"].disabled {
    opacity: 0.65;
    filter: alpha(opacity=65);
}

.text-red {
    color: #dd4b39 !important;
}

.text-yellow {
    color: #f39c12 !important;
}

.text-aqua {
    color: #00c0ef !important;
}

.text-blue {
    color: #0073b7 !important;
}

.text-black {
    color: var(--mu-texto, #111111) !important;
}

.text-light-blue {
    color: #3c8dbc !important;
}

.text-green {
    color: #00a65a !important;
}

.text-gray {
    color: #d2d6de !important;
}

.text-navy {
    color: #001f3f !important;
}

.text-teal {
    color: #39cccc !important;
}

.text-olive {
    color: #3d9970 !important;
}

.text-lime {
    color: #01ff70 !important;
}

.text-orange {
    color: #ff851b !important;
}

.text-fuchsia {
    color: #f012be !important;
}

.text-purple {
    color: #605ca8 !important;
}

.text-maroon {
    color: #d81b60 !important;
}

.link-muted {
    color: #7a869d;
}

    .link-muted:hover,
    .link-muted:focus {
        color: #606c84;
    }

.link-black {
    color: var(--mu-texto-suave, #666);
}

    .link-black:hover,
    .link-black:focus {
        color: var(--mu-texto-suave, #999);
    }

.hide {
    display: none !important;
}

.no-border {
    border: 0 !important;
}

.no-padding {
    padding: 0 !important;
}

.no-margin {
    margin: 0 !important;
}

.no-shadow {
    box-shadow: none !important;
}

.list-unstyled,
.chart-legend,
.contacts-list,
.users-list,
.mailbox-attachments {
    list-style: none;
    margin: 0;
    padding: 0;
}

.list-group-unbordered > .list-group-item {
    border-left: 0;
    border-right: 0;
    border-radius: 0;
    padding-left: 0;
    padding-right: 0;
}

.flat {
    border-radius: 0 !important;
}

.text-bold,
.text-bold.table td,
.text-bold.table th {
    font-weight: 700;
}

.text-sm {
    font-size: 12px;
}

.jqstooltip {
    padding: 5px !important;
    width: auto !important;
    height: auto !important;
}

.bg-teal-gradient {
    background: #39cccc !important;
    background: -webkit-gradient(linear, left bottom, left top, color-stop(0, #39cccc), color-stop(1, #7adddd)) !important;
    background: -ms-linear-gradient(bottom, #39cccc, #7adddd) !important;
    background: -moz-linear-gradient(center bottom, #39cccc 0%, #7adddd 100%) !important;
    background: -o-linear-gradient(#7adddd, #39cccc) !important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#7adddd', endColorstr='#39cccc', GradientType=0) !important;
    color: #fff;
}

.bg-light-blue-gradient {
    background: #3c8dbc !important;
    background: -webkit-gradient(linear, left bottom, left top, color-stop(0, #3c8dbc), color-stop(1, #67a8ce)) !important;
    background: -ms-linear-gradient(bottom, #3c8dbc, #67a8ce) !important;
    background: -moz-linear-gradient(center bottom, #3c8dbc 0%, #67a8ce 100%) !important;
    background: -o-linear-gradient(#67a8ce, #3c8dbc) !important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#67a8ce', endColorstr='#3c8dbc', GradientType=0) !important;
    color: #fff;
}

.bg-blue-gradient {
    background: #0073b7 !important;
    background: -webkit-gradient(linear, left bottom, left top, color-stop(0, #0073b7), color-stop(1, #0089db)) !important;
    background: -ms-linear-gradient(bottom, #0073b7, #0089db) !important;
    background: -moz-linear-gradient(center bottom, #0073b7 0%, #0089db 100%) !important;
    background: -o-linear-gradient(#0089db, #0073b7) !important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#0089db', endColorstr='#0073b7', GradientType=0) !important;
    color: #fff;
}

.bg-aqua-gradient {
    background: #00c0ef !important;
    background: -webkit-gradient(linear, left bottom, left top, color-stop(0, #00c0ef), color-stop(1, #14d1ff)) !important;
    background: -ms-linear-gradient(bottom, #00c0ef, #14d1ff) !important;
    background: -moz-linear-gradient(center bottom, #00c0ef 0%, #14d1ff 100%) !important;
    background: -o-linear-gradient(#14d1ff, #00c0ef) !important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#14d1ff', endColorstr='#00c0ef', GradientType=0) !important;
    color: #fff;
}

.bg-yellow-gradient {
    background: #f39c12 !important;
    background: -webkit-gradient(linear, left bottom, left top, color-stop(0, #f39c12), color-stop(1, #f7bc60)) !important;
    background: -ms-linear-gradient(bottom, #f39c12, #f7bc60) !important;
    background: -moz-linear-gradient(center bottom, #f39c12 0%, #f7bc60 100%) !important;
    background: -o-linear-gradient(#f7bc60, #f39c12) !important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f7bc60', endColorstr='#f39c12', GradientType=0) !important;
    color: #fff;
}

.bg-purple-gradient {
    background: #605ca8 !important;
    background: -webkit-gradient(linear, left bottom, left top, color-stop(0, #605ca8), color-stop(1, #9491c4)) !important;
    background: -ms-linear-gradient(bottom, #605ca8, #9491c4) !important;
    background: -moz-linear-gradient(center bottom, #605ca8 0%, #9491c4 100%) !important;
    background: -o-linear-gradient(#9491c4, #605ca8) !important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#9491c4', endColorstr='#605ca8', GradientType=0) !important;
    color: #fff;
}

.bg-green-gradient {
    background: #00a65a !important;
    background: -webkit-gradient(linear, left bottom, left top, color-stop(0, #00a65a), color-stop(1, #00ca6d)) !important;
    background: -ms-linear-gradient(bottom, #00a65a, #00ca6d) !important;
    background: -moz-linear-gradient(center bottom, #00a65a 0%, #00ca6d 100%) !important;
    background: -o-linear-gradient(#00ca6d, #00a65a) !important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ca6d', endColorstr='#00a65a', GradientType=0) !important;
    color: #fff;
}

.bg-red-gradient {
    background: #dd4b39 !important;
    background: -webkit-gradient(linear, left bottom, left top, color-stop(0, #dd4b39), color-stop(1, #e47365)) !important;
    background: -ms-linear-gradient(bottom, #dd4b39, #e47365) !important;
    background: -moz-linear-gradient(center bottom, #dd4b39 0%, #e47365 100%) !important;
    background: -o-linear-gradient(#e47365, #dd4b39) !important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#e47365', endColorstr='#dd4b39', GradientType=0) !important;
    color: #fff;
}

.bg-black-gradient {
    background: #111111 !important;
    background: -webkit-gradient(linear, left bottom, left top, color-stop(0, #111111), color-stop(1, #2b2b2b)) !important;
    background: -ms-linear-gradient(bottom, #111111, #2b2b2b) !important;
    background: -moz-linear-gradient(center bottom, #111111 0%, #2b2b2b 100%) !important;
    background: -o-linear-gradient(#2b2b2b, #111111) !important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#2b2b2b', endColorstr='#111111', GradientType=0) !important;
    color: #fff;
}

.bg-maroon-gradient {
    background: #d81b60 !important;
    background: -webkit-gradient(linear, left bottom, left top, color-stop(0, #d81b60), color-stop(1, #e73f7c)) !important;
    background: -ms-linear-gradient(bottom, #d81b60, #e73f7c) !important;
    background: -moz-linear-gradient(center bottom, #d81b60 0%, #e73f7c 100%) !important;
    background: -o-linear-gradient(#e73f7c, #d81b60) !important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#e73f7c', endColorstr='#d81b60', GradientType=0) !important;
    color: #fff;
}

.description-block .description-icon {
    font-size: 16px;
}

.no-pad-top {
    padding-top: 0;
}

.position-static {
    position: static !important;
}

.list-header {
    font-size: 15px;
    padding: 10px 4px;
    font-weight: bold;
    color: var(--mu-texto-suave, #666);
}

.list-seperator {
    height: 1px;
    background: var(--mu-superficie-sutil, #f4f4f4);
    margin: 15px 0 9px 0;
}

.list-link > a {
    padding: 4px;
    color: var(--mu-texto-suave, #777);
}

    .list-link > a:hover {
        color: var(--mu-texto, #222);
    }

.font-light {
    font-weight: 300;
}

.user-block:before,
.user-block:after {
    content: " ";
    display: table;
}

.user-block:after {
    clear: both;
}

.user-block img {
    width: 40px;
    height: 40px;
    float: left;
}

.user-block .username,
.user-block .description,
.user-block .comment {
    display: block;
    margin-left: 50px;
}

.user-block .username {
    font-size: 16px;
    font-weight: 600;
}

.user-block .description {
    color: var(--mu-texto-suave, #999);
    font-size: 13px;
}

.user-block.user-block-sm .username,
.user-block.user-block-sm .description,
.user-block.user-block-sm .comment {
    margin-left: 40px;
}

.user-block.user-block-sm .username {
    font-size: 14px;
}

.img-sm,
.img-md,
.img-lg,
.box-comments .box-comment img,
.user-block.user-block-sm img {
    float: left;
}

.img-sm,
.box-comments .box-comment img,
.user-block.user-block-sm img {
    width: 30px !important;
    height: 30px !important;
}

    .img-sm + .img-push {
        margin-left: 40px;
    }

.img-md {
    width: 60px;
    height: 60px;
}

    .img-md + .img-push {
        margin-left: 70px;
    }

.img-lg {
    width: 100px;
    height: 100px;
}

    .img-lg + .img-push {
        margin-left: 110px;
    }

.img-bordered {
    border: 3px solid var(--mu-borda-forte, #d2d6de);
    padding: 3px;
}

.img-bordered-sm {
    border: 2px solid var(--mu-borda-forte, #d2d6de);
    padding: 2px;
}

.attachment-block {
    border: 1px solid var(--mu-borda-sutil, #f4f4f4);
    padding: 5px;
    margin-bottom: 10px;
    background: var(--mu-superficie-sutil, #f7f7f7);
}

    .attachment-block .attachment-img {
        max-width: 100px;
        max-height: 100px;
        height: auto;
        float: left;
    }

    .attachment-block .attachment-pushed {
        margin-left: 110px;
    }

    .attachment-block .attachment-heading {
        margin: 0;
    }

    .attachment-block .attachment-text {
        color: var(--mu-texto-suave, #555);
    }

.connectedSortable {
    min-height: 100px;
}

.ui-helper-hidden-accessible {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
}

.sort-highlight {
    background: var(--mu-superficie-sutil, #f4f4f4);
    border: 1px dashed var(--mu-borda-media, #ddd);
    margin-bottom: 10px;
}

.full-opacity-hover {
    opacity: 0.65;
    filter: alpha(opacity=65);
}

    .full-opacity-hover:hover {
        opacity: 1;
        filter: alpha(opacity=100);
    }

.chart {
    position: relative;
    overflow: hidden;
    width: 100%;
}

    .chart svg,
    .chart canvas {
        width: 100% !important;
    }

.corpo {
    flex: 1 0 auto;
}

.footer {
    flex-shrink: 0;
}

/*
 * Misc: print
 * -----------
 */
@media print {
    .no-print,
    .main-sidebar,
    .left-side,
    .main-header,
    .content-header {
        display: none !important;
    }

    .content-wrapper,
    .right-side,
    .main-footer {
        margin-left: 0 !important;
        min-height: 0 !important;
        -webkit-transform: translate(0, 0) !important;
        -ms-transform: translate(0, 0) !important;
        -o-transform: translate(0, 0) !important;
        transform: translate(0, 0) !important;
    }

    .fixed .content-wrapper,
    .fixed .right-side {
        padding-top: 0 !important;
    }

    .invoice {
        width: 100%;
        border: 0;
        margin: 0;
        padding: 0;
    }

    .invoice-col {
        float: left;
        width: 33.3333333%;
    }

    .table-responsive {
        overflow: auto;
    }

        .table-responsive > .table tr th,
        .table-responsive > .table tr td {
            white-space: normal !important;
        }
}
`, "",{"version":3,"sources":["webpack://./Content/layout.css"],"names":[],"mappings":"AAAA;;;;;;EAME;AACF;;;EAGE;AACF;;IAEI,YAAY;AAChB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,8EAA8E;IAC9E,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;AACA,WAAW;AACX;IACI,YAAY;IACZ,kBAAkB;AACtB;;IAEI;;QAEI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;;AAEJ;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;IACI,qDAAqD;AACzD;AACA;;EAEE;AACF;;IAEI,+EAA+E;IAC/E,yEAAyE;IACzE,qEAAqE;IACrE,+DAA+D;IAC/D,kBAAkB;IAClB,YAAY;AAChB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI;;QAEI,cAAc;IAClB;AACJ;;AAEA;IACI;;QAEI,iBAAiB;IACrB;AACJ;;AAEA;IACI;;QAEI,sCAAsC;QACtC,kCAAkC;QAClC,iCAAiC;QACjC,8BAA8B;IAClC;AACJ;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,sCAAsC;IACtC,aAAa;IACb,4BAA4B;IAC5B,oDAAoD;AACxD;AACA,iBAAiB;AACjB;;;IAGI,eAAe;AACnB;;AAEA;IACI,qCAAqC,EAAE,wBAAwB;IAC/D,sBAAsB,EAAE,cAAc;IACtC,wBAAwB,EAAE,YAAY;IACtC,qBAAqB,EAAE,UAAU;IACjC,qBAAqB,EAAE,2BAA2B;IAClD,6BAA6B,EAAE,mCAAmC;IAClE,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,MAAM;IACN,QAAQ;IACR,OAAO;AACX;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI;;QAEI,kBAAkB;IACtB;AACJ;;AAEA;IACI,eAAe;AACnB;;;AAGA;;;;;;;;IAQI,eAAe;IACf,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;AACpB;AACA,YAAY;AACZ;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;AACrB;AACA,iBAAiB;AACjB;;;;;;;;;;;;IAYI,0CAA0C;AAC9C;AACA,kBAAkB;AAClB;IACI,cAAc;AAClB;;IAEI;;;QAGI,aAAa;QACb,qBAAqB;QACrB,cAAc;IAClB;AACJ,gBAAgB;AAChB;IACI,qBAAqB;IACrB,eAAe;AACnB;;IAEI;QACI,kCAAkC;QAClC,cAAc;QACd,eAAe;IACnB;AACJ;;;EAGE;AACF;IACI,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;AACjB;;IAEI;QACI,gDAAgD;QAChD,2CAA2C;QAC3C,wCAAwC;QACxC,gBAAgB;QAChB,kBAAkB;QAClB,YAAY;QACZ,gBAAgB;QAChB,gBAAgB;IACpB;;AAEJ;IACI,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;IAEI;;QAEI,gCAAgC;QAChC,oCAAoC;IACxC;;IAEA;QACI,kCAAkC;QAClC,UAAU;IACd;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,kCAAkC;IACtC;;AAEJ;;IAEI,YAAY;AAChB;;AAEA;IACI;;QAEI,cAAc;QACd,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,SAAS;IACb;AACJ;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,sBAAsB;IACtB,kBAAkB;IAClB,wBAAwB;AAC5B;;IAEI;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;;QAEI,uBAAuB;IAC3B;;IAEA;QACI,aAAa;IACjB;;AAEJ;;;IAGI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,0CAA0C;IAC1C,qCAAqC;IACrC,kCAAkC;IAClC,cAAc;IACd,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,2DAA2D;IAC3D,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;IAEI;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;AAEJ;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;IAEI;QACI,SAAS;QACT,eAAe;IACnB;;QAEI;YACI,eAAe;YACf,qBAAqB;YACrB,iBAAiB;YACjB,gBAAgB;QACpB;;IAEJ;QACI,YAAY;QACZ,uBAAuB;QACvB,aAAa;QACb,gBAAgB;QAChB,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,kBAAkB;IACtB;;QAEI;YACI,4BAA4B;YAC5B,qBAAqB;YACrB,qBAAqB;QACzB;;YAEI;;;gBAGI,iBAAiB;YACrB;;QAEJ;YACI,iBAAiB;QACrB;;AAER;IACI;QACI,kBAAkB;QAClB,eAAe;QACf,MAAM;QACN,QAAQ;QACR,WAAW;QACX,+CAA+C;QAC/C,kBAAkB;IACtB;;QAEI;YACI,cAAc;QAClB;AACR;;AAEA;IACI,WAAW;IACX,SAAS;IACT,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,SAAS;QACT,WAAW;IACf;;QAEI;YACI,iBAAiB;YACjB,oBAAoB;YACpB,iBAAiB;QACrB;AACR;;AAEA;IACI;QACI,kBAAkB;IACtB;;QAEI;;YAEI,WAAW;YACX,WAAW;QACf;;QAEA;YACI,SAAS;QACb;;QAEA;YACI,YAAY;QAChB;AACR;;AAEA;IACI;QACI,sBAAsB;IAC1B;;QAEI;YACI,cAAc;YACd,kBAAkB;YAClB,MAAM;YACN,WAAW;QACf;AACR;AACA;;;EAGE;AACF;IACI,qDAAqD;IACrD,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,8EAA8E;IAC9E,wEAAwE;IACxE,oEAAoE;IACpE,8DAA8D;AAClE;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;AACA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE;AACF;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;;IAEI;;QAEI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,yBAAyB;QACzB,cAAc;QACd,kBAAkB;QAClB,UAAU;IACd;;QAEI;YACI,gBAAgB;YAChB,kBAAkB;QACtB;;QAEA;YACI,qBAAqB;YACrB,kBAAkB;YAClB,eAAe;YACf,eAAe;QACnB;;YAEI;;;gBAGI,iBAAiB;YACrB;;AAEZ;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;IAEI;QACI,kBAAkB;QAClB,SAAS;QACT,UAAU;IACd;;QAEI;YACI,2BAA2B;YAC3B,cAAc;QAClB;;YAEI;;;;;;;;wFAQ4E;YAC5E;gBACI,wDAAwD;YAC5D;;YAEA;;;;;;;;;;;;;;;;;;sGAkB0F;YAC1F;;gBAEI,iDAAiD;YACrD;;YAEA;;;;;;;;;gGASoF;YACpF;gBACI,6BAA6B;YACjC;;YAEA;;;gBAGI,WAAW;YACf;;QAEJ;;YAEI,iBAAiB;QACrB;;QAEA;YACI,eAAe;QACnB;;IAEJ;QACI,4BAA4B;QAC5B,eAAe;IACnB;;IAEA;;QAEI,WAAW;QACX,YAAY;QACZ,UAAU;QACV,kBAAkB;QAClB,uCAAuC;QACvC,kCAAkC;QAClC,+BAA+B;IACnC;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,WAAW;QACX,gBAAgB;IACpB;;IAEA;;QAEI,iCAAiC;QACjC,6BAA6B;QAC7B,4BAA4B;QAC5B,yBAAyB;IAC7B;;IAEA;QACI,cAAc;IAClB;AACJ;;EAEE;AACF;;;IAGI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;IAEI;QACI,eAAe;IACnB;;QAEI;YACI,4BAA4B;QAChC;;IAEJ;QACI,+BAA+B;IACnC;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,+BAA+B;IACnC;;IAEA;;;;;;;QAOI,wBAAwB;QACxB,gCAAgC;IACpC;;AAEJ;IACI,WAAW;AACf;;IAEI;QACI,cAAc;QACd,kBAAkB;QAClB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;AAEJ;IACI,iBAAiB;AACrB;;AAEA;;;IAGI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;AAEA;;IAEI,MAAM;IACN,iBAAiB;IACjB,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;IACrB,YAAY;AAChB;;IAEI;QACI,aAAa;IACjB;;AAEJ;IACI,SAAS;IACT,cAAc;AAClB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;;;IAGI,mBAAmB;IACnB,gBAAgB;AACpB;;IAEI;;QAEI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;QAEI;YACI,kBAAkB;YAClB,WAAW;YACX,QAAQ;YACR,gBAAgB;QACpB;AACR;;EAEE;AACF;IACI,eAAe;IACf,aAAa;IACb,SAAS;AACb;;AAEA;;IAEI,eAAe;IACf,MAAM;IACN,aAAa;IACb,gBAAgB;IAChB,0CAA0C;IAC1C,qCAAqC;IACrC,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,QAAQ;AACZ;;AAEA;;IAEI,QAAQ;AACZ;;AAEA;IACI;;;QAGI,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;;IAGI,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;IAEI;;QAEI,gBAAgB;QAChB,kBAAkB;QAClB,kCAAkC;QAClC,oCAAoC;IACxC;;QAEI;YACI,eAAe;QACnB;;AAER;;;;IAII,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;IAClB;;QAEI;YACI,mBAAmB;QACvB;AACR;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,eAAe;AACnB;;IAEI;QACI,cAAc;QACd,kBAAkB;IACtB;;QAEI;;YAEI,YAAY;YACZ,cAAc;QAClB;;QAEA;YACI,WAAW;QACf;;QAEA;YACI,aAAa;QACjB;;IAEJ;QACI,WAAW;QACX,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;QAEI;YACI,SAAS;QACb;;QAEA;YACI,SAAS;YACT,eAAe;QACnB;;IAEJ;QACI,SAAS;IACb;;AAEJ;IACI,cAAc;AAClB;;IAEI;;QAEI,mBAAmB;IACvB;;QAEI;YACI,sBAAsB;QAC1B;;YAEI;gBACI,mBAAmB;gBACnB,cAAc;YAClB;;gBAEI;;;oBAGI,0BAA0B;oBAC1B,4BAA4B;gBAChC;;oBAEI;;;wBAGI,mBAAmB;oBACvB;;oBAEA;wBACI,WAAW;oBACf;;YAER;;;;gBAII,mBAAmB;gBACnB,WAAW;YACf;;QAEJ;;YAEI,WAAW;QACf;;QAEA;YACI,mBAAmB;QACvB;;QAEA;YACI,cAAc;QAClB;;AAER;IACI,cAAc;AAClB;;IAEI;;QAEI,+CAA+C;QAC/C,qDAAqD;IACzD;;QAEI;YACI,6CAA6C;QACjD;;YAEI;gBACI,8CAA8C;gBAC9C,+BAA+B;YACnC;;gBAEI;;;oBAGI,iDAAiD;oBACjD,mDAAmD;gBACvD;;oBAEI;;;wBAGI,8CAA8C;oBAClD;;YAER;;;;gBAII,+CAA+C;gBAC/C,4BAA4B;YAChC;;QAEJ;;YAEI,4BAA4B;QAChC;;QAEA;YACI,kBAAkB;QACtB;;YAEI;gBACI,+CAA+C;YACnD;;YAEA;gBACI,cAAc;YAClB;AACZ;;;EAGE;AACF,uBAAuB;AACvB;IACI,gBAAgB;IAChB,yCAAyC;AAC7C;;IAEI;QACI,kCAAkC;IACtC;;QAEI;;;YAGI,kBAAkB;QACtB;;QAEA;YACI,qDAAqD;YACrD,4BAA4B;QAChC;;IAEJ;QACI,kDAAkD;IACtD;;AAEJ;;;IAGI,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,SAAS;AACb;;IAEI;;;QAGI,kBAAkB;IACtB;;QAEI;;;YAGI,2BAA2B;YAC3B,4BAA4B;YAC5B,6BAA6B;YAC7B,4BAA4B;YAC5B,+CAA+C;YAC/C,iBAAiB;YACjB,uDAAuD;YACvD,+BAA+B;YAC/B,eAAe;QACnB;;QAEA;;;YAGI,yBAAyB;YACzB,0BAA0B;YAC1B,+BAA+B;YAC/B,8BAA8B;YAC9B,eAAe;YACf,4CAA4C;YAC5C,iBAAiB;YACjB,uDAAuD;YACvD,uCAAuC;YACvC,kBAAkB;QACtB;;AAER;IACI;;;QAGI,iDAAiD;QACjD,uCAAuC;IAC3C;AACJ;;AAEA;;;IAGI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;;;IAGI,iBAAiB;IACjB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,kBAAkB;AACtB;;IAEI;;;QAGI,cAAc;QACd,mBAAmB;QACnB,+BAA+B;QAC/B,uDAAuD;IAC3D;;QAEI;;;YAGI,+CAA+C;YAC/C,qBAAqB;QACzB;;IAEJ;QACI,+BAA+B;QAC/B,gBAAgB;QAChB,uBAAuB;QACvB,aAAa;IACjB;;QAEI;;;YAGI,WAAW;QACf;;IAEJ;QACI,SAAS;QACT,kBAAkB;IACtB;;QAEI;YACI,2BAA2B;YAC3B,WAAW;YACX,YAAY;QAChB;;QAEA;YACI,UAAU;YACV,kBAAkB;YAClB,+BAA+B;YAC/B,eAAe;YACf,kBAAkB;QACtB;;YAEI;gBACI,qCAAqC;gBACrC,eAAe;gBACf,kBAAkB;gBAClB,MAAM;gBACN,QAAQ;YACZ;;QAEJ;YACI,kBAAkB;YAClB,eAAe;YACf,cAAc;QAClB;;QAEA;;YAEI,YAAY;YACZ,cAAc;QAClB;;QAEA;YACI,WAAW;QACf;;IAEJ;QACI,aAAa;IACjB;;QAEI;YACI,eAAe;YACf,UAAU;YACV,kBAAkB;YAClB,qCAAqC;QACzC;;QAEA;YACI,UAAU;YACV,SAAS;QACb;;AAER;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;AAChB;;IAEI;;QAEI,+BAA+B;QAC/B,8BAA8B;IAClC;;QAEI;YACI,aAAa;YACb,aAAa;YACb,kBAAkB;QACtB;;YAEI;gBACI,UAAU;gBACV,YAAY;gBACZ,WAAW;gBACX,iBAAiB;gBACjB,yBAAyB;gBACzB,sCAAsC;YAC1C;;YAEA;gBACI,UAAU;gBACV,WAAW;gBACX,+BAA+B;gBAC/B,eAAe;gBACf,gBAAgB;YACpB;;gBAEI;oBACI,cAAc;oBACd,eAAe;gBACnB;;QAER;YACI,aAAa;YACb,uDAAuD;YACvD,oDAAoD;QACxD;;YAEI;;gBAEI,YAAY;gBACZ,cAAc;YAClB;;YAEA;gBACI,WAAW;YACf;;YAEA;gBACI,uCAAuC;YAC3C;;AAEZ;IACI;QACI,iDAAiD;QACjD,uCAAuC;IAC3C;AACJ;;AAEA;IACI,qDAAqD;IACrD,aAAa;AACjB;;IAEI;;QAEI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,qCAAqC;IACzC;;AAEJ;IACI;QACI,qDAAqD;IACzD;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI;QACI,WAAW;QACX,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;AACJ;AACA;oEACoE;AACpE;IACI,uCAAuC;IACvC,oCAAoC;IACpC,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI;QACI,sDAAsD;QACtD,mCAAmC;QACnC,UAAU;IACd;;IAEA;QACI,uDAAuD;QACvD,mCAAmC;IACvC;;IAEA;QACI,sDAAsD;QACtD,UAAU;IACd;;IAEA;QACI,sDAAsD;IAC1D;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,8DAA8D;QAC9D,2CAA2C;QAC3C,UAAU;IACd;;IAEA;QACI,+DAA+D;QAC/D,2CAA2C;IAC/C;;IAEA;QACI,8DAA8D;QAC9D,UAAU;IACd;;IAEA;QACI,8DAA8D;IAClE;;IAEA;QACI,qCAAqC;IACzC;AACJ;AACA,iCAAiC;AACjC;IACI,kBAAkB;AACtB;;IAEI;QACI,kBAAkB;QAClB,QAAQ;QACR,UAAU;IACd;;AAEJ;IACI;QACI,YAAY;IAChB;;QAEI;YACI,gBAAgB;QACpB;;YAEI;gBACI,kBAAkB;gBAClB,SAAS;gBACT,UAAU;gBACV,6CAA6C;gBAC7C,sCAAsC;YAC1C;AACZ;AACA;;;EAGE;AACF;IACI,gBAAgB;IAChB,gBAAgB;IAChB,4CAA4C;AAChD;;IAEI;QACI,qBAAqB;QACrB,gBAAgB;IACpB;;IAEA;;;QAGI,kCAAkC;QAClC,UAAU;IACd;;IAEA;QACI,wBAAwB;QACxB,qBAAqB;QACrB,gBAAgB;IACpB;;AAEJ;IACI,cAAc;AAClB;;AAEA;;IAEI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;AACA,gBAAgB;AAChB;IACI,gBAAgB;IAChB,4CAA4C;IAC5C,4CAA4C;AAChD;AACA,kBAAkB;AAClB;;IAEI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;AACA,+CAA+C;AAC/C;IACI,iBAAiB;AACrB;;AAEA;;;IAGI,iBAAiB;AACrB;;AAEA;;;IAGI,iBAAiB;AACrB;AACA;;;EAGE;AACF;;IAEI,wBAAwB;IACxB,gBAAgB;AACpB;;IAEI;;;;QAII,kBAAkB;IACtB;QACI,mBAAmB;QACnB;;YAEI,YAAY;QAChB;;YAEI;;;;gBAII,kBAAkB;YACtB;;QAEJ;;YAEI,WAAW;QACf;;YAEI;;;;gBAII,kBAAkB;YACtB;;QAEJ;;YAEI,WAAW;QACf;;YAEI;;;;gBAII,kBAAkB;YACtB;QACJ,kBAAkB;QAClB;YACI,kBAAkB;YAClB,WAAW;YACX,aAAa;YACb,qBAAqB;YACrB,kBAAkB;QACtB;;YAEI;gBACI,WAAW;gBACX,kBAAkB;gBAClB,SAAS;YACb;;YAEA;;gBAEI,WAAW;YACf;;YAEA;;gBAEI,WAAW;YACf;;YAEA;;gBAEI,UAAU;YACd;;AAEZ;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;AACA,0DAA0D;AAC1D;IACI,SAAS;AACb;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,6MAA6M;IAC7M,wMAAwM;IACxM,qMAAqM;AACzM;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,6MAA6M;IAC7M,wMAAwM;IACxM,qMAAqM;AACzM;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,6MAA6M;IAC7M,wMAAwM;IACxM,qMAAqM;AACzM;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,6MAA6M;IAC7M,wMAAwM;IACxM,qMAAqM;AACzM;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,6MAA6M;IAC7M,wMAAwM;IACxM,qMAAqM;AACzM;AACA;;;EAGE;AACF;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,wCAAwC;AAC5C;;IAEI;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;QAClB,cAAc;QACd,WAAW;QACX,+BAA+B;QAC/B,cAAc;QACd,WAAW;QACX,8BAA8B;QAC9B,qBAAqB;IACzB;;QAEI;YACI,WAAW;YACX,+BAA+B;QACnC;;IAEJ;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;QACnB,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;QAEI;YACI,cAAc;YACd,cAAc;YACd,eAAe;YACf,eAAe;QACnB;;IAEJ;;QAEI,UAAU;IACd;;IAEA;QACI,mCAAmC;QACnC,8BAA8B;QAC9B,2BAA2B;QAC3B,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,UAAU;QACV,eAAe;QACf,0BAA0B;IAC9B;;IAEA;QACI,qBAAqB;QACrB,cAAc;IAClB;;QAEI;YACI,eAAe;QACnB;;AAER;IACI;QACI,kBAAkB;IACtB;;QAEI;YACI,aAAa;QACjB;;QAEA;YACI,eAAe;QACnB;AACR;AACA;;;EAGE;AACF;IACI,kBAAkB;IAClB,kBAAkB;IAClB,yCAAyC;IACzC,oDAAoD;IACpD,mBAAmB;IACnB,WAAW;IACX,wCAAwC;AAC5C;;IAEI;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gDAAgD;IACpD;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,uDAAuD;QACvD,SAAS;IACb;;QAEI;YACI,mBAAmB;QACvB;;IAEJ;QACI,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,sDAAsD;IAC1D;;IAEA;QACI,qDAAqD;IACzD;;IAEA;QACI,aAAa;IACjB;;QAEI;YACI,uBAAuB;QAC3B;;QAEA;;YAEI,8BAA8B;QAClC;;QAEA;YACI,gDAAgD;QACpD;;YAEI;gBACI,+BAA+B;gBAC/B,+CAA+C;gBAC/C,qDAAqD;YACzD;;gBAEI;;oBAEI,+BAA+B;gBACnC;;QAER;YACI,yBAAyB;QAC7B;;YAEI;gBACI,cAAc;gBACd,mBAAmB;gBACnB,yBAAyB;YAC7B;;gBAEI;;oBAEI,cAAc;gBAClB;;QAER;YACI,yBAAyB;QAC7B;;YAEI;gBACI,cAAc;gBACd,mBAAmB;gBACnB,yBAAyB;YAC7B;;gBAEI;;oBAEI,cAAc;gBAClB;;QAER;YACI,yBAAyB;QAC7B;;YAEI;gBACI,cAAc;gBACd,mBAAmB;gBACnB,yBAAyB;YAC7B;;gBAEI;;oBAEI,cAAc;gBAClB;;QAER;YACI,yBAAyB;QAC7B;;YAEI;gBACI,cAAc;gBACd,mBAAmB;gBACnB,yBAAyB;YAC7B;;gBAEI;;oBAEI,cAAc;gBAClB;;QAER;YACI,yBAAyB;QAC7B;;YAEI;gBACI,cAAc;gBACd,mBAAmB;gBACnB,yBAAyB;YAC7B;;gBAEI;;oBAEI,cAAc;gBAClB;;QAER;YACI,SAAS;YACT,gBAAgB;QACpB;;QAEA;YACI,WAAW;QACf;;IAEJ;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,4BAA4B;QAC5B,gBAAgB;QAChB,eAAe;QACf,oBAAoB;IACxB;;IAEA;;;;QAII,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,WAAW;QACX,YAAY;IAChB;;IAEA;;QAEI,WAAW;QACX,oCAAoC;QACpC,kBAAkB;IACtB;;QAEI;;YAEI,kBAAkB;YAClB,QAAQ;YACR,SAAS;YACT,kBAAkB;YAClB,iBAAiB;YACjB,4BAA4B;YAC5B,eAAe;QACnB;;QAEA;;YAEI,8BAA8B;QAClC;;AAER;;;;;;IAMI,YAAY;IACZ,cAAc;AAClB;;AAEA;;;IAGI,WAAW;AACf;;AAEA;IACI,4BAA4B;IAC5B,cAAc;IACd,aAAa;IACb,kBAAkB;AACtB;;IAEI;QACI,uDAAuD;IAC3D;;AAEJ;IACI,mBAAmB;AACvB;;AAEA;;;;IAII,qBAAqB;IACrB,eAAe;IACf,SAAS;IACT,cAAc;AAClB;;AAEA;;;IAGI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;AACZ;;IAEI;QACI,kBAAkB;IACtB;;IAEA;QACI,QAAQ;QACR,UAAU;IACd;;IAEA;QACI,uCAAuC;IAC3C;;AAEJ;IACI,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,cAAc;AAClB;;IAEI;;QAEI,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;AAEJ;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,+BAA+B;IAC/B,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,+BAA+B;IAC/B,8BAA8B;IAC9B,oDAAoD;IACpD,aAAa;IACb,+CAA+C;AACnD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,WAAW;QACX,kBAAkB;IACtB;AACJ;;AAEA;IACI,+CAA+C;AACnD;;IAEI;QACI,cAAc;QACd,oDAAoD;IACxD;;QAEI;;YAEI,YAAY;YACZ,cAAc;QAClB;;QAEA;YACI,WAAW;QACf;;QAEA;YACI,gBAAgB;QACpB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,WAAW;QACf;;IAEJ;QACI,iBAAiB;QACjB,kCAAkC;IACtC;;IAEA;QACI,4BAA4B;QAC5B,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;AACJ,sBAAsB;AACtB;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,cAAc;AAClB;;IAEI;QACI,kBAAkB;QAClB,aAAa;QACb,+CAA+C;QAC/C,kBAAkB;QAClB,8BAA8B;QAC9B,4BAA4B;IAChC;;QAEI;YACI,gBAAgB;QACpB;;QAEA;YACI,oBAAoB;QACxB;;QAEA;YACI,qBAAqB;YACrB,gBAAgB;YAChB,gBAAgB;QACpB;;QAEA;YACI,iBAAiB;YACjB,cAAc;QAClB;;QAEA;YACI,aAAa;YACb,YAAY;YACZ,cAAc;QAClB;;YAEI;;;gBAGI,iBAAiB;gBACjB,eAAe;YACnB;;QAEJ;YACI,qBAAqB;QACzB;;QAEA;YACI,kCAAkC;QACtC;;YAEI;gBACI,6BAA6B;gBAC7B,gBAAgB;YACpB;;YAEA;gBACI,0DAA0D;YAC9D;;IAER;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,qBAAqB;QACrB,YAAY;QACZ,aAAa;IACjB;AACJ,sGAAsG;AACtG;IACI,0BAA0B;AAC9B;;IAEI;QACI,mBAAmB;IACvB;;QAEI;;YAEI,YAAY;YACZ,cAAc;QAClB;;QAEA;YACI,WAAW;QACf;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,6BAA6B;YAC7B,kBAAkB;QACtB;;QAEA;YACI,yBAAyB;QAC7B;;QAEA;YACI,yBAAyB;QAC7B;;QAEA;YACI,iBAAiB;YACjB,iBAAiB;QACrB;;YAEI;gBACI,cAAc;gBACd,gBAAgB;YACpB;;QAEJ;YACI,kBAAkB;YAClB,+CAA+C;YAC/C,iBAAiB;YACjB,kBAAkB;YAClB,aAAa;QACjB;;YAEI;gBACI,iBAAiB;gBACjB,gBAAgB;gBAChB,eAAe;YACnB;;YAEA;;gBAEI,gBAAgB;gBAChB,eAAe;gBACf,kBAAkB;gBAClB,SAAS;YACb;;YAEA;;gBAEI,YAAY;gBACZ,cAAc;YAClB;;YAEA;gBACI,WAAW;YACf;;AAEZ;IACI,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;AACA;;;EAGE;AACF;IACI,cAAc;IACd,gBAAgB;IAChB,sCAAsC;IACtC,WAAW;IACX,wCAAwC;IACxC,kBAAkB;IAClB,mBAAmB;AACvB;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,8BAA8B;QAC9B,2BAA2B;QAC3B,WAAW;IACf;;QAEI;;YAEI,gBAAgB;QACpB;;YAEI;gBACI,sCAAsC;YAC1C;;AAEZ;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,6BAA6B;IAC7B,8BAA8B;IAC9B,cAAc;IACd,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;IAEI;QACI,eAAe;IACnB;;AAEJ;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;AACA;;;EAGE;AACF;IACI,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;AACpB;;IAEI;QACI,WAAW;QACX,kBAAkB;QAClB,MAAM;QACN,SAAS;QACT,UAAU;QACV,4CAA4C;QAC5C,UAAU;QACV,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;QAClB,mBAAmB;IACvB;;QAEI;;YAEI,YAAY;YACZ,cAAc;QAClB;;QAEA;YACI,WAAW;QACf;;QAEA;YACI,gDAAgD;YAChD,wCAAwC;YACxC,kBAAkB;YAClB,aAAa;YACb,sCAAsC;YACtC,4BAA4B;YAC5B,iBAAiB;YACjB,kBAAkB;YAClB,UAAU;YACV,kBAAkB;QACtB;;YAEI;gBACI,kCAAkC;gBAClC,YAAY;gBACZ,aAAa;gBACb,eAAe;YACnB;;YAEA;gBACI,SAAS;gBACT,kCAAkC;gBAClC,uDAAuD;gBACvD,aAAa;gBACb,eAAe;gBACf,gBAAgB;YACpB;;gBAEI;oBACI,gBAAgB;gBACpB;;YAEJ;;gBAEI,aAAa;YACjB;;QAEJ;;;YAGI,WAAW;YACX,YAAY;YACZ,eAAe;YACf,iBAAiB;YACjB,kBAAkB;YAClB,kCAAkC;YAClC,+CAA+C;YAC/C,kBAAkB;YAClB,kBAAkB;YAClB,UAAU;YACV,MAAM;QACV;;IAEJ;QACI,gBAAgB;QAChB,YAAY;QACZ,qBAAqB;QACrB,4CAA4C;QAC5C,kBAAkB;IACtB;;AAEJ;IACI,+CAA+C;IAC/C,6CAA6C;IAC7C,wBAAwB;IACxB,gBAAgB;AACpB;;IAEI;QACI,gDAAgD;IACpD;AACJ;;;EAGE;AACF;IACI,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;IAChB,6BAA6B;AACjC;;IAEI;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;QAChB,wBAAwB;QACxB,qBAAqB;QACrB,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,wDAAwD;QACxD,qDAAqD;QACrD,gDAAgD;IACpD;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;QAEI;YACI,kBAAkB;YAClB,MAAM;YACN,QAAQ;YACR,eAAe;YACf,gBAAgB;YAChB,gBAAgB;YAChB,iBAAiB;YACjB,UAAU;YACV,wBAAwB;YACxB,aAAa;YACb,uCAAuC;YACvC,eAAe;YACf,cAAc;QAClB;;AAER;IACI,qDAAqD;IACrD,4BAA4B;IAC5B,yCAAyC;AAC7C;;IAEI;;;QAGI,qDAAqD;IACzD;;AAEJ;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;IAEI;;;QAGI,yBAAyB;IAC7B;;AAEJ;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;IAEI;;;QAGI,yBAAyB;IAC7B;;AAEJ;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;IAEI;;;QAGI,yBAAyB;IAC7B;;AAEJ;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;IAEI;;;QAGI,yBAAyB;IAC7B;;AAEJ;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;IAEI;;;QAGI,yBAAyB;IAC7B;;AAEJ;IACI,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;AACf;;IAEI;;;QAGI,+BAA+B;QAC/B,sCAAsC;IAC1C;;AAEJ;IACI,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,sDAAsD;IACtD,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,kCAAkC;IAClC,6CAA6C;IAC7C,qDAAqD;IACrD,eAAe;AACnB;;IAEI;;;QAGI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,+CAA+C;QAC/C,4BAA4B;QAC5B,kBAAkB;IACtB;;IAEA;;QAEI,wDAAwD;QACxD,qDAAqD;QACrD,gDAAgD;IACpD;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,YAAY;QACZ,eAAe;QACf,gBAAgB;IACpB;AACJ;;;EAGE;AACF;IACI,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;IAC5B,kDAAkD;AACtD;;IAEI;QACI,WAAW;QACX,0BAA0B;IAC9B;;QAEI;YACI,WAAW;QACf;;IAEJ;QACI,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,4CAA4C;IAChD;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;AACJ;;;EAGE;AACF;IACI,kBAAkB;AACtB;;IAEI;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,4BAA4B;QAC5B,YAAY;QACZ,yBAAyB;IAC7B;;QAEI;YACI,YAAY;YACZ,yBAAyB;QAC7B;;IAEJ;QACI,WAAW;QACX,0BAA0B;IAC9B;;AAEJ;IACI,qBAAqB;AACzB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;AACA;;;EAGE;AACF;;;IAGI,4BAA4B;IAC5B,+CAA+C;AACnD;AACA,cAAc;AACd;IACI,gBAAgB;IAChB,iCAAiC;IACjC,4BAA4B;AAChC;;IAEI;;;QAGI,iBAAiB;IACrB;;AAEJ;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;AACA,gBAAgB;AAChB;IACI,gBAAgB;IAChB,aAAa;IACb,kCAAkC;IAClC,4BAA4B;AAChC;;AAEA;;IAEI,uBAAuB;IACvB,4BAA4B;IAC5B,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,oDAAoD;IACpD,kCAAkC;IAClC,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;AAC7B;AACA,aAAa;AACb;IACI,mBAAmB;IACnB,sCAAsC;IACtC,wCAAwC;IACxC,kBAAkB;AACtB;;IAEI;QACI,SAAS;QACT,mDAAmD;QACnD,4BAA4B;QAC5B,2BAA2B;IAC/B;;QAEI;YACI,iCAAiC;YACjC,mBAAmB;YACnB,iBAAiB;QACrB;;YAEI;gBACI,kCAAkC;YACtC;;YAEA;gBACI,4BAA4B;gBAC5B,gBAAgB;YACpB;;gBAEI;oBACI,kCAAkC;gBACtC;;gBAEA;;oBAEI,uBAAuB;oBACvB,SAAS;gBACb;;oBAEI;wBACI,kCAAkC;oBACtC;;YAER;;;gBAGI,yBAAyB;YAC7B;;YAEA;gBACI,yBAAyB;YAC7B;;gBAEI;;oBAEI,4CAA4C;oBAC5C,4BAA4B;gBAChC;;gBAEA;oBACI,6BAA6B;oBAC7B,iDAAiD;oBACjD,kDAAkD;gBACtD;;YAEJ;gBACI,cAAc;YAClB;;gBAEI;oBACI,8BAA8B;gBAClC;;QAER;YACI,sBAAsB;QAC1B;;YAEI;gBACI,YAAY;YAChB;;gBAEI;oBACI,eAAe;gBACnB;;oBAEI;wBACI,sBAAsB;oBAC1B;;oBAEA;wBACI,iDAAiD;wBACjD,+BAA+B;oBACnC;;QAEZ;YACI,iBAAiB;YACjB,eAAe;YACf,eAAe;YACf,4BAA4B;QAChC;;YAEI;;;gBAGI,iBAAiB;YACrB;;IAER;QACI,sCAAsC;QACtC,aAAa;QACb,+BAA+B;QAC/B,8BAA8B;IAClC;;IAEA;;QAEI,uBAAuB;QACvB,kCAAkC;IACtC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gDAAgD;IACpD;AACJ,eAAe;AACf;IACI,+CAA+C;IAC/C,kCAAkC;AACtC;;AAEA;IACI,2BAA2B;AAC/B;AACA;;;EAGE;AACF;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;IAEI;QACI,kBAAkB;QAClB,gDAAgD;QAChD,wCAAwC;QACxC,eAAe;QACf,sCAAsC;IAC1C;;QAEI;;YAEI,YAAY;YACZ,cAAc;QAClB;;QAEA;YACI,WAAW;QACf;;IAEJ;QACI,WAAW;IACf;;QAEI;YACI,WAAW;YACX,YAAY;QAChB;;IAEJ;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,kCAAkC;QAClC,gBAAgB;QAChB,mBAAmB;QACnB,uBAAuB;IAC3B;;AAEJ;IACI,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;IAChB,uDAAuD;AAC3D;;IAEI;QACI,sBAAsB;IAC1B;AACJ;;;EAGE;AACF;;;;;;IAMI,oDAAoD;AACxD;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gDAAgD;AACpD;;IAEI;;;;;;QAMI,gDAAgD;IACpD;;IAEA;;QAEI,wBAAwB;IAC5B;;AAEJ;;;IAGI,SAAS;AACb;AACA,2BAA2B;AAC3B;;;IAGI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;AACA;;;EAGE;AACF;IACI,qDAAqD;IACrD,4BAA4B;AAChC;AACA;;;EAGE;AACF;IACI,6BAA6B;IAC7B,4BAA4B;IAC5B,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;IAC7B,0BAA0B;IAC1B,aAAa;IACb,aAAa;IACb,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;IAEI;;QAEI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;;AAEJ;;IAEI,sDAAsD;IACtD,gDAAgD;IAChD,4CAA4C;IAC5C,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,+CAA+C;IAC/C,gDAAgD;IAChD,oBAAoB;IACpB,+BAA+B;AACnC;;IAEI;;QAEI,kBAAkB;QAClB,WAAW;QACX,SAAS;QACT,yBAAyB;QACzB,kDAAkD;QAClD,YAAY;QACZ,SAAS;QACT,QAAQ;QACR,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;;AAEJ;IACI,kBAAkB;IAClB,cAAc;AAClB;;IAEI;;QAEI,WAAW;QACX,UAAU;QACV,+BAA+B;QAC/B,iDAAiD;IACrD;;AAEJ;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;IACrC,iCAAiC;IACjC,gCAAgC;IAChC,6BAA6B;IAC7B,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,2CAA2C;IAC3C,aAAa;IACb,SAAS;AACb;;IAEI;;QAEI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;;AAEJ;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;IAEI;;QAEI,0BAA0B;IAC9B;;AAEJ;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;IAEI;;QAEI,0BAA0B;IAC9B;;AAEJ;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;IAEI;;QAEI,0BAA0B;IAC9B;;AAEJ;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;IAEI;;QAEI,0BAA0B;IAC9B;;AAEJ;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;IAEI;;QAEI,0BAA0B;IAC9B;AACJ;;;EAGE;AACF;IACI,UAAU;IACV,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;;IAEI;QACI,kBAAkB;QAClB,eAAe;QACf,YAAY;IAChB;;IAEA;;QAEI,kCAAkC;IACtC;;AAEJ;;IAEI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,eAAe;AACnB;AACA;;;EAGE;AACF;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,qBAAqB;IACrB,iBAAiB;AACrB;AACA;;;EAGE;AACF;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,kDAAkD;IAClD,0CAA0C;IAC1C,SAAS;AACb;;AAEA;IACI;QACI,kDAAkD;QAClD,0CAA0C;IAC9C;AACJ;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,qBAAqB;AACzB;AACA;;;EAGE;AACF;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,kBAAkB;AACtB;;IAEI;QACI,WAAW;QACX,YAAY;QACZ,sBAAsB;IAC1B;;AAEJ;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,iBAAiB;AACrB;;IAEI;QACI,kBAAkB;IACtB;;IAEA;QACI,SAAS;IACb;;QAEI;YACI,yBAAyB;YACzB,cAAc;YACd,eAAe;QACnB;;YAEI;;;gBAGI,WAAW;YACf;;YAEA;;;;gBAII,WAAW;YACf;AACZ;;;EAGE;AACF;IACI,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;IAEI;QACI,uDAAuD;IAC3D;;AAEJ;IACI,uDAAuD;IACvD,aAAa;AACjB;;IAEI;QACI,eAAe;QACf,SAAS;IACb;;IAEA;QACI,SAAS;QACT,kBAAkB;IACtB;;AAEJ;IACI,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6CAA6C;IAC7C,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,+CAA+C;AACnD;;AAEA;IACI,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,kCAAkC;IAClC,kBAAkB;AACtB;;IAEI;QACI,UAAU;IACd;;QAEI;YACI,eAAe;YACf,YAAY;QAChB;AACR;;;EAGE;AACF,qCAAqC;AACrC;IACI,+CAA+C;AACnD;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;IAEI;QACI,4BAA4B;IAChC;;AAEJ;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;AACA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA,gDAAgD;AAChD;IACI,kBAAkB;IAClB,UAAU;IACV,sCAAsC;IACtC,kBAAkB;IAClB,2BAA2B;IAC3B,YAAY;AAChB;AACA,eAAe;AACf;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,sCAAsC;IACtC,YAAY;IACZ,WAAW;AACf;;IAEI;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;IAChB;AACJ,qDAAqD;AACrD;IACI,iBAAiB;AACrB;;IAEI;QACI,SAAS;IACb;;IAEA;QACI,4CAA4C;QAC5C,SAAS;QACT,eAAe;IACnB;;AAEJ;IACI,gBAAgB;AACpB;AACA;;;EAGE;AACF;;IAEI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;IAEI;;QAEI,4BAA4B;IAChC;;AAEJ;;IAEI,+CAA+C;AACnD;;AAEA;;IAEI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;;QAEI,UAAU;QACV,gBAAgB;IACpB;AACJ;;AAEA;;IAEI,sCAAsC;IACtC,aAAa;IACb,aAAa;IACb,kCAAkC;AACtC;;IAEI;;QAEI,kCAAkC;IACtC;;AAEJ;;IAEI,SAAS;IACT,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;AACA;;;EAGE;AACF;IACI,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI;QACI,WAAW;QACX,kBAAkB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;AACA;;;EAGE;AACF;IACI,kBAAkB;IAClB,sCAAsC;IACtC,gDAAgD;IAChD,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;AACA;;;EAGE;AACF;IACI,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,gDAAgD;AACpD;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,uDAAuD;IACvD,mBAAmB;IACnB,oBAAoB;IACpB,kCAAkC;AACtC;;IAEI;QACI,gBAAgB;QAChB,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;;;;;;EAOE;AACF;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;IAEI;QACI,kBAAkB;QAClB,OAAO;QACP,MAAM;QACN,SAAS;QACT,WAAW;QACX,iBAAiB;QACjB,gBAAgB;QAChB,kBAAkB;QAClB,0CAA0C;IAC9C;;IAEA;QACI,kBAAkB;IACtB;;QAEI;YACI,iBAAiB;YACjB,WAAW;YACX,gBAAgB;QACpB;;IAEJ;QACI,kBAAkB;IACtB;;QAEI;YACI,iBAAiB;YACjB,WAAW;YACX,gBAAgB;QACpB;;IAEJ;QACI,kBAAkB;IACtB;;QAEI;YACI,iBAAiB;YACjB,WAAW;YACX,gBAAgB;QACpB;;AAER;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,UAAU;AACd;;IAEI;QACI,kBAAkB;QAClB,OAAO;QACP,MAAM;QACN,SAAS;QACT,WAAW;QACX,iBAAiB;QACjB,gBAAgB;QAChB,kBAAkB;QAClB,0CAA0C;IAC9C;;IAEA;QACI,kBAAkB;IACtB;;QAEI;YACI,iBAAiB;YACjB,WAAW;YACX,gBAAgB;QACpB;;IAEJ;QACI,kBAAkB;IACtB;;QAEI;YACI,iBAAiB;YACjB,WAAW;YACX,gBAAgB;QACpB;;IAEJ;QACI,kBAAkB;IACtB;;QAEI;YACI,iBAAiB;YACjB,WAAW;YACX,gBAAgB;QACpB;;IAEJ;QACI,YAAY;QACZ,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,eAAe;QACf,gBAAgB;IACpB;;AAEJ;IACI,cAAc;IACd,yBAAyB;IACzB,gCAAgC;AACpC;;IAEI;;QAEI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,+CAA+C;IACnD;;AAEJ;IACI,cAAc;IACd,yBAAyB;IACzB,gCAAgC;AACpC;;IAEI;;QAEI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,+CAA+C;IACnD;;AAEJ;IACI,cAAc;IACd,yBAAyB;IACzB,gCAAgC;AACpC;;IAEI;;QAEI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,+CAA+C;IACnD;;AAEJ;IACI,cAAc;IACd,yBAAyB;IACzB,gCAAgC;AACpC;;IAEI;;QAEI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,+CAA+C;IACnD;;AAEJ;IACI,cAAc;IACd,yBAAyB;IACzB,gCAAgC;AACpC;;IAEI;;QAEI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,+CAA+C;IACnD;;AAEJ;IACI,cAAc;IACd,yBAAyB;IACzB,gCAAgC;AACpC;;IAEI;;QAEI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,+CAA+C;IACnD;;AAEJ;IACI,cAAc;IACd,yBAAyB;IACzB,gCAAgC;AACpC;;IAEI;;QAEI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,sBAAsB;IAC1B;;IAEA;QACI,+BAA+B;QAC/B,+CAA+C;IACnD;;AAEJ;IACI,cAAc;IACd,yBAAyB;IACzB,gCAAgC;AACpC;;IAEI;;QAEI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,+CAA+C;IACnD;;AAEJ;IACI,cAAc;IACd,yBAAyB;IACzB,gCAAgC;AACpC;;IAEI;;QAEI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,+CAA+C;IACnD;;AAEJ;IACI,cAAc;IACd,yBAAyB;IACzB,gCAAgC;AACpC;;IAEI;;QAEI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,+CAA+C;IACnD;;AAEJ;IACI,cAAc;IACd,yBAAyB;IACzB,gCAAgC;AACpC;;IAEI;;QAEI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,+CAA+C;IACnD;;AAEJ;IACI,cAAc;IACd,yBAAyB;IACzB,gCAAgC;AACpC;;IAEI;;QAEI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,+CAA+C;IACnD;;AAEJ;IACI,cAAc;IACd,yBAAyB;IACzB,gCAAgC;AACpC;;IAEI;;QAEI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,+CAA+C;IACnD;;AAEJ;IACI,+BAA+B;IAC/B,oDAAoD;IACpD,gCAAgC;AACpC;;IAEI;;QAEI,+BAA+B;QAC/B,oDAAoD;QACpD,gCAAgC;IACpC;;IAEA;QACI,+BAA+B;QAC/B,oDAAoD;QACpD,gCAAgC;IACpC;;IAEA;;;QAGI,+BAA+B;QAC/B,oDAAoD;QACpD,gCAAgC;IACpC;;IAEA;;;QAGI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,yBAAyB;IAC7B;;AAEJ;IACI,cAAc;IACd,yBAAyB;IACzB,gCAAgC;AACpC;;IAEI;;QAEI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,+CAA+C;IACnD;;AAEJ;IACI,cAAc;IACd,yBAAyB;IACzB,gCAAgC;AACpC;;IAEI;;QAEI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,+CAA+C;IACnD;;AAEJ;IACI,cAAc;IACd,yBAAyB;IACzB,gCAAgC;AACpC;;IAEI;;QAEI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,+CAA+C;IACnD;;AAEJ;IACI,cAAc;IACd,yBAAyB;IACzB,gCAAgC;AACpC;;IAEI;;QAEI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,+CAA+C;IACnD;;AAEJ;IACI,cAAc;IACd,yBAAyB;IACzB,gCAAgC;AACpC;;IAEI;;QAEI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,+CAA+C;IACnD;;AAEJ;IACI,cAAc;IACd,yBAAyB;IACzB,gCAAgC;AACpC;;IAEI;;QAEI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,cAAc;QACd,yBAAyB;QACzB,gCAAgC;IACpC;;IAEA;;;QAGI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,+CAA+C;IACnD;AACJ;;;EAGE;AACF;IACI,+CAA+C;IAC/C,sBAAsB;IACtB,4BAA4B;IAC5B,yCAAyC;IACzC,gDAAgD;AACpD;;IAEI;;;QAGI,qDAAqD;IACzD;;AAEJ;IACI,eAAe;IACf,kBAAkB;IAClB,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;;IAEI,cAAc;IACd,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;IAEI;QACI,WAAW;QACX,eAAe;QACf,iBAAiB;QACjB,iBAAiB;IACrB;;QAEI;YACI,iDAAiD;YACjD,2CAA2C;YAC3C,uCAAuC;YACvC,iCAAiC;QACrC;;YAEI;gBACI,gCAAgC;gBAChC,4BAA4B;gBAC5B,2BAA2B;gBAC3B,wBAAwB;YAC5B;;AAEZ;IACI,mCAAmC;IACnC,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;IACxC,yCAAyC;IACzC,kBAAkB;IAClB,YAAY;AAChB;;IAEI;QACI,6CAA6C;IACjD;AACJ;;;EAGE;AACF;;;;;;IAMI,aAAa;AACjB;;AAEA;;IAEI,gDAAgD;IAChD,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gDAAgD;IAChD,gBAAgB;IAChB,2BAA2B,EAAE,WAAW;AAC5C;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;IAEI;QACI,aAAa;IACjB;;AAEJ;;IAEI,gDAAgD;AACpD;;IAEI;;QAEI,aAAa;IACjB;;AAEJ;;IAEI,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kDAAkD;AACtD;;IAEI;;QAEI,4BAA4B;IAChC;;AAEJ;IACI,gDAAgD;IAChD,gBAAgB;AACpB;;IAEI;QACI,qBAAqB;IACzB;;AAEJ;IACI,4CAA4C;AAChD;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;AACnC;;IAEI;QACI,WAAW;IACf;;AAEJ;IACI,mBAAmB;AACvB;;AAEA;;;;IAII,WAAW;AACf;;IAEI;;;;QAII,0CAA0C;IAC9C;;IAEA;;;;;;;;QAQI,kCAAkC;IACtC;AACJ;;;EAGE;AACF;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,kBAAkB;AACtB;;IAEI;QACI,mBAAmB;IACvB;;IAEA;QACI,SAAS;QACT,UAAU;QACV,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,yBAAyB;IAC7B;;AAEJ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IA2DI,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;IAC5B,gEAAgE;AACpE;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;;;;IAMI,oCAAoC;AACxC;;AAEA;;;;;IAKI,oCAAoC;AACxC;;AAEA;;;;;IAKI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;IAGI,oCAAoC;AACxC;;AAEA;;;;;IAKI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,4BAA4B;IAC5B,iEAAiE;AACrE;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;IAGI,oCAAoC;AACxC;;AAEA;;;IAGI,oCAAoC;AACxC;;AAEA;;;IAGI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;IAGI,oCAAoC;AACxC;;AAEA;;;IAGI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;IAEI;;QAEI,cAAc;IAClB;;AAEJ;IACI,kCAAkC;AACtC;;IAEI;;QAEI,kCAAkC;IACtC;;AAEJ;IACI,wBAAwB;AAC5B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;;;;IAKI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;;IAGI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,sHAAsH;IACtH,oEAAoE;IACpE,oFAAoF;IACpF,2DAA2D;IAC3D,6HAA6H;IAC7H,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,sHAAsH;IACtH,oEAAoE;IACpE,oFAAoF;IACpF,2DAA2D;IAC3D,6HAA6H;IAC7H,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,sHAAsH;IACtH,oEAAoE;IACpE,oFAAoF;IACpF,2DAA2D;IAC3D,6HAA6H;IAC7H,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,sHAAsH;IACtH,oEAAoE;IACpE,oFAAoF;IACpF,2DAA2D;IAC3D,6HAA6H;IAC7H,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,sHAAsH;IACtH,oEAAoE;IACpE,oFAAoF;IACpF,2DAA2D;IAC3D,6HAA6H;IAC7H,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,sHAAsH;IACtH,oEAAoE;IACpE,oFAAoF;IACpF,2DAA2D;IAC3D,6HAA6H;IAC7H,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,sHAAsH;IACtH,oEAAoE;IACpE,oFAAoF;IACpF,2DAA2D;IAC3D,6HAA6H;IAC7H,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,sHAAsH;IACtH,oEAAoE;IACpE,oFAAoF;IACpF,2DAA2D;IAC3D,6HAA6H;IAC7H,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,sHAAsH;IACtH,oEAAoE;IACpE,oFAAoF;IACpF,2DAA2D;IAC3D,6HAA6H;IAC7H,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,sHAAsH;IACtH,oEAAoE;IACpE,oFAAoF;IACpF,2DAA2D;IAC3D,6HAA6H;IAC7H,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,+CAA+C;IAC/C,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,kCAAkC;AACtC;;IAEI;QACI,4BAA4B;IAChC;;AAEJ;IACI,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;;;IAGI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,eAAe;AACnB;;AAEA;;;IAGI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;;;;;IAKI,WAAW;AACf;;AAEA;;;IAGI,sBAAsB;IACtB,uBAAuB;AAC3B;;IAEI;QACI,iBAAiB;IACrB;;AAEJ;IACI,WAAW;IACX,YAAY;AAChB;;IAEI;QACI,iBAAiB;IACrB;;AAEJ;IACI,YAAY;IACZ,aAAa;AACjB;;IAEI;QACI,kBAAkB;IACtB;;AAEJ;IACI,gDAAgD;IAChD,YAAY;AAChB;;AAEA;IACI,gDAAgD;IAChD,YAAY;AAChB;;AAEA;IACI,gDAAgD;IAChD,YAAY;IACZ,mBAAmB;IACnB,+CAA+C;AACnD;;IAEI;QACI,gBAAgB;QAChB,iBAAiB;QACjB,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,kCAAkC;IACtC;;AAEJ;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,+CAA+C;IAC/C,8CAA8C;IAC9C,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;IAEI;QACI,UAAU;QACV,0BAA0B;IAC9B;;AAEJ;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;IAEI;;QAEI,sBAAsB;IAC1B;;AAEJ;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;EAGE;AACF;IACI;;;;;QAKI,wBAAwB;IAC5B;;IAEA;;;QAGI,yBAAyB;QACzB,wBAAwB;QACxB,6CAA6C;QAC7C,yCAAyC;QACzC,wCAAwC;QACxC,qCAAqC;IACzC;;IAEA;;QAEI,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,SAAS;QACT,SAAS;QACT,UAAU;IACd;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;;QAEI;;YAEI,8BAA8B;QAClC;AACR","sourcesContent":["/*!\r\n *   AdminLTE v2.4.5\r\n *   Author: Almsaeed Studio\r\n *\t Website: Almsaeed Studio <https://adminlte.io>\r\n *   License: Open source - MIT\r\n *           Please visit http://opensource.org/licenses/MIT for more information\r\n */\r\n/*\r\n * Core: General Layout Style\r\n * -------------------------\r\n */\r\nhtml,\r\nbody {\r\n    height: 100%;\r\n}\r\n\r\n.layout-boxed html,\r\n.layout-boxed body {\r\n    height: 100%;\r\n}\r\n\r\nbody {\r\n    font-family: 'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif;\r\n    font-weight: 400;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n}\r\n/* Layout */\r\n.wrapper {\r\n    height: 100%;\r\n    position: relative;\r\n}\r\n\r\n    .wrapper:before,\r\n    .wrapper:after {\r\n        content: \" \";\r\n        display: table;\r\n    }\r\n\r\n    .wrapper:after {\r\n        clear: both;\r\n    }\r\n\r\n.layout-boxed .wrapper {\r\n    max-width: 1250px;\r\n    margin: 0 auto;\r\n    min-height: 100%;\r\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);\r\n    position: relative;\r\n}\r\n\r\n.layout-boxed {\r\n    background-color: var(--mu-superficie-sutil, #f9fafc);\r\n}\r\n/*\r\n * Content Wrapper - contains the main content\r\n */\r\n.content-wrapper,\r\n.main-footer {\r\n    -webkit-transition: -webkit-transform 0.3s ease-in-out, margin 0.3s ease-in-out;\r\n    -moz-transition: -moz-transform 0.3s ease-in-out, margin 0.3s ease-in-out;\r\n    -o-transition: -o-transform 0.3s ease-in-out, margin 0.3s ease-in-out;\r\n    transition: transform 0.3s ease-in-out, margin 0.3s ease-in-out;\r\n    margin-left: 230px;\r\n    z-index: 820;\r\n}\r\n\r\n.layout-top-nav .content-wrapper,\r\n.layout-top-nav .main-footer {\r\n    margin-left: 0;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .content-wrapper,\r\n    .main-footer {\r\n        margin-left: 0;\r\n    }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .sidebar-collapse .content-wrapper,\r\n    .sidebar-collapse .main-footer {\r\n        margin-left: 50px;\r\n    }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .sidebar-open .content-wrapper,\r\n    .sidebar-open .main-footer {\r\n        -webkit-transform: translate(230px, 0);\r\n        -ms-transform: translate(230px, 0);\r\n        -o-transform: translate(230px, 0);\r\n        transform: translate(230px, 0);\r\n    }\r\n}\r\n\r\n.content-wrapper {\r\n    min-height: 100%;\r\n    /*background-color: #ecf0f5;*/\r\n    z-index: 800;\r\n}\r\n\r\n.main-footer {\r\n    background: var(--mu-superficie, #fff);\r\n    padding: 15px;\r\n    color: var(--mu-texto, #444);\r\n    border-top: 1px solid var(--mu-borda-forte, #d2d6de);\r\n}\r\n/* Fixed layout */\r\n.fixed .main-header,\r\n.fixed .main-sidebar,\r\n.fixed .left-side {\r\n    position: fixed;\r\n}\r\n\r\n.wrapword {\r\n    white-space: -moz-pre-wrap !important; /* Mozilla, since 1999 */\r\n    white-space: -pre-wrap; /* Opera 4-6 */\r\n    white-space: -o-pre-wrap; /* Opera 7 */\r\n    white-space: pre-wrap; /* css-3 */\r\n    word-wrap: break-word; /* Internet Explorer 5.5+ */\r\n    white-space: -webkit-pre-wrap; /* Newer versions of Chrome/Safari*/\r\n    word-break: wrapword;\r\n    white-space: normal;\r\n}\r\n\r\n.fixed .main-header {\r\n    top: 0;\r\n    right: 0;\r\n    left: 0;\r\n}\r\n\r\n.fixed .content-wrapper,\r\n.fixed .right-side {\r\n    padding-top: 100px;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .fixed .content-wrapper,\r\n    .fixed .right-side {\r\n        padding-top: 100px;\r\n    }\r\n}\r\n\r\n.fixed.layout-boxed .wrapper {\r\n    max-width: 100%;\r\n}\r\n\r\n\r\n.hold-transition .content-wrapper,\r\n.hold-transition .right-side,\r\n.hold-transition .main-footer,\r\n.hold-transition .main-sidebar,\r\n.hold-transition .left-side,\r\n.hold-transition .main-header .navbar,\r\n.hold-transition .main-header .logo,\r\n.hold-transition .menu-open .fa-angle-left {\r\n    /* Fix for IE */\r\n    -webkit-transition: none;\r\n    -o-transition: none;\r\n    transition: none;\r\n}\r\n/* Content */\r\n.content {\r\n    min-height: 250px;\r\n    /*padding: 15px 15px 0 15px;*/\r\n    padding: 1px 10px 0 5px;\r\n    margin-right: auto;\r\n    margin-left: auto;\r\n}\r\n/* H1 - H6 font */\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\n.h1,\r\n.h2,\r\n.h3,\r\n.h4,\r\n.h5,\r\n.h6 {\r\n    font-family: 'Source Sans Pro', sans-serif;\r\n}\r\n/* General Links */\r\na {\r\n    color: #3c8dbc;\r\n}\r\n\r\n    a:hover,\r\n    a:active,\r\n    a:focus {\r\n        outline: none;\r\n        text-decoration: none;\r\n        color: #72afd2;\r\n    }\r\n/* Page Header */\r\n.page-header {\r\n    margin: 10px 0 20px 0;\r\n    font-size: 22px;\r\n}\r\n\r\n    .page-header > small {\r\n        color: var(--mu-texto-suave, #666);\r\n        display: block;\r\n        margin-top: 5px;\r\n    }\r\n/*\r\n * Component: Main Header\r\n * ----------------------\r\n */\r\n.main-header {\r\n    position: relative;\r\n    max-height: 108px;\r\n    z-index: 1030;\r\n}\r\n\r\n    .main-header .navbar {\r\n        -webkit-transition: margin-left 0.3s ease-in-out;\r\n        -o-transition: margin-left 0.3s ease-in-out;\r\n        transition: margin-left 0.3s ease-in-out;\r\n        margin-bottom: 0;\r\n        margin-left: 230px;\r\n        border: none;\r\n        min-height: 50px;\r\n        border-radius: 0;\r\n    }\r\n\r\n.layout-top-nav .main-header .navbar {\r\n    margin-left: 0;\r\n}\r\n\r\n.main-header #navbar-search-input.form-control {\r\n    background: rgba(255, 255, 255, 0.2);\r\n    border-color: transparent;\r\n}\r\n\r\n    .main-header #navbar-search-input.form-control:focus,\r\n    .main-header #navbar-search-input.form-control:active {\r\n        border-color: rgba(0, 0, 0, 0.1);\r\n        background: rgba(255, 255, 255, 0.9);\r\n    }\r\n\r\n    .main-header #navbar-search-input.form-control::-moz-placeholder {\r\n        color: var(--mu-texto-desab, #ccc);\r\n        opacity: 1;\r\n    }\r\n\r\n    .main-header #navbar-search-input.form-control:-ms-input-placeholder {\r\n        color: var(--mu-texto-desab, #ccc);\r\n    }\r\n\r\n    .main-header #navbar-search-input.form-control::-webkit-input-placeholder {\r\n        color: var(--mu-texto-desab, #ccc);\r\n    }\r\n\r\n.main-header .navbar-custom-menu,\r\n.main-header .navbar-right {\r\n    float: right;\r\n}\r\n\r\n@media (max-width: 991px) {\r\n    .main-header .navbar-custom-menu a,\r\n    .main-header .navbar-right a {\r\n        color: inherit;\r\n        background: transparent;\r\n    }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .main-header .navbar-right {\r\n        float: none;\r\n    }\r\n\r\n    .navbar-collapse .main-header .navbar-right {\r\n        margin: 7.5px -15px;\r\n    }\r\n\r\n    .main-header .navbar-right > li {\r\n        color: inherit;\r\n        border: 0;\r\n    }\r\n}\r\n\r\n.main-header .sidebar-toggle {\r\n    float: left;\r\n    background-color: transparent;\r\n    background-image: none;\r\n    padding: 15px 15px;\r\n    font-family: fontAwesome;\r\n}\r\n\r\n    .main-header .sidebar-toggle:before {\r\n        content: \"\\f0c9\";\r\n    }\r\n\r\n    .main-header .sidebar-toggle:hover {\r\n        color: #fff;\r\n    }\r\n\r\n    .main-header .sidebar-toggle:focus,\r\n    .main-header .sidebar-toggle:active {\r\n        background: transparent;\r\n    }\r\n\r\n    .main-header .sidebar-toggle .icon-bar {\r\n        display: none;\r\n    }\r\n\r\n.main-header .navbar .nav > li.user > a > .fa,\r\n.main-header .navbar .nav > li.user > a > .glyphicon,\r\n.main-header .navbar .nav > li.user > a > .ion {\r\n    margin-right: 5px;\r\n}\r\n\r\n.main-header .navbar .nav > li > a > .label {\r\n    position: absolute;\r\n    top: 9px;\r\n    right: 7px;\r\n    text-align: center;\r\n    font-size: 9px;\r\n    padding: 2px 3px;\r\n    line-height: .9;\r\n}\r\n\r\n.main-header .logo {\r\n    -webkit-transition: width 0.3s ease-in-out;\r\n    -o-transition: width 0.3s ease-in-out;\r\n    transition: width 0.3s ease-in-out;\r\n    display: block;\r\n    float: left;\r\n    height: 50px;\r\n    font-size: 20px;\r\n    line-height: 50px;\r\n    text-align: center;\r\n    width: 230px;\r\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\r\n    padding: 0 15px;\r\n    font-weight: 300;\r\n    overflow: hidden;\r\n}\r\n\r\n    .main-header .logo .logo-lg {\r\n        display: block;\r\n    }\r\n\r\n    .main-header .logo .logo-mini {\r\n        display: none;\r\n    }\r\n\r\n.main-header .navbar-brand {\r\n    color: #fff;\r\n}\r\n\r\n.content-header {\r\n    position: relative;\r\n    padding: 15px 15px 0 15px;\r\n}\r\n\r\n    .content-header > h1 {\r\n        margin: 0;\r\n        font-size: 24px;\r\n    }\r\n\r\n        .content-header > h1 > small {\r\n            font-size: 15px;\r\n            display: inline-block;\r\n            padding-left: 4px;\r\n            font-weight: 300;\r\n        }\r\n\r\n    .content-header > .breadcrumb {\r\n        float: right;\r\n        background: transparent;\r\n        margin-top: 0;\r\n        margin-bottom: 0;\r\n        font-size: 12px;\r\n        padding: 7px 5px;\r\n        position: absolute;\r\n        top: 15px;\r\n        right: 10px;\r\n        border-radius: 2px;\r\n    }\r\n\r\n        .content-header > .breadcrumb > li > a {\r\n            color: var(--mu-texto, #444);\r\n            text-decoration: none;\r\n            display: inline-block;\r\n        }\r\n\r\n            .content-header > .breadcrumb > li > a > .fa,\r\n            .content-header > .breadcrumb > li > a > .glyphicon,\r\n            .content-header > .breadcrumb > li > a > .ion {\r\n                margin-right: 5px;\r\n            }\r\n\r\n        .content-header > .breadcrumb > li + li:before {\r\n            content: '>\\00a0';\r\n        }\r\n\r\n@media (max-width: 991px) {\r\n    .content-header > .breadcrumb {\r\n        position: relative;\r\n        margin-top: 5px;\r\n        top: 0;\r\n        right: 0;\r\n        float: none;\r\n        background: var(--mu-superficie-forte, #d2d6de);\r\n        padding-left: 10px;\r\n    }\r\n\r\n        .content-header > .breadcrumb li:before {\r\n            color: #97a0b3;\r\n        }\r\n}\r\n\r\n.navbar-toggle {\r\n    color: #fff;\r\n    border: 0;\r\n    margin: 0;\r\n    padding: 15px 15px;\r\n}\r\n\r\n@media (max-width: 991px) {\r\n    .navbar-custom-menu .navbar-nav > li {\r\n        float: left;\r\n    }\r\n\r\n    .navbar-custom-menu .navbar-nav {\r\n        margin: 0;\r\n        float: left;\r\n    }\r\n\r\n        .navbar-custom-menu .navbar-nav > li > a {\r\n            padding-top: 15px;\r\n            padding-bottom: 15px;\r\n            line-height: 20px;\r\n        }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .main-header {\r\n        position: relative;\r\n    }\r\n\r\n        .main-header .logo,\r\n        .main-header .navbar {\r\n            width: 100%;\r\n            float: none;\r\n        }\r\n\r\n        .main-header .navbar {\r\n            margin: 0;\r\n        }\r\n\r\n        .main-header .navbar-custom-menu {\r\n            float: right;\r\n        }\r\n}\r\n\r\n@media (max-width: 991px) {\r\n    .navbar-collapse.pull-left {\r\n        float: none !important;\r\n    }\r\n\r\n        .navbar-collapse.pull-left + .navbar-custom-menu {\r\n            display: block;\r\n            position: absolute;\r\n            top: 0;\r\n            right: 40px;\r\n        }\r\n}\r\n/*\r\n * Component: Sidebar\r\n * ------------------\r\n */\r\n.main-sidebar {\r\n    background-color: var(--mu-superficie-sutil, #f2f2f2);\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    padding-top: 118px;\r\n    min-height: 100%;\r\n    width: 219px;\r\n    z-index: 810;\r\n    -webkit-transition: -webkit-transform 0.3s ease-in-out, width 0.3s ease-in-out;\r\n    -moz-transition: -moz-transform 0.3s ease-in-out, width 0.3s ease-in-out;\r\n    -o-transition: -o-transform 0.3s ease-in-out, width 0.3s ease-in-out;\r\n    transition: transform 0.3s ease-in-out, width 0.3s ease-in-out;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .main-sidebar {\r\n        padding-top: 100px;\r\n    }\r\n}\r\n/*@media (max-width: 767px) {\r\n  .main-sidebar {\r\n    -webkit-transform: translate(-230px, 0);\r\n    -ms-transform: translate(-230px, 0);\r\n    -o-transform: translate(-230px, 0);\r\n    transform: translate(-230px, 0);\r\n    background-color: #f2f2f2;\r\n  }\r\n}\r\n@media (min-width: 768px) {\r\n  .sidebar-collapse .main-sidebar {\r\n    -webkit-transform: translate(-230px, 0);\r\n    -ms-transform: translate(-230px, 0);\r\n    -o-transform: translate(-230px, 0);\r\n    transform: translate(-230px, 0);\r\n  }\r\n}\r\n@media (max-width: 767px) {\r\n  .sidebar-open .main-sidebar {\r\n    -webkit-transform: translate(0, 0);\r\n    -ms-transform: translate(0, 0);\r\n    -o-transform: translate(0, 0);\r\n    transform: translate(0, 0);\r\n  }\r\n}*/\r\n.sidebar-inner {\r\n    padding-bottom: 10px;\r\n}\r\n\r\n.sidebar-form input:focus {\r\n    border-color: transparent;\r\n}\r\n\r\n.user-panel {\r\n    position: relative;\r\n    width: 100%;\r\n    padding: 10px;\r\n    overflow: hidden;\r\n}\r\n\r\n    .user-panel:before,\r\n    .user-panel:after {\r\n        content: \" \";\r\n        display: table;\r\n    }\r\n\r\n    .user-panel:after {\r\n        clear: both;\r\n    }\r\n\r\n    .user-panel > .image > img {\r\n        width: 100%;\r\n        max-width: 45px;\r\n        height: auto;\r\n    }\r\n\r\n    .user-panel > .info {\r\n        padding: 5px 5px 5px 15px;\r\n        line-height: 1;\r\n        position: absolute;\r\n        left: 55px;\r\n    }\r\n\r\n        .user-panel > .info > p {\r\n            font-weight: 600;\r\n            margin-bottom: 9px;\r\n        }\r\n\r\n        .user-panel > .info > a {\r\n            text-decoration: none;\r\n            padding-right: 5px;\r\n            margin-top: 3px;\r\n            font-size: 11px;\r\n        }\r\n\r\n            .user-panel > .info > a > .fa,\r\n            .user-panel > .info > a > .ion,\r\n            .user-panel > .info > a > .glyphicon {\r\n                margin-right: 3px;\r\n            }\r\n\r\n.sidebar-menu {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n    .sidebar-menu > li {\r\n        position: relative;\r\n        margin: 0;\r\n        padding: 0;\r\n    }\r\n\r\n        .sidebar-menu > li > a {\r\n            padding: 12px 5px 12px 15px;\r\n            display: block;\r\n        }\r\n\r\n            /* 493427 — item ATIVO (a tela aberta) do menu esquerdo. O `ativo` vai no <li>, nao no\r\n               <a> (ver orcamentoController.tsx: `$(\"[item-menu]\").parent().addClass(\"ativo\")`), e\r\n               quem pintava era `li.ativo a` em estilo.css, com --mu-superficie-media. No claro isso\r\n               da #e4e6e8, que funciona; no ESCURO da #171c20 — mais escuro que o proprio fundo do\r\n               menu (--mu-superficie-sutil, #1c2126) — e a linha ativa ficava indistinguivel.\r\n\r\n               Regra propria aqui em vez de mexer em --mu-superficie-media, que e compartilhada com\r\n               cabecalho de tabela e barra de ferramentas: mudar o token move tudo isso junto. O\r\n               valor claro repete o #e4e6e8 de hoje, ou seja, no tema claro nada muda. */\r\n            .sidebar-menu > li.ativo > a[item-menu] {\r\n                background-color: var(--mu-menu-esquerdo-ativo, #e4e6e8);\r\n            }\r\n\r\n            /* Realce da linha inteira ao passar o mouse no item do menu esquerdo. O <a> ja e\r\n               `display: block`, entao o fundo cobre a largura toda da linha.\r\n\r\n               A cor e SEMPRE MAIS CLARA que a do item ativo acima, nos dois temas: e o que deixa\r\n               distinguir \"linha sob o mouse\" de \"tela aberta\". Antes o hover usava exatamente o\r\n               mesmo #e4e6e8 do ativo no claro, e os dois se confundiam.\r\n\r\n               Vem DEPOIS da regra do ativo de proposito: as duas tem a mesma especificidade, entao\r\n               quem estiver por ultimo vence — assim passar o mouse na propria linha ativa tambem\r\n               clareia, em vez de ficar sem resposta.\r\n\r\n               O gatilho e `li:hover`, e nao `a[item-menu]:hover`: a estrela de \"menu favorito\" e um\r\n               <a> IRMAO dentro do mesmo <li> (flutuando a direita, puxado para cima), entao com o\r\n               gatilho no proprio <a> passar o mouse na estrela deixava a linha sem realce mesmo com\r\n               o ponteiro dentro dela. Quem PINTA continua sendo so o `a[item-menu]` — a estrela nao\r\n               ganha fundo proprio (ver regra seguinte).\r\n\r\n               `:focus` fica no proprio <a> porque foco e por elemento, nao pela linha; estes itens\r\n               tem accesskey e sao alcancaveis por Tab, e o mesmo realce serve de indicacao de foco. */\r\n            .sidebar-menu > li:hover > a[item-menu],\r\n            .sidebar-menu > li > a[item-menu]:focus {\r\n                background-color: var(--mu-menu-item-hover, #fff);\r\n            }\r\n\r\n            /* A estrela de \"menu favorito\" NUNCA pinta fundo proprio: ela e desenhada por cima do\r\n               <a> da linha (mesma <li>, `position: relative` com `top` negativo), entao sem fundo\r\n               ela mostra o fundo da linha e acompanha hover/ativo de graca.\r\n\r\n               Sem isto ela destoava nos dois estados: no HOVER ficava transparente e aparecia o\r\n               cinza do menu no lugar do realce (um retangulo mais escuro na ponta direita da linha),\r\n               e no ATIVO herdava `li.ativo a` de estilo.css — que pinta TODO <a> dentro do <li>\r\n               ativo com --mu-superficie-media, um tom que a linha ja nao usa mais.\r\n\r\n               Especificidade (0,2,2) > (0,1,2) do `li.ativo a`, entao vence sem `!important`. */\r\n            .sidebar-menu > li > a[menu-inicial-favorito] {\r\n                background-color: transparent;\r\n            }\r\n\r\n            .sidebar-menu > li > a > .fa,\r\n            .sidebar-menu > li > a > .glyphicon,\r\n            .sidebar-menu > li > a > .ion {\r\n                width: 20px;\r\n            }\r\n\r\n        .sidebar-menu > li .label,\r\n        .sidebar-menu > li .badge {\r\n            margin-right: 5px;\r\n        }\r\n\r\n        .sidebar-menu > li .badge {\r\n            margin-top: 3px;\r\n        }\r\n\r\n    .sidebar-menu li.header {\r\n        padding: 10px 25px 10px 15px;\r\n        font-size: 12px;\r\n    }\r\n\r\n    .sidebar-menu li > a > .fa-angle-left,\r\n    .sidebar-menu li > a > .pull-right-container > .fa-angle-left {\r\n        width: auto;\r\n        height: auto;\r\n        padding: 0;\r\n        margin-right: 10px;\r\n        -webkit-transition: transform 0.5s ease;\r\n        -o-transition: transform 0.5s ease;\r\n        transition: transform 0.5s ease;\r\n    }\r\n\r\n    .sidebar-menu li > a > .fa-angle-left {\r\n        position: absolute;\r\n        top: 50%;\r\n        right: 10px;\r\n        margin-top: -8px;\r\n    }\r\n\r\n    .sidebar-menu .menu-open > a > .fa-angle-left,\r\n    .sidebar-menu .menu-open > a > .pull-right-container > .fa-angle-left {\r\n        -webkit-transform: rotate(-90deg);\r\n        -ms-transform: rotate(-90deg);\r\n        -o-transform: rotate(-90deg);\r\n        transform: rotate(-90deg);\r\n    }\r\n\r\n    .sidebar-menu .active > .treeview-menu {\r\n        display: block;\r\n    }\r\n/*\r\n * Component: Sidebar Mini\r\n */\r\n.sidebar-mini.sidebar-collapse .content-wrapper,\r\n.sidebar-mini.sidebar-collapse .right-side,\r\n.sidebar-mini.sidebar-collapse .main-footer {\r\n    margin-left: 50px;\r\n    z-index: 840;\r\n}\r\n\r\n.sidebar-mini.sidebar-collapse .main-sidebar {\r\n    -webkit-transform: translate(0, 0);\r\n    -ms-transform: translate(0, 0);\r\n    -o-transform: translate(0, 0);\r\n    transform: translate(0, 0);\r\n    width: 50px !important;\r\n    z-index: 850;\r\n}\r\n\r\n.sidebar-mini.sidebar-collapse .sidebar-menu > li {\r\n    position: relative;\r\n}\r\n\r\n    .sidebar-mini.sidebar-collapse .sidebar-menu > li > a {\r\n        margin-right: 0;\r\n    }\r\n\r\n        .sidebar-mini.sidebar-collapse .sidebar-menu > li > a > span {\r\n            border-top-right-radius: 4px;\r\n        }\r\n\r\n    .sidebar-mini.sidebar-collapse .sidebar-menu > li:not(.treeview) > a > span {\r\n        border-bottom-right-radius: 4px;\r\n    }\r\n\r\n    .sidebar-mini.sidebar-collapse .sidebar-menu > li > .treeview-menu {\r\n        padding-top: 5px;\r\n        padding-bottom: 5px;\r\n        border-bottom-right-radius: 4px;\r\n    }\r\n\r\n    .sidebar-mini.sidebar-collapse .main-sidebar .user-panel > .info,\r\n    .sidebar-mini.sidebar-collapse .sidebar-form,\r\n    .sidebar-mini.sidebar-collapse .sidebar-menu > li > a > span,\r\n    .sidebar-mini.sidebar-collapse .sidebar-menu > li > a > u,\r\n    .sidebar-mini.sidebar-collapse .sidebar-menu > li > .treeview-menu,\r\n    .sidebar-mini.sidebar-collapse .sidebar-menu > li > a > .pull-right,\r\n    .sidebar-mini.sidebar-collapse .sidebar-menu li.header {\r\n        display: none !important;\r\n        -webkit-transform: translateZ(0);\r\n    }\r\n\r\n.sidebar-mini.sidebar-collapse .main-header .logo {\r\n    width: 50px;\r\n}\r\n\r\n    .sidebar-mini.sidebar-collapse .main-header .logo > .logo-mini {\r\n        display: block;\r\n        margin-left: -15px;\r\n        margin-right: -15px;\r\n        font-size: 18px;\r\n    }\r\n\r\n    .sidebar-mini.sidebar-collapse .main-header .logo > .logo-lg {\r\n        display: none;\r\n    }\r\n\r\n.sidebar-mini.sidebar-collapse .main-header .navbar {\r\n    margin-left: 50px;\r\n}\r\n\r\n.sidebar-mini:not(.sidebar-mini-expand-feature).sidebar-collapse .sidebar-menu > li:hover > a > span:not(.pull-right),\r\n.sidebar-mini:not(.sidebar-mini-expand-feature).sidebar-collapse .sidebar-menu > li:hover > a > u,\r\n.sidebar-mini:not(.sidebar-mini-expand-feature).sidebar-collapse .sidebar-menu > li:hover > .treeview-menu {\r\n    display: block !important;\r\n    position: absolute;\r\n    width: 180px;\r\n    left: 50px;\r\n}\r\n\r\n.sidebar-mini:not(.sidebar-mini-expand-feature).sidebar-collapse .sidebar-menu > li:hover > a > span,\r\n.sidebar-mini:not(.sidebar-mini-expand-feature).sidebar-collapse .sidebar-menu > li:hover > a > u {\r\n    top: 0;\r\n    margin-left: -3px;\r\n    padding: 12px 5px 12px 20px;\r\n    background-color: inherit;\r\n}\r\n\r\n.sidebar-mini:not(.sidebar-mini-expand-feature).sidebar-collapse .sidebar-menu > li:hover > a > .pull-right-container {\r\n    position: relative !important;\r\n    float: right;\r\n    width: auto !important;\r\n    left: 180px !important;\r\n    top: -22px !important;\r\n    z-index: 900;\r\n}\r\n\r\n    .sidebar-mini:not(.sidebar-mini-expand-feature).sidebar-collapse .sidebar-menu > li:hover > a > .pull-right-container > .label:not(:first-of-type) {\r\n        display: none;\r\n    }\r\n\r\n.sidebar-mini:not(.sidebar-mini-expand-feature).sidebar-collapse .sidebar-menu > li:hover > .treeview-menu {\r\n    top: 44px;\r\n    margin-left: 0;\r\n}\r\n\r\n.sidebar-expanded-on-hover .main-footer,\r\n.sidebar-expanded-on-hover .content-wrapper {\r\n    margin-left: 50px;\r\n}\r\n\r\n.sidebar-expanded-on-hover .main-sidebar {\r\n    box-shadow: 3px 0 8px rgba(0, 0, 0, 0.125);\r\n}\r\n\r\n.sidebar-menu,\r\n.main-sidebar .user-panel,\r\n.sidebar-menu > li.header {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n}\r\n\r\n    .sidebar-form,\r\n    .sidebar-menu > li.header {\r\n        overflow: hidden;\r\n        text-overflow: clip;\r\n    }\r\n\r\n    .sidebar-menu li > a {\r\n        position: relative;\r\n    }\r\n\r\n        .sidebar-menu li > a > .pull-right-container {\r\n            position: absolute;\r\n            right: 10px;\r\n            top: 50%;\r\n            margin-top: -7px;\r\n        }\r\n/*\r\n * Component: Control sidebar. By default, this is the right sidebar.\r\n */\r\n.control-sidebar-bg {\r\n    position: fixed;\r\n    z-index: 1000;\r\n    bottom: 0;\r\n}\r\n\r\n.control-sidebar-bg,\r\n.control-sidebar {\r\n    padding-left: 0;\r\n    top: 0;\r\n    right: -245px;\r\n    /*width: 230px;*/\r\n    -webkit-transition: right 0.3s ease-in-out;\r\n    -o-transition: right 0.3s ease-in-out;\r\n    transition: right 0.3s ease-in-out;\r\n}\r\n\r\n.control-sidebar {\r\n    position: absolute;\r\n    padding-top: 105px;\r\n    z-index: 999;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .control-sidebar {\r\n        padding-top: 100px;\r\n    }\r\n}\r\n\r\n.control-sidebar > .tab-content {\r\n    padding: 10px 15px;\r\n}\r\n\r\n.control-sidebar.control-sidebar-open,\r\n.control-sidebar.control-sidebar-open + .control-sidebar-bg {\r\n    right: 0;\r\n}\r\n\r\n.control-sidebar-open .control-sidebar-bg,\r\n.control-sidebar-open .control-sidebar {\r\n    right: 0;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .control-sidebar-open .content-wrapper,\r\n    .control-sidebar-open .right-side,\r\n    .control-sidebar-open .main-footer {\r\n        margin-right: 230px;\r\n    }\r\n}\r\n\r\n.fixed .control-sidebar {\r\n    position: fixed;\r\n    height: 100%;\r\n    overflow-y: auto;\r\n}\r\n\r\n.nav-tabs.control-sidebar-tabs > li:first-of-type > a,\r\n.nav-tabs.control-sidebar-tabs > li:first-of-type > a:hover,\r\n.nav-tabs.control-sidebar-tabs > li:first-of-type > a:focus {\r\n    border-left-width: 0;\r\n}\r\n\r\n.nav-tabs.control-sidebar-tabs > li > a {\r\n    border-radius: 0;\r\n}\r\n\r\n    .nav-tabs.control-sidebar-tabs > li > a,\r\n    .nav-tabs.control-sidebar-tabs > li > a:hover {\r\n        border-top: none;\r\n        border-right: none;\r\n        border-left: 1px solid transparent;\r\n        border-bottom: 1px solid transparent;\r\n    }\r\n\r\n        .nav-tabs.control-sidebar-tabs > li > a .icon {\r\n            font-size: 16px;\r\n        }\r\n\r\n.nav-tabs.control-sidebar-tabs > li.active > a,\r\n.nav-tabs.control-sidebar-tabs > li.active > a:hover,\r\n.nav-tabs.control-sidebar-tabs > li.active > a:focus,\r\n.nav-tabs.control-sidebar-tabs > li.active > a:active {\r\n    border-top: none;\r\n    border-right: none;\r\n    border-bottom: none;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .nav-tabs.control-sidebar-tabs {\r\n        display: table;\r\n    }\r\n\r\n        .nav-tabs.control-sidebar-tabs > li {\r\n            display: table-cell;\r\n        }\r\n}\r\n\r\n.control-sidebar-heading {\r\n    font-weight: 400;\r\n    font-size: 16px;\r\n    padding: 10px 0;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.control-sidebar-subheading {\r\n    display: block;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n}\r\n\r\n.control-sidebar-menu {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0 -15px;\r\n}\r\n\r\n    .control-sidebar-menu > li > a {\r\n        display: block;\r\n        padding: 10px 15px;\r\n    }\r\n\r\n        .control-sidebar-menu > li > a:before,\r\n        .control-sidebar-menu > li > a:after {\r\n            content: \" \";\r\n            display: table;\r\n        }\r\n\r\n        .control-sidebar-menu > li > a:after {\r\n            clear: both;\r\n        }\r\n\r\n        .control-sidebar-menu > li > a > .control-sidebar-subheading {\r\n            margin-top: 0;\r\n        }\r\n\r\n    .control-sidebar-menu .menu-icon {\r\n        float: left;\r\n        width: 35px;\r\n        height: 35px;\r\n        border-radius: 50%;\r\n        text-align: center;\r\n        line-height: 35px;\r\n    }\r\n\r\n    .control-sidebar-menu .menu-info {\r\n        margin-left: 45px;\r\n        margin-top: 3px;\r\n    }\r\n\r\n        .control-sidebar-menu .menu-info > .control-sidebar-subheading {\r\n            margin: 0;\r\n        }\r\n\r\n        .control-sidebar-menu .menu-info > p {\r\n            margin: 0;\r\n            font-size: 11px;\r\n        }\r\n\r\n    .control-sidebar-menu .progress {\r\n        margin: 0;\r\n    }\r\n\r\n.control-sidebar-dark {\r\n    color: #b8c7ce;\r\n}\r\n\r\n    .control-sidebar-dark,\r\n    .control-sidebar-dark + .control-sidebar-bg {\r\n        background: #222d32;\r\n    }\r\n\r\n        .control-sidebar-dark .nav-tabs.control-sidebar-tabs {\r\n            border-bottom: #1c2529;\r\n        }\r\n\r\n            .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a {\r\n                background: #181f23;\r\n                color: #b8c7ce;\r\n            }\r\n\r\n                .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a,\r\n                .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a:hover,\r\n                .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a:focus {\r\n                    border-left-color: #141a1d;\r\n                    border-bottom-color: #141a1d;\r\n                }\r\n\r\n                    .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a:hover,\r\n                    .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a:focus,\r\n                    .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a:active {\r\n                        background: #1c2529;\r\n                    }\r\n\r\n                    .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li > a:hover {\r\n                        color: #fff;\r\n                    }\r\n\r\n            .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li.active > a,\r\n            .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li.active > a:hover,\r\n            .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li.active > a:focus,\r\n            .control-sidebar-dark .nav-tabs.control-sidebar-tabs > li.active > a:active {\r\n                background: #222d32;\r\n                color: #fff;\r\n            }\r\n\r\n        .control-sidebar-dark .control-sidebar-heading,\r\n        .control-sidebar-dark .control-sidebar-subheading {\r\n            color: #fff;\r\n        }\r\n\r\n        .control-sidebar-dark .control-sidebar-menu > li > a:hover {\r\n            background: #1e282c;\r\n        }\r\n\r\n        .control-sidebar-dark .control-sidebar-menu > li > a .menu-info > p {\r\n            color: #b8c7ce;\r\n        }\r\n\r\n.control-sidebar-light {\r\n    color: #5e5e5e;\r\n}\r\n\r\n    .control-sidebar-light,\r\n    .control-sidebar-light + .control-sidebar-bg {\r\n        background: var(--mu-superficie-sutil, #f9fafc);\r\n        border-left: 1px solid var(--mu-borda-forte, #d2d6de);\r\n    }\r\n\r\n        .control-sidebar-light .nav-tabs.control-sidebar-tabs {\r\n            border-bottom: var(--mu-borda-forte, #d2d6de);\r\n        }\r\n\r\n            .control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a {\r\n                background: var(--mu-superficie-azul, #e8ecf4);\r\n                color: var(--mu-texto, #444444);\r\n            }\r\n\r\n                .control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a,\r\n                .control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a:hover,\r\n                .control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a:focus {\r\n                    border-left-color: var(--mu-borda-forte, #d2d6de);\r\n                    border-bottom-color: var(--mu-borda-forte, #d2d6de);\r\n                }\r\n\r\n                    .control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a:hover,\r\n                    .control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a:focus,\r\n                    .control-sidebar-light .nav-tabs.control-sidebar-tabs > li > a:active {\r\n                        background: var(--mu-superficie-azul, #eff1f7);\r\n                    }\r\n\r\n            .control-sidebar-light .nav-tabs.control-sidebar-tabs > li.active > a,\r\n            .control-sidebar-light .nav-tabs.control-sidebar-tabs > li.active > a:hover,\r\n            .control-sidebar-light .nav-tabs.control-sidebar-tabs > li.active > a:focus,\r\n            .control-sidebar-light .nav-tabs.control-sidebar-tabs > li.active > a:active {\r\n                background: var(--mu-superficie-sutil, #f9fafc);\r\n                color: var(--mu-texto, #111);\r\n            }\r\n\r\n        .control-sidebar-light .control-sidebar-heading,\r\n        .control-sidebar-light .control-sidebar-subheading {\r\n            color: var(--mu-texto, #111);\r\n        }\r\n\r\n        .control-sidebar-light .control-sidebar-menu {\r\n            margin-left: -14px;\r\n        }\r\n\r\n            .control-sidebar-light .control-sidebar-menu > li > a:hover {\r\n                background: var(--mu-superficie-sutil, #f4f4f5);\r\n            }\r\n\r\n            .control-sidebar-light .control-sidebar-menu > li > a .menu-info > p {\r\n                color: #5e5e5e;\r\n            }\r\n/*\r\n * Component: Dropdown menus\r\n * -------------------------\r\n */\r\n/*Dropdowns in general*/\r\n.dropdown-menu {\r\n    box-shadow: none;\r\n    border-color: var(--mu-borda-sutil, #eee);\r\n}\r\n\r\n    .dropdown-menu > li > a {\r\n        color: var(--mu-texto-suave, #777);\r\n    }\r\n\r\n        .dropdown-menu > li > a > .glyphicon,\r\n        .dropdown-menu > li > a > .fa,\r\n        .dropdown-menu > li > a > .ion {\r\n            margin-right: 10px;\r\n        }\r\n\r\n        .dropdown-menu > li > a:hover {\r\n            background-color: var(--mu-superficie-media, #e1e3e9);\r\n            color: var(--mu-texto, #333);\r\n        }\r\n\r\n    .dropdown-menu > .divider {\r\n        background-color: var(--mu-superficie-media, #eee);\r\n    }\r\n\r\n.navbar-nav > .notifications-menu > .dropdown-menu,\r\n.navbar-nav > .messages-menu > .dropdown-menu,\r\n.navbar-nav > .tasks-menu > .dropdown-menu {\r\n    width: 280px;\r\n    padding: 0 0 0 0;\r\n    margin: 0;\r\n    top: 100%;\r\n}\r\n\r\n    .navbar-nav > .notifications-menu > .dropdown-menu > li,\r\n    .navbar-nav > .messages-menu > .dropdown-menu > li,\r\n    .navbar-nav > .tasks-menu > .dropdown-menu > li {\r\n        position: relative;\r\n    }\r\n\r\n        .navbar-nav > .notifications-menu > .dropdown-menu > li.header,\r\n        .navbar-nav > .messages-menu > .dropdown-menu > li.header,\r\n        .navbar-nav > .tasks-menu > .dropdown-menu > li.header {\r\n            border-top-left-radius: 4px;\r\n            border-top-right-radius: 4px;\r\n            border-bottom-right-radius: 0;\r\n            border-bottom-left-radius: 0;\r\n            background-color: var(--mu-superficie, #ffffff);\r\n            padding: 7px 10px;\r\n            border-bottom: 1px solid var(--mu-borda-sutil, #f4f4f4);\r\n            color: var(--mu-texto, #444444);\r\n            font-size: 14px;\r\n        }\r\n\r\n        .navbar-nav > .notifications-menu > .dropdown-menu > li.footer > a,\r\n        .navbar-nav > .messages-menu > .dropdown-menu > li.footer > a,\r\n        .navbar-nav > .tasks-menu > .dropdown-menu > li.footer > a {\r\n            border-top-left-radius: 0;\r\n            border-top-right-radius: 0;\r\n            border-bottom-right-radius: 4px;\r\n            border-bottom-left-radius: 4px;\r\n            font-size: 12px;\r\n            background-color: var(--mu-superficie, #fff);\r\n            padding: 7px 10px;\r\n            border-bottom: 1px solid var(--mu-borda-sutil, #eeeeee);\r\n            color: var(--mu-texto, #444) !important;\r\n            text-align: center;\r\n        }\r\n\r\n@media (max-width: 991px) {\r\n    .navbar-nav > .notifications-menu > .dropdown-menu > li.footer > a,\r\n    .navbar-nav > .messages-menu > .dropdown-menu > li.footer > a,\r\n    .navbar-nav > .tasks-menu > .dropdown-menu > li.footer > a {\r\n        background: var(--mu-superficie, #fff) !important;\r\n        color: var(--mu-texto, #444) !important;\r\n    }\r\n}\r\n\r\n.navbar-nav > .notifications-menu > .dropdown-menu > li.footer > a:hover,\r\n.navbar-nav > .messages-menu > .dropdown-menu > li.footer > a:hover,\r\n.navbar-nav > .tasks-menu > .dropdown-menu > li.footer > a:hover {\r\n    text-decoration: none;\r\n    font-weight: normal;\r\n}\r\n\r\n.navbar-nav > .notifications-menu > .dropdown-menu > li .menu,\r\n.navbar-nav > .messages-menu > .dropdown-menu > li .menu,\r\n.navbar-nav > .tasks-menu > .dropdown-menu > li .menu {\r\n    max-height: 200px;\r\n    margin: 0;\r\n    padding: 0;\r\n    list-style: none;\r\n    overflow-x: hidden;\r\n}\r\n\r\n    .navbar-nav > .notifications-menu > .dropdown-menu > li .menu > li > a,\r\n    .navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a,\r\n    .navbar-nav > .tasks-menu > .dropdown-menu > li .menu > li > a {\r\n        display: block;\r\n        white-space: nowrap;\r\n        /* Prevent text from breaking */\r\n        border-bottom: 1px solid var(--mu-borda-sutil, #f4f4f4);\r\n    }\r\n\r\n        .navbar-nav > .notifications-menu > .dropdown-menu > li .menu > li > a:hover,\r\n        .navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a:hover,\r\n        .navbar-nav > .tasks-menu > .dropdown-menu > li .menu > li > a:hover {\r\n            background: var(--mu-superficie-sutil, #f4f4f4);\r\n            text-decoration: none;\r\n        }\r\n\r\n    .navbar-nav > .notifications-menu > .dropdown-menu > li .menu > li > a {\r\n        color: var(--mu-texto, #444444);\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        padding: 10px;\r\n    }\r\n\r\n        .navbar-nav > .notifications-menu > .dropdown-menu > li .menu > li > a > .glyphicon,\r\n        .navbar-nav > .notifications-menu > .dropdown-menu > li .menu > li > a > .fa,\r\n        .navbar-nav > .notifications-menu > .dropdown-menu > li .menu > li > a > .ion {\r\n            width: 20px;\r\n        }\r\n\r\n    .navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a {\r\n        margin: 0;\r\n        padding: 10px 10px;\r\n    }\r\n\r\n        .navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a > div > img {\r\n            margin: auto 10px auto auto;\r\n            width: 40px;\r\n            height: 40px;\r\n        }\r\n\r\n        .navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a > h4 {\r\n            padding: 0;\r\n            margin: 0 0 0 45px;\r\n            color: var(--mu-texto, #444444);\r\n            font-size: 15px;\r\n            position: relative;\r\n        }\r\n\r\n            .navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a > h4 > small {\r\n                color: var(--mu-texto-suave, #999999);\r\n                font-size: 10px;\r\n                position: absolute;\r\n                top: 0;\r\n                right: 0;\r\n            }\r\n\r\n        .navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a > p {\r\n            margin: 0 0 0 45px;\r\n            font-size: 12px;\r\n            color: #888888;\r\n        }\r\n\r\n        .navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a:before,\r\n        .navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a:after {\r\n            content: \" \";\r\n            display: table;\r\n        }\r\n\r\n        .navbar-nav > .messages-menu > .dropdown-menu > li .menu > li > a:after {\r\n            clear: both;\r\n        }\r\n\r\n    .navbar-nav > .tasks-menu > .dropdown-menu > li .menu > li > a {\r\n        padding: 10px;\r\n    }\r\n\r\n        .navbar-nav > .tasks-menu > .dropdown-menu > li .menu > li > a > h3 {\r\n            font-size: 14px;\r\n            padding: 0;\r\n            margin: 0 0 10px 0;\r\n            color: var(--mu-texto-suave, #666666);\r\n        }\r\n\r\n        .navbar-nav > .tasks-menu > .dropdown-menu > li .menu > li > a > .progress {\r\n            padding: 0;\r\n            margin: 0;\r\n        }\r\n\r\n.navbar-nav > .user-menu > .dropdown-menu {\r\n    border-top-right-radius: 0;\r\n    border-top-left-radius: 0;\r\n    padding: 1px 0 0 0;\r\n    border-top-width: 0;\r\n    width: 280px;\r\n}\r\n\r\n    .navbar-nav > .user-menu > .dropdown-menu,\r\n    .navbar-nav > .user-menu > .dropdown-menu > .user-body {\r\n        border-bottom-right-radius: 4px;\r\n        border-bottom-left-radius: 4px;\r\n    }\r\n\r\n        .navbar-nav > .user-menu > .dropdown-menu > li.user-header {\r\n            height: 175px;\r\n            padding: 10px;\r\n            text-align: center;\r\n        }\r\n\r\n            .navbar-nav > .user-menu > .dropdown-menu > li.user-header > img {\r\n                z-index: 5;\r\n                height: 90px;\r\n                width: 90px;\r\n                border: 3px solid;\r\n                border-color: transparent;\r\n                border-color: rgba(255, 255, 255, 0.2);\r\n            }\r\n\r\n            .navbar-nav > .user-menu > .dropdown-menu > li.user-header > p {\r\n                z-index: 5;\r\n                color: #fff;\r\n                color: rgba(255, 255, 255, 0.8);\r\n                font-size: 17px;\r\n                margin-top: 10px;\r\n            }\r\n\r\n                .navbar-nav > .user-menu > .dropdown-menu > li.user-header > p > small {\r\n                    display: block;\r\n                    font-size: 12px;\r\n                }\r\n\r\n        .navbar-nav > .user-menu > .dropdown-menu > .user-body {\r\n            padding: 15px;\r\n            border-bottom: 1px solid var(--mu-borda-sutil, #f4f4f4);\r\n            border-top: 1px solid var(--mu-borda-media, #dddddd);\r\n        }\r\n\r\n            .navbar-nav > .user-menu > .dropdown-menu > .user-body:before,\r\n            .navbar-nav > .user-menu > .dropdown-menu > .user-body:after {\r\n                content: \" \";\r\n                display: table;\r\n            }\r\n\r\n            .navbar-nav > .user-menu > .dropdown-menu > .user-body:after {\r\n                clear: both;\r\n            }\r\n\r\n            .navbar-nav > .user-menu > .dropdown-menu > .user-body a {\r\n                color: var(--mu-texto, #444) !important;\r\n            }\r\n\r\n@media (max-width: 991px) {\r\n    .navbar-nav > .user-menu > .dropdown-menu > .user-body a {\r\n        background: var(--mu-superficie, #fff) !important;\r\n        color: var(--mu-texto, #444) !important;\r\n    }\r\n}\r\n\r\n.navbar-nav > .user-menu > .dropdown-menu > .user-footer {\r\n    background-color: var(--mu-superficie-sutil, #f9f9f9);\r\n    padding: 10px;\r\n}\r\n\r\n    .navbar-nav > .user-menu > .dropdown-menu > .user-footer:before,\r\n    .navbar-nav > .user-menu > .dropdown-menu > .user-footer:after {\r\n        content: \" \";\r\n        display: table;\r\n    }\r\n\r\n    .navbar-nav > .user-menu > .dropdown-menu > .user-footer:after {\r\n        clear: both;\r\n    }\r\n\r\n    .navbar-nav > .user-menu > .dropdown-menu > .user-footer .btn-default {\r\n        color: var(--mu-texto-suave, #666666);\r\n    }\r\n\r\n@media (max-width: 991px) {\r\n    .navbar-nav > .user-menu > .dropdown-menu > .user-footer .btn-default:hover {\r\n        background-color: var(--mu-superficie-sutil, #f9f9f9);\r\n    }\r\n}\r\n\r\n.navbar-nav > .user-menu .user-image {\r\n    float: left;\r\n    width: 25px;\r\n    height: 25px;\r\n    border-radius: 50%;\r\n    margin-right: 10px;\r\n    margin-top: -2px;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .navbar-nav > .user-menu .user-image {\r\n        float: none;\r\n        margin-right: 0;\r\n        margin-top: -8px;\r\n        line-height: 10px;\r\n    }\r\n}\r\n/* Add fade animation to dropdown menus by appending\r\n the class .animated-dropdown-menu to the .dropdown-menu ul (or ol)*/\r\n.open:not(.dropup) > .animated-dropdown-menu {\r\n    backface-visibility: visible !important;\r\n    -webkit-animation: flipInX 0.7s both;\r\n    -o-animation: flipInX 0.7s both;\r\n    animation: flipInX 0.7s both;\r\n}\r\n\r\n@keyframes flipInX {\r\n    0% {\r\n        transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\r\n        transition-timing-function: ease-in;\r\n        opacity: 0;\r\n    }\r\n\r\n    40% {\r\n        transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\r\n        transition-timing-function: ease-in;\r\n    }\r\n\r\n    60% {\r\n        transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\r\n        opacity: 1;\r\n    }\r\n\r\n    80% {\r\n        transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\r\n    }\r\n\r\n    100% {\r\n        transform: perspective(400px);\r\n    }\r\n}\r\n\r\n@-webkit-keyframes flipInX {\r\n    0% {\r\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\r\n        -webkit-transition-timing-function: ease-in;\r\n        opacity: 0;\r\n    }\r\n\r\n    40% {\r\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\r\n        -webkit-transition-timing-function: ease-in;\r\n    }\r\n\r\n    60% {\r\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\r\n        opacity: 1;\r\n    }\r\n\r\n    80% {\r\n        -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: perspective(400px);\r\n    }\r\n}\r\n/* Fix dropdown menu in navbars */\r\n.navbar-custom-menu > .navbar-nav > li {\r\n    position: relative;\r\n}\r\n\r\n    .navbar-custom-menu > .navbar-nav > li > .dropdown-menu {\r\n        position: absolute;\r\n        right: 0;\r\n        left: auto;\r\n    }\r\n\r\n@media (max-width: 991px) {\r\n    .navbar-custom-menu > .navbar-nav {\r\n        float: right;\r\n    }\r\n\r\n        .navbar-custom-menu > .navbar-nav > li {\r\n            position: static;\r\n        }\r\n\r\n            .navbar-custom-menu > .navbar-nav > li > .dropdown-menu {\r\n                position: absolute;\r\n                right: 5%;\r\n                left: auto;\r\n                border: 1px solid var(--mu-borda-media, #ddd);\r\n                background: var(--mu-superficie, #fff);\r\n            }\r\n}\r\n/*\r\n * Component: Form\r\n * ---------------\r\n */\r\n.form-control {\r\n    border-radius: 0;\r\n    box-shadow: none;\r\n    border-color: var(--mu-borda-forte, #d2d6de);\r\n}\r\n\r\n    .form-control:focus {\r\n        border-color: #3c8dbc;\r\n        box-shadow: none;\r\n    }\r\n\r\n    .form-control::-moz-placeholder,\r\n    .form-control:-ms-input-placeholder,\r\n    .form-control::-webkit-input-placeholder {\r\n        color: var(--mu-texto-desab, #bbb);\r\n        opacity: 1;\r\n    }\r\n\r\n    .form-control:not(select) {\r\n        -webkit-appearance: none;\r\n        -moz-appearance: none;\r\n        appearance: none;\r\n    }\r\n\r\n.form-group.has-success label {\r\n    color: #00a65a;\r\n}\r\n\r\n.form-group.has-success .form-control,\r\n.form-group.has-success .input-group-addon {\r\n    border-color: #00a65a;\r\n    box-shadow: none;\r\n}\r\n\r\n.form-group.has-success .help-block {\r\n    color: #00a65a;\r\n}\r\n\r\n.form-group.has-warning label {\r\n    color: #f39c12;\r\n}\r\n\r\n.form-group.has-warning .form-control,\r\n.form-group.has-warning .input-group-addon {\r\n    border-color: #f39c12;\r\n    box-shadow: none;\r\n}\r\n\r\n.form-group.has-warning .help-block {\r\n    color: #f39c12;\r\n}\r\n\r\n.form-group.has-error label {\r\n    color: #dd4b39;\r\n}\r\n\r\n.form-group.has-error .form-control,\r\n.form-group.has-error .input-group-addon {\r\n    border-color: #dd4b39;\r\n    box-shadow: none;\r\n}\r\n\r\n.form-group.has-error .help-block {\r\n    color: #dd4b39;\r\n}\r\n/* Input group */\r\n.input-group .input-group-addon {\r\n    border-radius: 0;\r\n    border-color: var(--mu-borda-forte, #d2d6de);\r\n    background-color: var(--mu-superficie, #fff);\r\n}\r\n/* button groups */\r\n.btn-group-vertical .btn.btn-flat:first-of-type,\r\n.btn-group-vertical .btn.btn-flat:last-of-type {\r\n    border-radius: 0;\r\n}\r\n\r\n.icheck > label {\r\n    padding-left: 0;\r\n}\r\n/* support Font Awesome icons in form-control */\r\n.form-control-feedback.fa {\r\n    line-height: 34px;\r\n}\r\n\r\n.input-lg + .form-control-feedback.fa,\r\n.input-group-lg + .form-control-feedback.fa,\r\n.form-group-lg .form-control + .form-control-feedback.fa {\r\n    line-height: 46px;\r\n}\r\n\r\n.input-sm + .form-control-feedback.fa,\r\n.input-group-sm + .form-control-feedback.fa,\r\n.form-group-sm .form-control + .form-control-feedback.fa {\r\n    line-height: 30px;\r\n}\r\n/*\r\n * Component: Progress Bar\r\n * -----------------------\r\n */\r\n.progress,\r\n.progress > .progress-bar {\r\n    -webkit-box-shadow: none;\r\n    box-shadow: none;\r\n}\r\n\r\n    .progress,\r\n    .progress > .progress-bar,\r\n    .progress .progress-bar,\r\n    .progress > .progress-bar .progress-bar {\r\n        border-radius: 1px;\r\n    }\r\n        /* size variation */\r\n        .progress.sm,\r\n        .progress-sm {\r\n            height: 10px;\r\n        }\r\n\r\n            .progress.sm,\r\n            .progress-sm,\r\n            .progress.sm .progress-bar,\r\n            .progress-sm .progress-bar {\r\n                border-radius: 1px;\r\n            }\r\n\r\n        .progress.xs,\r\n        .progress-xs {\r\n            height: 7px;\r\n        }\r\n\r\n            .progress.xs,\r\n            .progress-xs,\r\n            .progress.xs .progress-bar,\r\n            .progress-xs .progress-bar {\r\n                border-radius: 1px;\r\n            }\r\n\r\n        .progress.xxs,\r\n        .progress-xxs {\r\n            height: 3px;\r\n        }\r\n\r\n            .progress.xxs,\r\n            .progress-xxs,\r\n            .progress.xxs .progress-bar,\r\n            .progress-xxs .progress-bar {\r\n                border-radius: 1px;\r\n            }\r\n        /* Vertical bars */\r\n        .progress.vertical {\r\n            position: relative;\r\n            width: 30px;\r\n            height: 200px;\r\n            display: inline-block;\r\n            margin-right: 10px;\r\n        }\r\n\r\n            .progress.vertical > .progress-bar {\r\n                width: 100%;\r\n                position: absolute;\r\n                bottom: 0;\r\n            }\r\n\r\n            .progress.vertical.sm,\r\n            .progress.vertical.progress-sm {\r\n                width: 20px;\r\n            }\r\n\r\n            .progress.vertical.xs,\r\n            .progress.vertical.progress-xs {\r\n                width: 10px;\r\n            }\r\n\r\n            .progress.vertical.xxs,\r\n            .progress.vertical.progress-xxs {\r\n                width: 3px;\r\n            }\r\n\r\n.progress-group .progress-text {\r\n    font-weight: 600;\r\n}\r\n\r\n.progress-group .progress-number {\r\n    float: right;\r\n}\r\n/* Remove margins from progress bars when put in a table */\r\n.table tr > td .progress {\r\n    margin: 0;\r\n}\r\n\r\n.progress-bar-light-blue,\r\n.progress-bar-primary {\r\n    background-color: #3c8dbc;\r\n}\r\n\r\n.progress-striped .progress-bar-light-blue,\r\n.progress-striped .progress-bar-primary {\r\n    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\r\n    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\r\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\r\n}\r\n\r\n.progress-bar-green,\r\n.progress-bar-success {\r\n    background-color: #00a65a;\r\n}\r\n\r\n.progress-striped .progress-bar-green,\r\n.progress-striped .progress-bar-success {\r\n    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\r\n    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\r\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\r\n}\r\n\r\n.progress-bar-aqua,\r\n.progress-bar-info {\r\n    background-color: #00c0ef;\r\n}\r\n\r\n.progress-striped .progress-bar-aqua,\r\n.progress-striped .progress-bar-info {\r\n    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\r\n    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\r\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\r\n}\r\n\r\n.progress-bar-yellow,\r\n.progress-bar-warning {\r\n    background-color: #f39c12;\r\n}\r\n\r\n.progress-striped .progress-bar-yellow,\r\n.progress-striped .progress-bar-warning {\r\n    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\r\n    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\r\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\r\n}\r\n\r\n.progress-bar-red,\r\n.progress-bar-danger {\r\n    background-color: #dd4b39;\r\n}\r\n\r\n.progress-striped .progress-bar-red,\r\n.progress-striped .progress-bar-danger {\r\n    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\r\n    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\r\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\r\n}\r\n/*\r\n * Component: Small Box\r\n * --------------------\r\n */\r\n.small-box {\r\n    border-radius: 2px;\r\n    position: relative;\r\n    display: block;\r\n    margin-bottom: 20px;\r\n    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n    .small-box > .inner {\r\n        padding: 10px;\r\n    }\r\n\r\n    .small-box > .small-box-footer {\r\n        position: relative;\r\n        text-align: center;\r\n        padding: 3px 0;\r\n        color: #fff;\r\n        color: rgba(255, 255, 255, 0.8);\r\n        display: block;\r\n        z-index: 10;\r\n        background: rgba(0, 0, 0, 0.1);\r\n        text-decoration: none;\r\n    }\r\n\r\n        .small-box > .small-box-footer:hover {\r\n            color: #fff;\r\n            background: rgba(0, 0, 0, 0.15);\r\n        }\r\n\r\n    .small-box h3 {\r\n        font-size: 38px;\r\n        font-weight: bold;\r\n        margin: 0 0 10px 0;\r\n        white-space: nowrap;\r\n        padding: 0;\r\n    }\r\n\r\n    .small-box p {\r\n        font-size: 15px;\r\n    }\r\n\r\n        .small-box p > small {\r\n            display: block;\r\n            color: #f9f9f9;\r\n            font-size: 13px;\r\n            margin-top: 5px;\r\n        }\r\n\r\n    .small-box h3,\r\n    .small-box p {\r\n        z-index: 5;\r\n    }\r\n\r\n    .small-box .icon {\r\n        -webkit-transition: all 0.3s linear;\r\n        -o-transition: all 0.3s linear;\r\n        transition: all 0.3s linear;\r\n        position: absolute;\r\n        top: -10px;\r\n        right: 10px;\r\n        z-index: 0;\r\n        font-size: 90px;\r\n        color: rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    .small-box:hover {\r\n        text-decoration: none;\r\n        color: #f9f9f9;\r\n    }\r\n\r\n        .small-box:hover .icon {\r\n            font-size: 95px;\r\n        }\r\n\r\n@media (max-width: 767px) {\r\n    .small-box {\r\n        text-align: center;\r\n    }\r\n\r\n        .small-box .icon {\r\n            display: none;\r\n        }\r\n\r\n        .small-box p {\r\n            font-size: 12px;\r\n        }\r\n}\r\n/*\r\n * Component: Box\r\n * --------------\r\n */\r\n.box {\r\n    position: relative;\r\n    border-radius: 3px;\r\n    background: var(--mu-superficie, #ffffff);\r\n    border-top: 3px solid var(--mu-borda-forte, #d2d6de);\r\n    margin-bottom: 20px;\r\n    width: 100%;\r\n    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n    .box.box-primary {\r\n        border-top-color: #3c8dbc;\r\n    }\r\n\r\n    .box.box-info {\r\n        border-top-color: #00c0ef;\r\n    }\r\n\r\n    .box.box-danger {\r\n        border-top-color: #dd4b39;\r\n    }\r\n\r\n    .box.box-warning {\r\n        border-top-color: #f39c12;\r\n    }\r\n\r\n    .box.box-success {\r\n        border-top-color: #00a65a;\r\n    }\r\n\r\n    .box.box-default {\r\n        border-top-color: var(--mu-borda-forte, #d2d6de);\r\n    }\r\n\r\n    .box.collapsed-box .box-body,\r\n    .box.collapsed-box .box-footer {\r\n        display: none;\r\n    }\r\n\r\n    .box .nav-stacked > li {\r\n        border-bottom: 1px solid var(--mu-borda-sutil, #f4f4f4);\r\n        margin: 0;\r\n    }\r\n\r\n        .box .nav-stacked > li:last-of-type {\r\n            border-bottom: none;\r\n        }\r\n\r\n    .box.height-control .box-body {\r\n        max-height: 300px;\r\n        overflow: auto;\r\n    }\r\n\r\n    .box .border-right {\r\n        border-right: 1px solid var(--mu-borda-sutil, #f4f4f4);\r\n    }\r\n\r\n    .box .border-left {\r\n        border-left: 1px solid var(--mu-borda-sutil, #f4f4f4);\r\n    }\r\n\r\n    .box.box-solid {\r\n        border-top: 0;\r\n    }\r\n\r\n        .box.box-solid > .box-header .btn.btn-default {\r\n            background: transparent;\r\n        }\r\n\r\n        .box.box-solid > .box-header .btn:hover,\r\n        .box.box-solid > .box-header a:hover {\r\n            background: rgba(0, 0, 0, 0.1);\r\n        }\r\n\r\n        .box.box-solid.box-default {\r\n            border: 1px solid var(--mu-borda-forte, #d2d6de);\r\n        }\r\n\r\n            .box.box-solid.box-default > .box-header {\r\n                color: var(--mu-texto, #444444);\r\n                background: var(--mu-superficie-forte, #d2d6de);\r\n                background-color: var(--mu-superficie-forte, #d2d6de);\r\n            }\r\n\r\n                .box.box-solid.box-default > .box-header a,\r\n                .box.box-solid.box-default > .box-header .btn {\r\n                    color: var(--mu-texto, #444444);\r\n                }\r\n\r\n        .box.box-solid.box-primary {\r\n            border: 1px solid #3c8dbc;\r\n        }\r\n\r\n            .box.box-solid.box-primary > .box-header {\r\n                color: #ffffff;\r\n                background: #3c8dbc;\r\n                background-color: #3c8dbc;\r\n            }\r\n\r\n                .box.box-solid.box-primary > .box-header a,\r\n                .box.box-solid.box-primary > .box-header .btn {\r\n                    color: #ffffff;\r\n                }\r\n\r\n        .box.box-solid.box-info {\r\n            border: 1px solid #00c0ef;\r\n        }\r\n\r\n            .box.box-solid.box-info > .box-header {\r\n                color: #ffffff;\r\n                background: #00c0ef;\r\n                background-color: #00c0ef;\r\n            }\r\n\r\n                .box.box-solid.box-info > .box-header a,\r\n                .box.box-solid.box-info > .box-header .btn {\r\n                    color: #ffffff;\r\n                }\r\n\r\n        .box.box-solid.box-danger {\r\n            border: 1px solid #dd4b39;\r\n        }\r\n\r\n            .box.box-solid.box-danger > .box-header {\r\n                color: #ffffff;\r\n                background: #dd4b39;\r\n                background-color: #dd4b39;\r\n            }\r\n\r\n                .box.box-solid.box-danger > .box-header a,\r\n                .box.box-solid.box-danger > .box-header .btn {\r\n                    color: #ffffff;\r\n                }\r\n\r\n        .box.box-solid.box-warning {\r\n            border: 1px solid #f39c12;\r\n        }\r\n\r\n            .box.box-solid.box-warning > .box-header {\r\n                color: #ffffff;\r\n                background: #f39c12;\r\n                background-color: #f39c12;\r\n            }\r\n\r\n                .box.box-solid.box-warning > .box-header a,\r\n                .box.box-solid.box-warning > .box-header .btn {\r\n                    color: #ffffff;\r\n                }\r\n\r\n        .box.box-solid.box-success {\r\n            border: 1px solid #00a65a;\r\n        }\r\n\r\n            .box.box-solid.box-success > .box-header {\r\n                color: #ffffff;\r\n                background: #00a65a;\r\n                background-color: #00a65a;\r\n            }\r\n\r\n                .box.box-solid.box-success > .box-header a,\r\n                .box.box-solid.box-success > .box-header .btn {\r\n                    color: #ffffff;\r\n                }\r\n\r\n        .box.box-solid > .box-header > .box-tools .btn {\r\n            border: 0;\r\n            box-shadow: none;\r\n        }\r\n\r\n        .box.box-solid[class*='bg'] > .box-header {\r\n            color: #fff;\r\n        }\r\n\r\n    .box .box-group > .box {\r\n        margin-bottom: 5px;\r\n    }\r\n\r\n    .box .knob-label {\r\n        text-align: center;\r\n        color: var(--mu-texto, #333);\r\n        font-weight: 100;\r\n        font-size: 12px;\r\n        margin-bottom: 0.3em;\r\n    }\r\n\r\n    .box > .overlay,\r\n    .overlay-wrapper > .overlay,\r\n    .box > .loading-img,\r\n    .overlay-wrapper > .loading-img {\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n    }\r\n\r\n    .box .overlay,\r\n    .overlay-wrapper .overlay {\r\n        z-index: 50;\r\n        background: rgba(255, 255, 255, 0.7);\r\n        border-radius: 3px;\r\n    }\r\n\r\n        .box .overlay > .fa,\r\n        .overlay-wrapper .overlay > .fa {\r\n            position: absolute;\r\n            top: 50%;\r\n            left: 50%;\r\n            margin-left: -15px;\r\n            margin-top: -15px;\r\n            color: var(--mu-texto, #000);\r\n            font-size: 30px;\r\n        }\r\n\r\n        .box .overlay.dark,\r\n        .overlay-wrapper .overlay.dark {\r\n            background: rgba(0, 0, 0, 0.5);\r\n        }\r\n\r\n.box-header:before,\r\n.box-body:before,\r\n.box-footer:before,\r\n.box-header:after,\r\n.box-body:after,\r\n.box-footer:after {\r\n    content: \" \";\r\n    display: table;\r\n}\r\n\r\n.box-header:after,\r\n.box-body:after,\r\n.box-footer:after {\r\n    clear: both;\r\n}\r\n\r\n.box-header {\r\n    color: var(--mu-texto, #444);\r\n    display: block;\r\n    padding: 10px;\r\n    position: relative;\r\n}\r\n\r\n    .box-header.with-border {\r\n        border-bottom: 1px solid var(--mu-borda-sutil, #f4f4f4);\r\n    }\r\n\r\n.collapsed-box .box-header.with-border {\r\n    border-bottom: none;\r\n}\r\n\r\n.box-header > .fa,\r\n.box-header > .glyphicon,\r\n.box-header > .ion,\r\n.box-header .box-title {\r\n    display: inline-block;\r\n    font-size: 18px;\r\n    margin: 0;\r\n    line-height: 1;\r\n}\r\n\r\n.box-header > .fa,\r\n.box-header > .glyphicon,\r\n.box-header > .ion {\r\n    margin-right: 5px;\r\n}\r\n\r\n.box-header > .box-tools {\r\n    position: absolute;\r\n    right: 10px;\r\n    top: 5px;\r\n}\r\n\r\n    .box-header > .box-tools [data-toggle=\"tooltip\"] {\r\n        position: relative;\r\n    }\r\n\r\n    .box-header > .box-tools.pull-right .dropdown-menu {\r\n        right: 0;\r\n        left: auto;\r\n    }\r\n\r\n    .box-header > .box-tools .dropdown-menu > li > a {\r\n        color: var(--mu-texto, #444) !important;\r\n    }\r\n\r\n.btn-box-tool {\r\n    padding: 5px;\r\n    font-size: 12px;\r\n    background: transparent;\r\n    color: #97a0b3;\r\n}\r\n\r\n    .open .btn-box-tool,\r\n    .btn-box-tool:hover {\r\n        color: #606c84;\r\n    }\r\n\r\n    .btn-box-tool.btn:active {\r\n        box-shadow: none;\r\n    }\r\n\r\n.box-body {\r\n    border-top-left-radius: 0;\r\n    border-top-right-radius: 0;\r\n    border-bottom-right-radius: 3px;\r\n    border-bottom-left-radius: 3px;\r\n    padding: 10px;\r\n}\r\n\r\n.no-header .box-body {\r\n    border-top-right-radius: 3px;\r\n    border-top-left-radius: 3px;\r\n}\r\n\r\n.box-body > .table {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.box-body .fc {\r\n    margin-top: 5px;\r\n}\r\n\r\n.box-body .full-width-chart {\r\n    margin: -19px;\r\n}\r\n\r\n.box-body.no-padding .full-width-chart {\r\n    margin: -9px;\r\n}\r\n\r\n.box-body .box-pane {\r\n    border-top-left-radius: 0;\r\n    border-top-right-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    border-bottom-left-radius: 3px;\r\n}\r\n\r\n.box-body .box-pane-right {\r\n    border-top-left-radius: 0;\r\n    border-top-right-radius: 0;\r\n    border-bottom-right-radius: 3px;\r\n    border-bottom-left-radius: 0;\r\n}\r\n\r\n.box-footer {\r\n    border-top-left-radius: 0;\r\n    border-top-right-radius: 0;\r\n    border-bottom-right-radius: 3px;\r\n    border-bottom-left-radius: 3px;\r\n    border-top: 1px solid var(--mu-borda-sutil, #f4f4f4);\r\n    padding: 10px;\r\n    background-color: var(--mu-superficie, #ffffff);\r\n}\r\n\r\n.chart-legend {\r\n    margin: 10px 0;\r\n}\r\n\r\n@media (max-width: 991px) {\r\n    .chart-legend > li {\r\n        float: left;\r\n        margin-right: 10px;\r\n    }\r\n}\r\n\r\n.box-comments {\r\n    background: var(--mu-superficie-sutil, #f7f7f7);\r\n}\r\n\r\n    .box-comments .box-comment {\r\n        padding: 8px 0;\r\n        border-bottom: 1px solid var(--mu-borda-sutil, #eee);\r\n    }\r\n\r\n        .box-comments .box-comment:before,\r\n        .box-comments .box-comment:after {\r\n            content: \" \";\r\n            display: table;\r\n        }\r\n\r\n        .box-comments .box-comment:after {\r\n            clear: both;\r\n        }\r\n\r\n        .box-comments .box-comment:last-of-type {\r\n            border-bottom: 0;\r\n        }\r\n\r\n        .box-comments .box-comment:first-of-type {\r\n            padding-top: 0;\r\n        }\r\n\r\n        .box-comments .box-comment img {\r\n            float: left;\r\n        }\r\n\r\n    .box-comments .comment-text {\r\n        margin-left: 40px;\r\n        color: var(--mu-texto-suave, #555);\r\n    }\r\n\r\n    .box-comments .username {\r\n        color: var(--mu-texto, #444);\r\n        display: block;\r\n        font-weight: 600;\r\n    }\r\n\r\n    .box-comments .text-muted {\r\n        font-weight: 400;\r\n        font-size: 12px;\r\n    }\r\n/* Widget: TODO LIST */\r\n.todo-list {\r\n    margin: 0;\r\n    padding: 0;\r\n    list-style: none;\r\n    overflow: auto;\r\n}\r\n\r\n    .todo-list > li {\r\n        border-radius: 2px;\r\n        padding: 10px;\r\n        background: var(--mu-superficie-sutil, #f4f4f4);\r\n        margin-bottom: 2px;\r\n        border-left: 2px solid #e6e7e8;\r\n        color: var(--mu-texto, #444);\r\n    }\r\n\r\n        .todo-list > li:last-of-type {\r\n            margin-bottom: 0;\r\n        }\r\n\r\n        .todo-list > li > input[type='checkbox'] {\r\n            margin: 0 10px 0 5px;\r\n        }\r\n\r\n        .todo-list > li .text {\r\n            display: inline-block;\r\n            margin-left: 5px;\r\n            font-weight: 600;\r\n        }\r\n\r\n        .todo-list > li .label {\r\n            margin-left: 10px;\r\n            font-size: 9px;\r\n        }\r\n\r\n        .todo-list > li .tools {\r\n            display: none;\r\n            float: right;\r\n            color: #dd4b39;\r\n        }\r\n\r\n            .todo-list > li .tools > .fa,\r\n            .todo-list > li .tools > .glyphicon,\r\n            .todo-list > li .tools > .ion {\r\n                margin-right: 5px;\r\n                cursor: pointer;\r\n            }\r\n\r\n        .todo-list > li:hover .tools {\r\n            display: inline-block;\r\n        }\r\n\r\n        .todo-list > li.done {\r\n            color: var(--mu-texto-suave, #999);\r\n        }\r\n\r\n            .todo-list > li.done .text {\r\n                text-decoration: line-through;\r\n                font-weight: 500;\r\n            }\r\n\r\n            .todo-list > li.done .label {\r\n                background: var(--mu-superficie-forte, #d2d6de) !important;\r\n            }\r\n\r\n    .todo-list .danger {\r\n        border-left-color: #dd4b39;\r\n    }\r\n\r\n    .todo-list .warning {\r\n        border-left-color: #f39c12;\r\n    }\r\n\r\n    .todo-list .info {\r\n        border-left-color: #00c0ef;\r\n    }\r\n\r\n    .todo-list .success {\r\n        border-left-color: #00a65a;\r\n    }\r\n\r\n    .todo-list .primary {\r\n        border-left-color: #3c8dbc;\r\n    }\r\n\r\n    .todo-list .handle {\r\n        display: inline-block;\r\n        cursor: move;\r\n        margin: 0 5px;\r\n    }\r\n/* Chat widget (DEPRECATED - this will be removed in the next major release. Use Direct Chat instead)*/\r\n.chat {\r\n    padding: 5px 20px 5px 10px;\r\n}\r\n\r\n    .chat .item {\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n        .chat .item:before,\r\n        .chat .item:after {\r\n            content: \" \";\r\n            display: table;\r\n        }\r\n\r\n        .chat .item:after {\r\n            clear: both;\r\n        }\r\n\r\n        .chat .item > img {\r\n            width: 40px;\r\n            height: 40px;\r\n            border: 2px solid transparent;\r\n            border-radius: 50%;\r\n        }\r\n\r\n        .chat .item > .online {\r\n            border: 2px solid #00a65a;\r\n        }\r\n\r\n        .chat .item > .offline {\r\n            border: 2px solid #dd4b39;\r\n        }\r\n\r\n        .chat .item > .message {\r\n            margin-left: 55px;\r\n            margin-top: -40px;\r\n        }\r\n\r\n            .chat .item > .message > .name {\r\n                display: block;\r\n                font-weight: 600;\r\n            }\r\n\r\n        .chat .item > .attachment {\r\n            border-radius: 3px;\r\n            background: var(--mu-superficie-sutil, #f4f4f4);\r\n            margin-left: 65px;\r\n            margin-right: 15px;\r\n            padding: 10px;\r\n        }\r\n\r\n            .chat .item > .attachment > h4 {\r\n                margin: 0 0 5px 0;\r\n                font-weight: 600;\r\n                font-size: 14px;\r\n            }\r\n\r\n            .chat .item > .attachment > p,\r\n            .chat .item > .attachment > .filename {\r\n                font-weight: 600;\r\n                font-size: 13px;\r\n                font-style: italic;\r\n                margin: 0;\r\n            }\r\n\r\n            .chat .item > .attachment:before,\r\n            .chat .item > .attachment:after {\r\n                content: \" \";\r\n                display: table;\r\n            }\r\n\r\n            .chat .item > .attachment:after {\r\n                clear: both;\r\n            }\r\n\r\n.box-input {\r\n    max-width: 200px;\r\n}\r\n\r\n.modal .panel-body {\r\n    color: var(--mu-texto, #444);\r\n}\r\n/*\r\n * Component: Info Box\r\n * -------------------\r\n */\r\n.info-box {\r\n    display: block;\r\n    min-height: 90px;\r\n    background: var(--mu-superficie, #fff);\r\n    width: 100%;\r\n    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\r\n    border-radius: 2px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n    .info-box small {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .info-box .progress {\r\n        background: rgba(0, 0, 0, 0.2);\r\n        margin: 5px -10px 5px -10px;\r\n        height: 2px;\r\n    }\r\n\r\n        .info-box .progress,\r\n        .info-box .progress .progress-bar {\r\n            border-radius: 0;\r\n        }\r\n\r\n            .info-box .progress .progress-bar {\r\n                background: var(--mu-superficie, #fff);\r\n            }\r\n\r\n.info-box-icon {\r\n    border-top-left-radius: 2px;\r\n    border-top-right-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    border-bottom-left-radius: 2px;\r\n    display: block;\r\n    float: left;\r\n    height: 90px;\r\n    width: 90px;\r\n    text-align: center;\r\n    font-size: 45px;\r\n    line-height: 90px;\r\n    background: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n    .info-box-icon > img {\r\n        max-width: 100%;\r\n    }\r\n\r\n.info-box-content {\r\n    padding: 5px 10px;\r\n    margin-left: 90px;\r\n}\r\n\r\n.info-box-number {\r\n    display: block;\r\n    font-weight: bold;\r\n    font-size: 18px;\r\n}\r\n\r\n.progress-description,\r\n.info-box-text {\r\n    display: block;\r\n    font-size: 14px;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.info-box-text {\r\n    text-transform: uppercase;\r\n}\r\n\r\n.info-box-more {\r\n    display: block;\r\n}\r\n\r\n.progress-description {\r\n    margin: 0;\r\n}\r\n/*\r\n * Component: Timeline\r\n * -------------------\r\n */\r\n.timeline {\r\n    position: relative;\r\n    margin: 0 0 30px 0;\r\n    padding: 0;\r\n    list-style: none;\r\n}\r\n\r\n    .timeline:before {\r\n        content: '';\r\n        position: absolute;\r\n        top: 0;\r\n        bottom: 0;\r\n        width: 4px;\r\n        background: var(--mu-superficie-forte, #ddd);\r\n        left: 31px;\r\n        margin: 0;\r\n        border-radius: 2px;\r\n    }\r\n\r\n    .timeline > li {\r\n        position: relative;\r\n        margin-right: 10px;\r\n        margin-bottom: 15px;\r\n    }\r\n\r\n        .timeline > li:before,\r\n        .timeline > li:after {\r\n            content: \" \";\r\n            display: table;\r\n        }\r\n\r\n        .timeline > li:after {\r\n            clear: both;\r\n        }\r\n\r\n        .timeline > li > .timeline-item {\r\n            -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\r\n            box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\r\n            border-radius: 3px;\r\n            margin-top: 0;\r\n            background: var(--mu-superficie, #fff);\r\n            color: var(--mu-texto, #444);\r\n            margin-left: 60px;\r\n            margin-right: 15px;\r\n            padding: 0;\r\n            position: relative;\r\n        }\r\n\r\n            .timeline > li > .timeline-item > .time {\r\n                color: var(--mu-texto-suave, #999);\r\n                float: right;\r\n                padding: 10px;\r\n                font-size: 12px;\r\n            }\r\n\r\n            .timeline > li > .timeline-item > .timeline-header {\r\n                margin: 0;\r\n                color: var(--mu-texto-suave, #555);\r\n                border-bottom: 1px solid var(--mu-borda-sutil, #f4f4f4);\r\n                padding: 10px;\r\n                font-size: 16px;\r\n                line-height: 1.1;\r\n            }\r\n\r\n                .timeline > li > .timeline-item > .timeline-header > a {\r\n                    font-weight: 600;\r\n                }\r\n\r\n            .timeline > li > .timeline-item > .timeline-body,\r\n            .timeline > li > .timeline-item > .timeline-footer {\r\n                padding: 10px;\r\n            }\r\n\r\n        .timeline > li > .fa,\r\n        .timeline > li > .glyphicon,\r\n        .timeline > li > .ion {\r\n            width: 30px;\r\n            height: 30px;\r\n            font-size: 15px;\r\n            line-height: 30px;\r\n            position: absolute;\r\n            color: var(--mu-texto-suave, #666);\r\n            background: var(--mu-superficie-forte, #d2d6de);\r\n            border-radius: 50%;\r\n            text-align: center;\r\n            left: 18px;\r\n            top: 0;\r\n        }\r\n\r\n    .timeline > .time-label > span {\r\n        font-weight: 600;\r\n        padding: 5px;\r\n        display: inline-block;\r\n        background-color: var(--mu-superficie, #fff);\r\n        border-radius: 4px;\r\n    }\r\n\r\n.timeline-inverse > li > .timeline-item {\r\n    background: var(--mu-superficie-sutil, #f0f0f0);\r\n    border: 1px solid var(--mu-borda-media, #ddd);\r\n    -webkit-box-shadow: none;\r\n    box-shadow: none;\r\n}\r\n\r\n    .timeline-inverse > li > .timeline-item > .timeline-header {\r\n        border-bottom-color: var(--mu-borda-media, #ddd);\r\n    }\r\n/*\r\n * Component: Button\r\n * -----------------\r\n */\r\n.btn {\r\n    border-radius: 3px;\r\n    -webkit-box-shadow: none;\r\n    box-shadow: none;\r\n    border: 1px solid transparent;\r\n}\r\n\r\n    .btn.uppercase {\r\n        text-transform: uppercase;\r\n    }\r\n\r\n    .btn.btn-flat {\r\n        border-radius: 0;\r\n        -webkit-box-shadow: none;\r\n        -moz-box-shadow: none;\r\n        box-shadow: none;\r\n        border-width: 1px;\r\n    }\r\n\r\n    .btn:active {\r\n        -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n        -moz-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n        box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n    }\r\n\r\n    .btn:focus {\r\n        outline: none;\r\n    }\r\n\r\n    .btn.btn-file {\r\n        position: relative;\r\n        overflow: hidden;\r\n    }\r\n\r\n        .btn.btn-file > input[type='file'] {\r\n            position: absolute;\r\n            top: 0;\r\n            right: 0;\r\n            min-width: 100%;\r\n            min-height: 100%;\r\n            font-size: 100px;\r\n            text-align: right;\r\n            opacity: 0;\r\n            filter: alpha(opacity=0);\r\n            outline: none;\r\n            background: var(--mu-superficie, white);\r\n            cursor: inherit;\r\n            display: block;\r\n        }\r\n\r\n.btn-default {\r\n    background-color: var(--mu-superficie-sutil, #f4f4f4);\r\n    color: var(--mu-texto, #444);\r\n    border-color: var(--mu-borda-media, #ddd);\r\n}\r\n\r\n    .btn-default:hover,\r\n    .btn-default:active,\r\n    .btn-default.hover {\r\n        background-color: var(--mu-superficie-sutil, #e7e7e7);\r\n    }\r\n\r\n.btn-primary {\r\n    background-color: #3c8dbc;\r\n    border-color: #367fa9;\r\n}\r\n\r\n    .btn-primary:hover,\r\n    .btn-primary:active,\r\n    .btn-primary.hover {\r\n        background-color: #367fa9;\r\n    }\r\n\r\n.btn-success {\r\n    background-color: #00a65a;\r\n    border-color: #008d4c;\r\n}\r\n\r\n    .btn-success:hover,\r\n    .btn-success:active,\r\n    .btn-success.hover {\r\n        background-color: #008d4c;\r\n    }\r\n\r\n.btn-info {\r\n    background-color: #00c0ef;\r\n    border-color: #00acd6;\r\n}\r\n\r\n    .btn-info:hover,\r\n    .btn-info:active,\r\n    .btn-info.hover {\r\n        background-color: #00acd6;\r\n    }\r\n\r\n.btn-danger {\r\n    background-color: #dd4b39;\r\n    border-color: #d73925;\r\n}\r\n\r\n    .btn-danger:hover,\r\n    .btn-danger:active,\r\n    .btn-danger.hover {\r\n        background-color: #d73925;\r\n    }\r\n\r\n.btn-warning {\r\n    background-color: #f39c12;\r\n    border-color: #e08e0b;\r\n}\r\n\r\n    .btn-warning:hover,\r\n    .btn-warning:active,\r\n    .btn-warning.hover {\r\n        background-color: #e08e0b;\r\n    }\r\n\r\n.btn-outline {\r\n    border: 1px solid #fff;\r\n    background: transparent;\r\n    color: #fff;\r\n}\r\n\r\n    .btn-outline:hover,\r\n    .btn-outline:focus,\r\n    .btn-outline:active {\r\n        color: rgba(255, 255, 255, 0.7);\r\n        border-color: rgba(255, 255, 255, 0.7);\r\n    }\r\n\r\n.btn-link {\r\n    -webkit-box-shadow: none;\r\n    box-shadow: none;\r\n}\r\n\r\n.btn[class*='bg-']:hover {\r\n    -webkit-box-shadow: inset 0 0 100px rgba(0, 0, 0, 0.2);\r\n    box-shadow: inset 0 0 100px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.btn-app {\r\n    border-radius: 3px;\r\n    position: relative;\r\n    padding: 15px 5px;\r\n    margin: 0 0 10px 10px;\r\n    min-width: 80px;\r\n    height: 60px;\r\n    text-align: center;\r\n    color: var(--mu-texto-suave, #666);\r\n    border: 1px solid var(--mu-borda-media, #ddd);\r\n    background-color: var(--mu-superficie-sutil, #f4f4f4);\r\n    font-size: 12px;\r\n}\r\n\r\n    .btn-app > .fa,\r\n    .btn-app > .glyphicon,\r\n    .btn-app > .ion {\r\n        font-size: 20px;\r\n        display: block;\r\n    }\r\n\r\n    .btn-app:hover {\r\n        background: var(--mu-superficie-sutil, #f4f4f4);\r\n        color: var(--mu-texto, #444);\r\n        border-color: #aaa;\r\n    }\r\n\r\n    .btn-app:active,\r\n    .btn-app:focus {\r\n        -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n        -moz-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n        box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n    }\r\n\r\n    .btn-app > .badge {\r\n        position: absolute;\r\n        top: -3px;\r\n        right: -10px;\r\n        font-size: 10px;\r\n        font-weight: 400;\r\n    }\r\n/*\r\n * Component: Callout\r\n * ------------------\r\n */\r\n.callout {\r\n    border-radius: 3px;\r\n    margin: 0 0 20px 0;\r\n    padding: 15px 30px 15px 15px;\r\n    border-left: 5px solid var(--mu-borda-sutil, #eee);\r\n}\r\n\r\n    .callout a {\r\n        color: #fff;\r\n        text-decoration: underline;\r\n    }\r\n\r\n        .callout a:hover {\r\n            color: #eee;\r\n        }\r\n\r\n    .callout h4 {\r\n        margin-top: 0;\r\n        font-weight: 600;\r\n    }\r\n\r\n    .callout p:last-child {\r\n        margin-bottom: 0;\r\n    }\r\n\r\n    .callout code,\r\n    .callout .highlight {\r\n        background-color: var(--mu-superficie, #fff);\r\n    }\r\n\r\n    .callout.callout-danger {\r\n        border-color: #c23321;\r\n    }\r\n\r\n    .callout.callout-warning {\r\n        border-color: #c87f0a;\r\n    }\r\n\r\n    .callout.callout-info {\r\n        border-color: #0097bc;\r\n    }\r\n\r\n    .callout.callout-success {\r\n        border-color: #00733e;\r\n    }\r\n/*\r\n * Component: alert\r\n * ----------------\r\n */\r\n.alert {\r\n    border-radius: 3px;\r\n}\r\n\r\n    .alert h4 {\r\n        font-weight: 600;\r\n    }\r\n\r\n    .alert .icon {\r\n        margin-right: 10px;\r\n    }\r\n\r\n    .alert .close {\r\n        color: var(--mu-texto, #000);\r\n        opacity: 0.2;\r\n        filter: alpha(opacity=20);\r\n    }\r\n\r\n        .alert .close:hover {\r\n            opacity: 0.5;\r\n            filter: alpha(opacity=50);\r\n        }\r\n\r\n    .alert a {\r\n        color: #fff;\r\n        text-decoration: underline;\r\n    }\r\n\r\n.alert-success {\r\n    border-color: #008d4c;\r\n}\r\n\r\n.alert-danger,\r\n.alert-error {\r\n    border-color: #d73925;\r\n}\r\n\r\n.alert-warning {\r\n    border-color: #e08e0b;\r\n}\r\n\r\n.alert-info {\r\n    border-color: #00acd6;\r\n}\r\n/*\r\n * Component: Nav\r\n * --------------\r\n */\r\n.nav > li > a:hover,\r\n.nav > li > a:active,\r\n.nav > li > a:focus {\r\n    color: var(--mu-texto, #444);\r\n    background: var(--mu-superficie-sutil, #f7f7f7);\r\n}\r\n/* NAV PILLS */\r\n.nav-pills > li > a {\r\n    border-radius: 0;\r\n    border-top: 3px solid transparent;\r\n    color: var(--mu-texto, #444);\r\n}\r\n\r\n    .nav-pills > li > a > .fa,\r\n    .nav-pills > li > a > .glyphicon,\r\n    .nav-pills > li > a > .ion {\r\n        margin-right: 5px;\r\n    }\r\n\r\n.nav-pills > li.active > a,\r\n.nav-pills > li.active > a:hover,\r\n.nav-pills > li.active > a:focus {\r\n    border-top-color: #3c8dbc;\r\n}\r\n\r\n.nav-pills > li.active > a {\r\n    font-weight: 600;\r\n}\r\n/* NAV STACKED */\r\n.nav-stacked > li > a {\r\n    border-radius: 0;\r\n    border-top: 0;\r\n    border-left: 3px solid transparent;\r\n    color: var(--mu-texto, #444);\r\n}\r\n\r\n.nav-stacked > li.active > a,\r\n.nav-stacked > li.active > a:hover {\r\n    background: transparent;\r\n    color: var(--mu-texto, #444);\r\n    border-top: 0;\r\n    border-left-color: #3c8dbc;\r\n}\r\n\r\n.nav-stacked > li.header {\r\n    border-bottom: 1px solid var(--mu-borda-media, #ddd);\r\n    color: var(--mu-texto-suave, #777);\r\n    margin-bottom: 10px;\r\n    padding: 5px 10px;\r\n    text-transform: uppercase;\r\n}\r\n/* NAV TABS */\r\n.nav-tabs-custom {\r\n    margin-bottom: 20px;\r\n    background: var(--mu-superficie, #fff);\r\n    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\r\n    border-radius: 3px;\r\n}\r\n\r\n    .nav-tabs-custom > .nav-tabs {\r\n        margin: 0;\r\n        border-bottom-color: var(--mu-borda-sutil, #f4f4f4);\r\n        border-top-right-radius: 3px;\r\n        border-top-left-radius: 3px;\r\n    }\r\n\r\n        .nav-tabs-custom > .nav-tabs > li {\r\n            border-top: 3px solid transparent;\r\n            margin-bottom: -2px;\r\n            margin-right: 5px;\r\n        }\r\n\r\n            .nav-tabs-custom > .nav-tabs > li.disabled > a {\r\n                color: var(--mu-texto-suave, #777);\r\n            }\r\n\r\n            .nav-tabs-custom > .nav-tabs > li > a {\r\n                color: var(--mu-texto, #444);\r\n                border-radius: 0;\r\n            }\r\n\r\n                .nav-tabs-custom > .nav-tabs > li > a.text-muted {\r\n                    color: var(--mu-texto-suave, #999);\r\n                }\r\n\r\n                .nav-tabs-custom > .nav-tabs > li > a,\r\n                .nav-tabs-custom > .nav-tabs > li > a:hover {\r\n                    background: transparent;\r\n                    margin: 0;\r\n                }\r\n\r\n                    .nav-tabs-custom > .nav-tabs > li > a:hover {\r\n                        color: var(--mu-texto-suave, #999);\r\n                    }\r\n\r\n            .nav-tabs-custom > .nav-tabs > li:not(.active) > a:hover,\r\n            .nav-tabs-custom > .nav-tabs > li:not(.active) > a:focus,\r\n            .nav-tabs-custom > .nav-tabs > li:not(.active) > a:active {\r\n                border-color: transparent;\r\n            }\r\n\r\n            .nav-tabs-custom > .nav-tabs > li.active {\r\n                border-top-color: #3c8dbc;\r\n            }\r\n\r\n                .nav-tabs-custom > .nav-tabs > li.active > a,\r\n                .nav-tabs-custom > .nav-tabs > li.active:hover > a {\r\n                    background-color: var(--mu-superficie, #fff);\r\n                    color: var(--mu-texto, #444);\r\n                }\r\n\r\n                .nav-tabs-custom > .nav-tabs > li.active > a {\r\n                    border-top-color: transparent;\r\n                    border-left-color: var(--mu-borda-sutil, #f4f4f4);\r\n                    border-right-color: var(--mu-borda-sutil, #f4f4f4);\r\n                }\r\n\r\n            .nav-tabs-custom > .nav-tabs > li:first-of-type {\r\n                margin-left: 0;\r\n            }\r\n\r\n                .nav-tabs-custom > .nav-tabs > li:first-of-type.active > a {\r\n                    border-left-color: transparent;\r\n                }\r\n\r\n        .nav-tabs-custom > .nav-tabs.pull-right {\r\n            float: none !important;\r\n        }\r\n\r\n            .nav-tabs-custom > .nav-tabs.pull-right > li {\r\n                float: right;\r\n            }\r\n\r\n                .nav-tabs-custom > .nav-tabs.pull-right > li:first-of-type {\r\n                    margin-right: 0;\r\n                }\r\n\r\n                    .nav-tabs-custom > .nav-tabs.pull-right > li:first-of-type > a {\r\n                        border-left-width: 1px;\r\n                    }\r\n\r\n                    .nav-tabs-custom > .nav-tabs.pull-right > li:first-of-type.active > a {\r\n                        border-left-color: var(--mu-borda-sutil, #f4f4f4);\r\n                        border-right-color: transparent;\r\n                    }\r\n\r\n        .nav-tabs-custom > .nav-tabs > li.header {\r\n            line-height: 35px;\r\n            padding: 0 10px;\r\n            font-size: 20px;\r\n            color: var(--mu-texto, #444);\r\n        }\r\n\r\n            .nav-tabs-custom > .nav-tabs > li.header > .fa,\r\n            .nav-tabs-custom > .nav-tabs > li.header > .glyphicon,\r\n            .nav-tabs-custom > .nav-tabs > li.header > .ion {\r\n                margin-right: 5px;\r\n            }\r\n\r\n    .nav-tabs-custom > .tab-content {\r\n        background: var(--mu-superficie, #fff);\r\n        padding: 10px;\r\n        border-bottom-right-radius: 3px;\r\n        border-bottom-left-radius: 3px;\r\n    }\r\n\r\n    .nav-tabs-custom .dropdown.open > a:active,\r\n    .nav-tabs-custom .dropdown.open > a:focus {\r\n        background: transparent;\r\n        color: var(--mu-texto-suave, #999);\r\n    }\r\n\r\n    .nav-tabs-custom.tab-primary > .nav-tabs > li.active {\r\n        border-top-color: #3c8dbc;\r\n    }\r\n\r\n    .nav-tabs-custom.tab-info > .nav-tabs > li.active {\r\n        border-top-color: #00c0ef;\r\n    }\r\n\r\n    .nav-tabs-custom.tab-danger > .nav-tabs > li.active {\r\n        border-top-color: #dd4b39;\r\n    }\r\n\r\n    .nav-tabs-custom.tab-warning > .nav-tabs > li.active {\r\n        border-top-color: #f39c12;\r\n    }\r\n\r\n    .nav-tabs-custom.tab-success > .nav-tabs > li.active {\r\n        border-top-color: #00a65a;\r\n    }\r\n\r\n    .nav-tabs-custom.tab-default > .nav-tabs > li.active {\r\n        border-top-color: var(--mu-borda-forte, #d2d6de);\r\n    }\r\n/* PAGINATION */\r\n.pagination > li > a {\r\n    background: var(--mu-superficie-sutil, #fafafa);\r\n    color: var(--mu-texto-suave, #666);\r\n}\r\n\r\n.pagination.pagination-flat > li > a {\r\n    border-radius: 0 !important;\r\n}\r\n/*\r\n * Component: Products List\r\n * ------------------------\r\n */\r\n.products-list {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n    .products-list > .item {\r\n        border-radius: 3px;\r\n        -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\r\n        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\r\n        padding: 10px 0;\r\n        background: var(--mu-superficie, #fff);\r\n    }\r\n\r\n        .products-list > .item:before,\r\n        .products-list > .item:after {\r\n            content: \" \";\r\n            display: table;\r\n        }\r\n\r\n        .products-list > .item:after {\r\n            clear: both;\r\n        }\r\n\r\n    .products-list .product-img {\r\n        float: left;\r\n    }\r\n\r\n        .products-list .product-img img {\r\n            width: 50px;\r\n            height: 50px;\r\n        }\r\n\r\n    .products-list .product-info {\r\n        margin-left: 60px;\r\n    }\r\n\r\n    .products-list .product-title {\r\n        font-weight: 600;\r\n    }\r\n\r\n    .products-list .product-description {\r\n        display: block;\r\n        color: var(--mu-texto-suave, #999);\r\n        overflow: hidden;\r\n        white-space: nowrap;\r\n        text-overflow: ellipsis;\r\n    }\r\n\r\n.product-list-in-box > .item {\r\n    -webkit-box-shadow: none;\r\n    box-shadow: none;\r\n    border-radius: 0;\r\n    border-bottom: 1px solid var(--mu-borda-sutil, #f4f4f4);\r\n}\r\n\r\n    .product-list-in-box > .item:last-of-type {\r\n        border-bottom-width: 0;\r\n    }\r\n/*\r\n * Component: Table\r\n * ----------------\r\n */\r\n.table > thead > tr > th,\r\n.table > tbody > tr > th,\r\n.table > tfoot > tr > th,\r\n.table > thead > tr > td,\r\n.table > tbody > tr > td,\r\n.table > tfoot > tr > td {\r\n    border-top: 1px solid var(--mu-borda-sutil, #f4f4f4);\r\n}\r\n\r\n.table > thead > tr > th {\r\n    border-bottom: 2px solid var(--mu-borda-sutil, #f4f4f4);\r\n}\r\n\r\n.table tr td .progress {\r\n    margin-top: 5px;\r\n}\r\n\r\n.table-bordered {\r\n    border: 1px solid var(--mu-borda-sutil, #f4f4f4);\r\n}\r\n\r\n    .table-bordered > thead > tr > th,\r\n    .table-bordered > tbody > tr > th,\r\n    .table-bordered > tfoot > tr > th,\r\n    .table-bordered > thead > tr > td,\r\n    .table-bordered > tbody > tr > td,\r\n    .table-bordered > tfoot > tr > td {\r\n        border: 1px solid var(--mu-borda-sutil, #f4f4f4);\r\n    }\r\n\r\n    .table-bordered > thead > tr > th,\r\n    .table-bordered > thead > tr > td {\r\n        border-bottom-width: 2px;\r\n    }\r\n\r\n.table.no-border,\r\n.table.no-border td,\r\n.table.no-border th {\r\n    border: 0;\r\n}\r\n/* .text-center in tables */\r\ntable.text-center,\r\ntable.text-center td,\r\ntable.text-center th {\r\n    text-align: center;\r\n}\r\n\r\n.table.align th {\r\n    text-align: left;\r\n}\r\n\r\n.table.align td {\r\n    text-align: right;\r\n}\r\n/*\r\n * Component: Label\r\n * ----------------\r\n */\r\n.label-default {\r\n    background-color: var(--mu-superficie-forte, #d2d6de);\r\n    color: var(--mu-texto, #444);\r\n}\r\n/*\r\n * Component: Direct Chat\r\n * ----------------------\r\n */\r\n.direct-chat .box-body {\r\n    border-bottom-right-radius: 0;\r\n    border-bottom-left-radius: 0;\r\n    position: relative;\r\n    overflow-x: hidden;\r\n    padding: 0;\r\n}\r\n\r\n.direct-chat.chat-pane-open .direct-chat-contacts {\r\n    -webkit-transform: translate(0, 0);\r\n    -ms-transform: translate(0, 0);\r\n    -o-transform: translate(0, 0);\r\n    transform: translate(0, 0);\r\n}\r\n\r\n.direct-chat-messages {\r\n    -webkit-transform: translate(0, 0);\r\n    -ms-transform: translate(0, 0);\r\n    -o-transform: translate(0, 0);\r\n    transform: translate(0, 0);\r\n    padding: 10px;\r\n    height: 250px;\r\n    overflow: auto;\r\n}\r\n\r\n.direct-chat-msg,\r\n.direct-chat-text {\r\n    display: block;\r\n}\r\n\r\n.direct-chat-msg {\r\n    margin-bottom: 10px;\r\n}\r\n\r\n    .direct-chat-msg:before,\r\n    .direct-chat-msg:after {\r\n        content: \" \";\r\n        display: table;\r\n    }\r\n\r\n    .direct-chat-msg:after {\r\n        clear: both;\r\n    }\r\n\r\n.direct-chat-messages,\r\n.direct-chat-contacts {\r\n    -webkit-transition: -webkit-transform 0.5s ease-in-out;\r\n    -moz-transition: -moz-transform 0.5s ease-in-out;\r\n    -o-transition: -o-transform 0.5s ease-in-out;\r\n    transition: transform 0.5s ease-in-out;\r\n}\r\n\r\n.direct-chat-text {\r\n    border-radius: 5px;\r\n    position: relative;\r\n    padding: 5px 10px;\r\n    background: var(--mu-superficie-forte, #d2d6de);\r\n    border: 1px solid var(--mu-borda-forte, #d2d6de);\r\n    margin: 5px 0 0 50px;\r\n    color: var(--mu-texto, #444444);\r\n}\r\n\r\n    .direct-chat-text:after,\r\n    .direct-chat-text:before {\r\n        position: absolute;\r\n        right: 100%;\r\n        top: 15px;\r\n        border: solid transparent;\r\n        border-right-color: var(--mu-borda-forte, #d2d6de);\r\n        content: ' ';\r\n        height: 0;\r\n        width: 0;\r\n        pointer-events: none;\r\n    }\r\n\r\n    .direct-chat-text:after {\r\n        border-width: 5px;\r\n        margin-top: -5px;\r\n    }\r\n\r\n    .direct-chat-text:before {\r\n        border-width: 6px;\r\n        margin-top: -6px;\r\n    }\r\n\r\n.right .direct-chat-text {\r\n    margin-right: 50px;\r\n    margin-left: 0;\r\n}\r\n\r\n    .right .direct-chat-text:after,\r\n    .right .direct-chat-text:before {\r\n        right: auto;\r\n        left: 100%;\r\n        border-right-color: transparent;\r\n        border-left-color: var(--mu-borda-forte, #d2d6de);\r\n    }\r\n\r\n.direct-chat-img {\r\n    border-radius: 50%;\r\n    float: left;\r\n    width: 40px;\r\n    height: 40px;\r\n}\r\n\r\n.right .direct-chat-img {\r\n    float: right;\r\n}\r\n\r\n.direct-chat-info {\r\n    display: block;\r\n    margin-bottom: 2px;\r\n    font-size: 12px;\r\n}\r\n\r\n.direct-chat-name {\r\n    font-weight: 600;\r\n}\r\n\r\n.direct-chat-timestamp {\r\n    color: var(--mu-texto-suave, #999);\r\n}\r\n\r\n.direct-chat-contacts-open .direct-chat-contacts {\r\n    -webkit-transform: translate(0, 0);\r\n    -ms-transform: translate(0, 0);\r\n    -o-transform: translate(0, 0);\r\n    transform: translate(0, 0);\r\n}\r\n\r\n.direct-chat-contacts {\r\n    -webkit-transform: translate(101%, 0);\r\n    -ms-transform: translate(101%, 0);\r\n    -o-transform: translate(101%, 0);\r\n    transform: translate(101%, 0);\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    height: 250px;\r\n    width: 100%;\r\n    background: #222d32;\r\n    color: #fff;\r\n    overflow: auto;\r\n}\r\n\r\n.contacts-list > li {\r\n    border-bottom: 1px solid rgba(0, 0, 0, 0.2);\r\n    padding: 10px;\r\n    margin: 0;\r\n}\r\n\r\n    .contacts-list > li:before,\r\n    .contacts-list > li:after {\r\n        content: \" \";\r\n        display: table;\r\n    }\r\n\r\n    .contacts-list > li:after {\r\n        clear: both;\r\n    }\r\n\r\n    .contacts-list > li:last-of-type {\r\n        border-bottom: none;\r\n    }\r\n\r\n.contacts-list-img {\r\n    border-radius: 50%;\r\n    width: 40px;\r\n    float: left;\r\n}\r\n\r\n.contacts-list-info {\r\n    margin-left: 45px;\r\n    color: #fff;\r\n}\r\n\r\n.contacts-list-name,\r\n.contacts-list-status {\r\n    display: block;\r\n}\r\n\r\n.contacts-list-name {\r\n    font-weight: 600;\r\n}\r\n\r\n.contacts-list-status {\r\n    font-size: 12px;\r\n}\r\n\r\n.contacts-list-date {\r\n    color: #aaa;\r\n    font-weight: normal;\r\n}\r\n\r\n.contacts-list-msg {\r\n    color: var(--mu-texto-suave, #999);\r\n}\r\n\r\n.direct-chat-danger .right > .direct-chat-text {\r\n    background: #dd4b39;\r\n    border-color: #dd4b39;\r\n    color: #ffffff;\r\n}\r\n\r\n    .direct-chat-danger .right > .direct-chat-text:after,\r\n    .direct-chat-danger .right > .direct-chat-text:before {\r\n        border-left-color: #dd4b39;\r\n    }\r\n\r\n.direct-chat-primary .right > .direct-chat-text {\r\n    background: #3c8dbc;\r\n    border-color: #3c8dbc;\r\n    color: #ffffff;\r\n}\r\n\r\n    .direct-chat-primary .right > .direct-chat-text:after,\r\n    .direct-chat-primary .right > .direct-chat-text:before {\r\n        border-left-color: #3c8dbc;\r\n    }\r\n\r\n.direct-chat-warning .right > .direct-chat-text {\r\n    background: #f39c12;\r\n    border-color: #f39c12;\r\n    color: #ffffff;\r\n}\r\n\r\n    .direct-chat-warning .right > .direct-chat-text:after,\r\n    .direct-chat-warning .right > .direct-chat-text:before {\r\n        border-left-color: #f39c12;\r\n    }\r\n\r\n.direct-chat-info .right > .direct-chat-text {\r\n    background: #00c0ef;\r\n    border-color: #00c0ef;\r\n    color: #ffffff;\r\n}\r\n\r\n    .direct-chat-info .right > .direct-chat-text:after,\r\n    .direct-chat-info .right > .direct-chat-text:before {\r\n        border-left-color: #00c0ef;\r\n    }\r\n\r\n.direct-chat-success .right > .direct-chat-text {\r\n    background: #00a65a;\r\n    border-color: #00a65a;\r\n    color: #ffffff;\r\n}\r\n\r\n    .direct-chat-success .right > .direct-chat-text:after,\r\n    .direct-chat-success .right > .direct-chat-text:before {\r\n        border-left-color: #00a65a;\r\n    }\r\n/*\r\n * Component: Users List\r\n * ---------------------\r\n */\r\n.users-list > li {\r\n    width: 25%;\r\n    float: left;\r\n    padding: 10px;\r\n    text-align: center;\r\n}\r\n\r\n    .users-list > li img {\r\n        border-radius: 50%;\r\n        max-width: 100%;\r\n        height: auto;\r\n    }\r\n\r\n    .users-list > li > a:hover,\r\n    .users-list > li > a:hover .users-list-name {\r\n        color: var(--mu-texto-suave, #999);\r\n    }\r\n\r\n.users-list-name,\r\n.users-list-date {\r\n    display: block;\r\n}\r\n\r\n.users-list-name {\r\n    font-weight: 600;\r\n    color: var(--mu-texto, #444);\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.users-list-date {\r\n    color: var(--mu-texto-suave, #999);\r\n    font-size: 12px;\r\n}\r\n/*\r\n * Component: Carousel\r\n * -------------------\r\n */\r\n.carousel-control.left,\r\n.carousel-control.right {\r\n    background-image: none;\r\n}\r\n\r\n.carousel-control > .fa {\r\n    font-size: 40px;\r\n    position: absolute;\r\n    top: 50%;\r\n    z-index: 5;\r\n    display: inline-block;\r\n    margin-top: -20px;\r\n}\r\n/*\r\n * Component: modal\r\n * ----------------\r\n */\r\n.modal {\r\n    background: rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.modal-content {\r\n    border-radius: 5px;\r\n    -webkit-box-shadow: 0 2px 3px rgba(0, 0, 0, 0.125);\r\n    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.125);\r\n    border: 0;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .modal-content {\r\n        -webkit-box-shadow: 0 2px 3px rgba(0, 0, 0, 0.125);\r\n        box-shadow: 0 2px 3px rgba(0, 0, 0, 0.125);\r\n    }\r\n}\r\n\r\n.modal-header {\r\n    border-bottom-color: var(--mu-borda-sutil, #f4f4f4);\r\n}\r\n\r\n.modal-footer {\r\n    border-top-color: var(--mu-borda-sutil, #f4f4f4);\r\n}\r\n\r\n.modal-primary .modal-header,\r\n.modal-primary .modal-footer {\r\n    border-color: #307095;\r\n}\r\n\r\n.modal-warning .modal-header,\r\n.modal-warning .modal-footer {\r\n    border-color: #c87f0a;\r\n}\r\n\r\n.modal-info .modal-header,\r\n.modal-info .modal-footer {\r\n    border-color: #0097bc;\r\n}\r\n\r\n.modal-success .modal-header,\r\n.modal-success .modal-footer {\r\n    border-color: #00733e;\r\n}\r\n\r\n.modal-danger .modal-header,\r\n.modal-danger .modal-footer {\r\n    border-color: #c23321;\r\n}\r\n/*\r\n * Component: Social Widgets\r\n * -------------------------\r\n */\r\n.box-widget {\r\n    border: none;\r\n    position: relative;\r\n}\r\n\r\n.widget-user .widget-user-header {\r\n    padding: 20px;\r\n    height: 120px;\r\n    border-top-right-radius: 3px;\r\n    border-top-left-radius: 3px;\r\n}\r\n\r\n.widget-user .widget-user-username {\r\n    margin-top: 0;\r\n    margin-bottom: 5px;\r\n    font-size: 25px;\r\n    font-weight: 300;\r\n    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.widget-user .widget-user-desc {\r\n    margin-top: 0;\r\n}\r\n\r\n.widget-user .widget-user-image {\r\n    position: absolute;\r\n    top: 65px;\r\n    left: 50%;\r\n    margin-left: -45px;\r\n}\r\n\r\n    .widget-user .widget-user-image > img {\r\n        width: 90px;\r\n        height: auto;\r\n        border: 3px solid #fff;\r\n    }\r\n\r\n.widget-user .box-footer {\r\n    padding-top: 30px;\r\n}\r\n\r\n.widget-user-2 .widget-user-header {\r\n    padding: 20px;\r\n    border-top-right-radius: 3px;\r\n    border-top-left-radius: 3px;\r\n}\r\n\r\n.widget-user-2 .widget-user-username {\r\n    margin-top: 5px;\r\n    margin-bottom: 5px;\r\n    font-size: 25px;\r\n    font-weight: 300;\r\n}\r\n\r\n.widget-user-2 .widget-user-desc {\r\n    margin-top: 0;\r\n}\r\n\r\n.widget-user-2 .widget-user-username,\r\n.widget-user-2 .widget-user-desc {\r\n    margin-left: 75px;\r\n}\r\n\r\n.widget-user-2 .widget-user-image > img {\r\n    width: 65px;\r\n    height: auto;\r\n    float: left;\r\n}\r\n\r\n.treeview-menu {\r\n    display: none;\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0;\r\n    padding-left: 5px;\r\n}\r\n\r\n    .treeview-menu .treeview-menu {\r\n        padding-left: 20px;\r\n    }\r\n\r\n    .treeview-menu > li {\r\n        margin: 0;\r\n    }\r\n\r\n        .treeview-menu > li > a {\r\n            padding: 5px 5px 5px 15px;\r\n            display: block;\r\n            font-size: 14px;\r\n        }\r\n\r\n            .treeview-menu > li > a > .fa,\r\n            .treeview-menu > li > a > .glyphicon,\r\n            .treeview-menu > li > a > .ion {\r\n                width: 20px;\r\n            }\r\n\r\n            .treeview-menu > li > a > .pull-right-container > .fa-angle-left,\r\n            .treeview-menu > li > a > .pull-right-container > .fa-angle-down,\r\n            .treeview-menu > li > a > .fa-angle-left,\r\n            .treeview-menu > li > a > .fa-angle-down {\r\n                width: auto;\r\n            }\r\n/*\r\n * Page: Mailbox\r\n * -------------\r\n */\r\n.mailbox-messages > .table {\r\n    margin: 0;\r\n}\r\n\r\n.mailbox-controls {\r\n    padding: 5px;\r\n}\r\n\r\n    .mailbox-controls.with-border {\r\n        border-bottom: 1px solid var(--mu-borda-sutil, #f4f4f4);\r\n    }\r\n\r\n.mailbox-read-info {\r\n    border-bottom: 1px solid var(--mu-borda-sutil, #f4f4f4);\r\n    padding: 10px;\r\n}\r\n\r\n    .mailbox-read-info h3 {\r\n        font-size: 20px;\r\n        margin: 0;\r\n    }\r\n\r\n    .mailbox-read-info h5 {\r\n        margin: 0;\r\n        padding: 5px 0 0 0;\r\n    }\r\n\r\n.mailbox-read-time {\r\n    color: var(--mu-texto-suave, #999);\r\n    font-size: 13px;\r\n}\r\n\r\n.mailbox-read-message {\r\n    padding: 10px;\r\n}\r\n\r\n.mailbox-attachments li {\r\n    float: left;\r\n    width: 200px;\r\n    border: 1px solid var(--mu-borda-sutil, #eee);\r\n    margin-bottom: 10px;\r\n    margin-right: 10px;\r\n}\r\n\r\n.mailbox-attachment-name {\r\n    font-weight: bold;\r\n    color: var(--mu-texto-suave, #666);\r\n}\r\n\r\n.mailbox-attachment-icon,\r\n.mailbox-attachment-info,\r\n.mailbox-attachment-size {\r\n    display: block;\r\n}\r\n\r\n.mailbox-attachment-info {\r\n    padding: 10px;\r\n    background: var(--mu-superficie-sutil, #f4f4f4);\r\n}\r\n\r\n.mailbox-attachment-size {\r\n    color: var(--mu-texto-suave, #999);\r\n    font-size: 12px;\r\n}\r\n\r\n.mailbox-attachment-icon {\r\n    text-align: center;\r\n    font-size: 65px;\r\n    color: var(--mu-texto-suave, #666);\r\n    padding: 20px 10px;\r\n}\r\n\r\n    .mailbox-attachment-icon.has-img {\r\n        padding: 0;\r\n    }\r\n\r\n        .mailbox-attachment-icon.has-img > img {\r\n            max-width: 100%;\r\n            height: auto;\r\n        }\r\n/*\r\n * Page: Lock Screen\r\n * -----------------\r\n */\r\n/* ADD THIS CLASS TO THE <BODY> TAG */\r\n.lockscreen {\r\n    background: var(--mu-superficie-forte, #d2d6de);\r\n}\r\n\r\n.lockscreen-logo {\r\n    font-size: 35px;\r\n    text-align: center;\r\n    margin-bottom: 25px;\r\n    font-weight: 300;\r\n}\r\n\r\n    .lockscreen-logo a {\r\n        color: var(--mu-texto, #444);\r\n    }\r\n\r\n.lockscreen-wrapper {\r\n    max-width: 400px;\r\n    margin: 0 auto;\r\n    margin-top: 10%;\r\n}\r\n/* User name [optional] */\r\n.lockscreen .lockscreen-name {\r\n    text-align: center;\r\n    font-weight: 600;\r\n}\r\n/* Will contain the image and the sign in form */\r\n.lockscreen-item {\r\n    border-radius: 4px;\r\n    padding: 0;\r\n    background: var(--mu-superficie, #fff);\r\n    position: relative;\r\n    margin: 10px auto 30px auto;\r\n    width: 290px;\r\n}\r\n/* User image */\r\n.lockscreen-image {\r\n    border-radius: 50%;\r\n    position: absolute;\r\n    left: -10px;\r\n    top: -25px;\r\n    background: var(--mu-superficie, #fff);\r\n    padding: 5px;\r\n    z-index: 10;\r\n}\r\n\r\n    .lockscreen-image > img {\r\n        border-radius: 50%;\r\n        width: 70px;\r\n        height: 70px;\r\n    }\r\n/* Contains the password input and the login button */\r\n.lockscreen-credentials {\r\n    margin-left: 70px;\r\n}\r\n\r\n    .lockscreen-credentials .form-control {\r\n        border: 0;\r\n    }\r\n\r\n    .lockscreen-credentials .btn {\r\n        background-color: var(--mu-superficie, #fff);\r\n        border: 0;\r\n        padding: 0 10px;\r\n    }\r\n\r\n.lockscreen-footer {\r\n    margin-top: 10px;\r\n}\r\n/*\r\n * Page: Login & Register\r\n * ----------------------\r\n */\r\n.login-logo,\r\n.register-logo {\r\n    font-size: 35px;\r\n    text-align: center;\r\n    margin-bottom: 25px;\r\n    font-weight: 300;\r\n}\r\n\r\n    .login-logo a,\r\n    .register-logo a {\r\n        color: var(--mu-texto, #444);\r\n    }\r\n\r\n.login-page,\r\n.register-page {\r\n    background: var(--mu-superficie-forte, #d2d6de);\r\n}\r\n\r\n.login-box,\r\n.register-box {\r\n    width: 360px;\r\n    margin: 7% auto;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .login-box,\r\n    .register-box {\r\n        width: 90%;\r\n        margin-top: 20px;\r\n    }\r\n}\r\n\r\n.login-box-body,\r\n.register-box-body {\r\n    background: var(--mu-superficie, #fff);\r\n    padding: 20px;\r\n    border-top: 0;\r\n    color: var(--mu-texto-suave, #666);\r\n}\r\n\r\n    .login-box-body .form-control-feedback,\r\n    .register-box-body .form-control-feedback {\r\n        color: var(--mu-texto-suave, #777);\r\n    }\r\n\r\n.login-box-msg,\r\n.register-box-msg {\r\n    margin: 0;\r\n    text-align: center;\r\n    padding: 0 20px 20px 20px;\r\n}\r\n\r\n.social-auth-links {\r\n    margin: 10px 0;\r\n}\r\n/*\r\n * Page: 400 and 500 error pages\r\n * ------------------------------\r\n */\r\n.error-page {\r\n    width: 600px;\r\n    margin: 20px auto 0 auto;\r\n}\r\n\r\n@media (max-width: 991px) {\r\n    .error-page {\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n.error-page > .headline {\r\n    float: left;\r\n    font-size: 100px;\r\n    font-weight: 300;\r\n}\r\n\r\n@media (max-width: 991px) {\r\n    .error-page > .headline {\r\n        float: none;\r\n        text-align: center;\r\n    }\r\n}\r\n\r\n.error-page > .error-content {\r\n    margin-left: 190px;\r\n    display: block;\r\n}\r\n\r\n@media (max-width: 991px) {\r\n    .error-page > .error-content {\r\n        margin-left: 0;\r\n    }\r\n}\r\n\r\n.error-page > .error-content > h3 {\r\n    font-weight: 300;\r\n    font-size: 25px;\r\n}\r\n\r\n@media (max-width: 991px) {\r\n    .error-page > .error-content > h3 {\r\n        text-align: center;\r\n    }\r\n}\r\n/*\r\n * Page: Invoice\r\n * -------------\r\n */\r\n.invoice {\r\n    position: relative;\r\n    background: var(--mu-superficie, #fff);\r\n    border: 1px solid var(--mu-borda-sutil, #f4f4f4);\r\n    padding: 20px;\r\n    margin: 10px 25px;\r\n}\r\n\r\n.invoice-title {\r\n    margin-top: 0;\r\n}\r\n/*\r\n * Page: Profile\r\n * -------------\r\n */\r\n.profile-user-img {\r\n    margin: 0 auto;\r\n    width: 100px;\r\n    padding: 3px;\r\n    border: 3px solid var(--mu-borda-forte, #d2d6de);\r\n}\r\n\r\n.profile-username {\r\n    font-size: 21px;\r\n    margin-top: 5px;\r\n}\r\n\r\n.post {\r\n    border-bottom: 1px solid var(--mu-borda-forte, #d2d6de);\r\n    margin-bottom: 15px;\r\n    padding-bottom: 15px;\r\n    color: var(--mu-texto-suave, #666);\r\n}\r\n\r\n    .post:last-of-type {\r\n        border-bottom: 0;\r\n        margin-bottom: 0;\r\n        padding-bottom: 0;\r\n    }\r\n\r\n    .post .user-block {\r\n        margin-bottom: 15px;\r\n    }\r\n/*\r\n * Social Buttons for Bootstrap\r\n *\r\n * Copyright 2013-2015 Panayiotis Lipiridis\r\n * Licensed under the MIT License\r\n *\r\n * https://github.com/lipis/bootstrap-social\r\n */\r\n.btn-social {\r\n    position: relative;\r\n    padding-left: 44px;\r\n    text-align: left;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n    .btn-social > :first-child {\r\n        position: absolute;\r\n        left: 0;\r\n        top: 0;\r\n        bottom: 0;\r\n        width: 32px;\r\n        line-height: 34px;\r\n        font-size: 1.6em;\r\n        text-align: center;\r\n        border-right: 1px solid rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-social.btn-lg {\r\n        padding-left: 61px;\r\n    }\r\n\r\n        .btn-social.btn-lg > :first-child {\r\n            line-height: 45px;\r\n            width: 45px;\r\n            font-size: 1.8em;\r\n        }\r\n\r\n    .btn-social.btn-sm {\r\n        padding-left: 38px;\r\n    }\r\n\r\n        .btn-social.btn-sm > :first-child {\r\n            line-height: 28px;\r\n            width: 28px;\r\n            font-size: 1.4em;\r\n        }\r\n\r\n    .btn-social.btn-xs {\r\n        padding-left: 30px;\r\n    }\r\n\r\n        .btn-social.btn-xs > :first-child {\r\n            line-height: 20px;\r\n            width: 20px;\r\n            font-size: 1.2em;\r\n        }\r\n\r\n.btn-social-icon {\r\n    position: relative;\r\n    padding-left: 44px;\r\n    text-align: left;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    height: 34px;\r\n    width: 34px;\r\n    padding: 0;\r\n}\r\n\r\n    .btn-social-icon > :first-child {\r\n        position: absolute;\r\n        left: 0;\r\n        top: 0;\r\n        bottom: 0;\r\n        width: 32px;\r\n        line-height: 34px;\r\n        font-size: 1.6em;\r\n        text-align: center;\r\n        border-right: 1px solid rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-social-icon.btn-lg {\r\n        padding-left: 61px;\r\n    }\r\n\r\n        .btn-social-icon.btn-lg > :first-child {\r\n            line-height: 45px;\r\n            width: 45px;\r\n            font-size: 1.8em;\r\n        }\r\n\r\n    .btn-social-icon.btn-sm {\r\n        padding-left: 38px;\r\n    }\r\n\r\n        .btn-social-icon.btn-sm > :first-child {\r\n            line-height: 28px;\r\n            width: 28px;\r\n            font-size: 1.4em;\r\n        }\r\n\r\n    .btn-social-icon.btn-xs {\r\n        padding-left: 30px;\r\n    }\r\n\r\n        .btn-social-icon.btn-xs > :first-child {\r\n            line-height: 20px;\r\n            width: 20px;\r\n            font-size: 1.2em;\r\n        }\r\n\r\n    .btn-social-icon > :first-child {\r\n        border: none;\r\n        text-align: center;\r\n        width: 100%;\r\n    }\r\n\r\n    .btn-social-icon.btn-lg {\r\n        height: 45px;\r\n        width: 45px;\r\n        padding-left: 0;\r\n        padding-right: 0;\r\n    }\r\n\r\n    .btn-social-icon.btn-sm {\r\n        height: 30px;\r\n        width: 30px;\r\n        padding-left: 0;\r\n        padding-right: 0;\r\n    }\r\n\r\n    .btn-social-icon.btn-xs {\r\n        height: 22px;\r\n        width: 22px;\r\n        padding-left: 0;\r\n        padding-right: 0;\r\n    }\r\n\r\n.btn-adn {\r\n    color: #ffffff;\r\n    background-color: #d87a68;\r\n    border-color: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n    .btn-adn:focus,\r\n    .btn-adn.focus {\r\n        color: #ffffff;\r\n        background-color: #ce563f;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-adn:hover {\r\n        color: #ffffff;\r\n        background-color: #ce563f;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-adn:active,\r\n    .btn-adn.active,\r\n    .open > .dropdown-toggle.btn-adn {\r\n        color: #ffffff;\r\n        background-color: #ce563f;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-adn:active,\r\n    .btn-adn.active,\r\n    .open > .dropdown-toggle.btn-adn {\r\n        background-image: none;\r\n    }\r\n\r\n    .btn-adn .badge {\r\n        color: #d87a68;\r\n        background-color: var(--mu-superficie, #ffffff);\r\n    }\r\n\r\n.btn-bitbucket {\r\n    color: #ffffff;\r\n    background-color: #205081;\r\n    border-color: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n    .btn-bitbucket:focus,\r\n    .btn-bitbucket.focus {\r\n        color: #ffffff;\r\n        background-color: #163758;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-bitbucket:hover {\r\n        color: #ffffff;\r\n        background-color: #163758;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-bitbucket:active,\r\n    .btn-bitbucket.active,\r\n    .open > .dropdown-toggle.btn-bitbucket {\r\n        color: #ffffff;\r\n        background-color: #163758;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-bitbucket:active,\r\n    .btn-bitbucket.active,\r\n    .open > .dropdown-toggle.btn-bitbucket {\r\n        background-image: none;\r\n    }\r\n\r\n    .btn-bitbucket .badge {\r\n        color: #205081;\r\n        background-color: var(--mu-superficie, #ffffff);\r\n    }\r\n\r\n.btn-dropbox {\r\n    color: #ffffff;\r\n    background-color: #1087dd;\r\n    border-color: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n    .btn-dropbox:focus,\r\n    .btn-dropbox.focus {\r\n        color: #ffffff;\r\n        background-color: #0d6aad;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-dropbox:hover {\r\n        color: #ffffff;\r\n        background-color: #0d6aad;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-dropbox:active,\r\n    .btn-dropbox.active,\r\n    .open > .dropdown-toggle.btn-dropbox {\r\n        color: #ffffff;\r\n        background-color: #0d6aad;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-dropbox:active,\r\n    .btn-dropbox.active,\r\n    .open > .dropdown-toggle.btn-dropbox {\r\n        background-image: none;\r\n    }\r\n\r\n    .btn-dropbox .badge {\r\n        color: #1087dd;\r\n        background-color: var(--mu-superficie, #ffffff);\r\n    }\r\n\r\n.btn-facebook {\r\n    color: #ffffff;\r\n    background-color: #3b5998;\r\n    border-color: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n    .btn-facebook:focus,\r\n    .btn-facebook.focus {\r\n        color: #ffffff;\r\n        background-color: #2d4373;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-facebook:hover {\r\n        color: #ffffff;\r\n        background-color: #2d4373;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-facebook:active,\r\n    .btn-facebook.active,\r\n    .open > .dropdown-toggle.btn-facebook {\r\n        color: #ffffff;\r\n        background-color: #2d4373;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-facebook:active,\r\n    .btn-facebook.active,\r\n    .open > .dropdown-toggle.btn-facebook {\r\n        background-image: none;\r\n    }\r\n\r\n    .btn-facebook .badge {\r\n        color: #3b5998;\r\n        background-color: var(--mu-superficie, #ffffff);\r\n    }\r\n\r\n.btn-flickr {\r\n    color: #ffffff;\r\n    background-color: #ff0084;\r\n    border-color: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n    .btn-flickr:focus,\r\n    .btn-flickr.focus {\r\n        color: #ffffff;\r\n        background-color: #cc006a;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-flickr:hover {\r\n        color: #ffffff;\r\n        background-color: #cc006a;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-flickr:active,\r\n    .btn-flickr.active,\r\n    .open > .dropdown-toggle.btn-flickr {\r\n        color: #ffffff;\r\n        background-color: #cc006a;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-flickr:active,\r\n    .btn-flickr.active,\r\n    .open > .dropdown-toggle.btn-flickr {\r\n        background-image: none;\r\n    }\r\n\r\n    .btn-flickr .badge {\r\n        color: #ff0084;\r\n        background-color: var(--mu-superficie, #ffffff);\r\n    }\r\n\r\n.btn-foursquare {\r\n    color: #ffffff;\r\n    background-color: #f94877;\r\n    border-color: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n    .btn-foursquare:focus,\r\n    .btn-foursquare.focus {\r\n        color: #ffffff;\r\n        background-color: #f71752;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-foursquare:hover {\r\n        color: #ffffff;\r\n        background-color: #f71752;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-foursquare:active,\r\n    .btn-foursquare.active,\r\n    .open > .dropdown-toggle.btn-foursquare {\r\n        color: #ffffff;\r\n        background-color: #f71752;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-foursquare:active,\r\n    .btn-foursquare.active,\r\n    .open > .dropdown-toggle.btn-foursquare {\r\n        background-image: none;\r\n    }\r\n\r\n    .btn-foursquare .badge {\r\n        color: #f94877;\r\n        background-color: var(--mu-superficie, #ffffff);\r\n    }\r\n\r\n.btn-github {\r\n    color: #ffffff;\r\n    background-color: #444444;\r\n    border-color: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n    .btn-github:focus,\r\n    .btn-github.focus {\r\n        color: #ffffff;\r\n        background-color: #2b2b2b;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-github:hover {\r\n        color: #ffffff;\r\n        background-color: #2b2b2b;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-github:active,\r\n    .btn-github.active,\r\n    .open > .dropdown-toggle.btn-github {\r\n        color: #ffffff;\r\n        background-color: #2b2b2b;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-github:active,\r\n    .btn-github.active,\r\n    .open > .dropdown-toggle.btn-github {\r\n        background-image: none;\r\n    }\r\n\r\n    .btn-github .badge {\r\n        color: var(--mu-texto, #444444);\r\n        background-color: var(--mu-superficie, #ffffff);\r\n    }\r\n\r\n.btn-google {\r\n    color: #ffffff;\r\n    background-color: #dd4b39;\r\n    border-color: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n    .btn-google:focus,\r\n    .btn-google.focus {\r\n        color: #ffffff;\r\n        background-color: #c23321;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-google:hover {\r\n        color: #ffffff;\r\n        background-color: #c23321;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-google:active,\r\n    .btn-google.active,\r\n    .open > .dropdown-toggle.btn-google {\r\n        color: #ffffff;\r\n        background-color: #c23321;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-google:active,\r\n    .btn-google.active,\r\n    .open > .dropdown-toggle.btn-google {\r\n        background-image: none;\r\n    }\r\n\r\n    .btn-google .badge {\r\n        color: #dd4b39;\r\n        background-color: var(--mu-superficie, #ffffff);\r\n    }\r\n\r\n.btn-instagram {\r\n    color: #ffffff;\r\n    background-color: #3f729b;\r\n    border-color: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n    .btn-instagram:focus,\r\n    .btn-instagram.focus {\r\n        color: #ffffff;\r\n        background-color: #305777;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-instagram:hover {\r\n        color: #ffffff;\r\n        background-color: #305777;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-instagram:active,\r\n    .btn-instagram.active,\r\n    .open > .dropdown-toggle.btn-instagram {\r\n        color: #ffffff;\r\n        background-color: #305777;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-instagram:active,\r\n    .btn-instagram.active,\r\n    .open > .dropdown-toggle.btn-instagram {\r\n        background-image: none;\r\n    }\r\n\r\n    .btn-instagram .badge {\r\n        color: #3f729b;\r\n        background-color: var(--mu-superficie, #ffffff);\r\n    }\r\n\r\n.btn-linkedin {\r\n    color: #ffffff;\r\n    background-color: #007bb6;\r\n    border-color: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n    .btn-linkedin:focus,\r\n    .btn-linkedin.focus {\r\n        color: #ffffff;\r\n        background-color: #005983;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-linkedin:hover {\r\n        color: #ffffff;\r\n        background-color: #005983;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-linkedin:active,\r\n    .btn-linkedin.active,\r\n    .open > .dropdown-toggle.btn-linkedin {\r\n        color: #ffffff;\r\n        background-color: #005983;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-linkedin:active,\r\n    .btn-linkedin.active,\r\n    .open > .dropdown-toggle.btn-linkedin {\r\n        background-image: none;\r\n    }\r\n\r\n    .btn-linkedin .badge {\r\n        color: #007bb6;\r\n        background-color: var(--mu-superficie, #ffffff);\r\n    }\r\n\r\n.btn-microsoft {\r\n    color: #ffffff;\r\n    background-color: #2672ec;\r\n    border-color: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n    .btn-microsoft:focus,\r\n    .btn-microsoft.focus {\r\n        color: #ffffff;\r\n        background-color: #125acd;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-microsoft:hover {\r\n        color: #ffffff;\r\n        background-color: #125acd;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-microsoft:active,\r\n    .btn-microsoft.active,\r\n    .open > .dropdown-toggle.btn-microsoft {\r\n        color: #ffffff;\r\n        background-color: #125acd;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-microsoft:active,\r\n    .btn-microsoft.active,\r\n    .open > .dropdown-toggle.btn-microsoft {\r\n        background-image: none;\r\n    }\r\n\r\n    .btn-microsoft .badge {\r\n        color: #2672ec;\r\n        background-color: var(--mu-superficie, #ffffff);\r\n    }\r\n\r\n.btn-openid {\r\n    color: #ffffff;\r\n    background-color: #f7931e;\r\n    border-color: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n    .btn-openid:focus,\r\n    .btn-openid.focus {\r\n        color: #ffffff;\r\n        background-color: #da7908;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-openid:hover {\r\n        color: #ffffff;\r\n        background-color: #da7908;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-openid:active,\r\n    .btn-openid.active,\r\n    .open > .dropdown-toggle.btn-openid {\r\n        color: #ffffff;\r\n        background-color: #da7908;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-openid:active,\r\n    .btn-openid.active,\r\n    .open > .dropdown-toggle.btn-openid {\r\n        background-image: none;\r\n    }\r\n\r\n    .btn-openid .badge {\r\n        color: #f7931e;\r\n        background-color: var(--mu-superficie, #ffffff);\r\n    }\r\n\r\n.btn-pinterest {\r\n    color: #ffffff;\r\n    background-color: #cb2027;\r\n    border-color: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n    .btn-pinterest:focus,\r\n    .btn-pinterest.focus {\r\n        color: #ffffff;\r\n        background-color: #9f191f;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-pinterest:hover {\r\n        color: #ffffff;\r\n        background-color: #9f191f;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-pinterest:active,\r\n    .btn-pinterest.active,\r\n    .open > .dropdown-toggle.btn-pinterest {\r\n        color: #ffffff;\r\n        background-color: #9f191f;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-pinterest:active,\r\n    .btn-pinterest.active,\r\n    .open > .dropdown-toggle.btn-pinterest {\r\n        background-image: none;\r\n    }\r\n\r\n    .btn-pinterest .badge {\r\n        color: #cb2027;\r\n        background-color: var(--mu-superficie, #ffffff);\r\n    }\r\n\r\n.btn-reddit {\r\n    color: var(--mu-texto, #000000);\r\n    background-color: var(--mu-superficie-azul, #eff7ff);\r\n    border-color: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n    .btn-reddit:focus,\r\n    .btn-reddit.focus {\r\n        color: var(--mu-texto, #000000);\r\n        background-color: var(--mu-superficie-azul, #bcddff);\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-reddit:hover {\r\n        color: var(--mu-texto, #000000);\r\n        background-color: var(--mu-superficie-azul, #bcddff);\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-reddit:active,\r\n    .btn-reddit.active,\r\n    .open > .dropdown-toggle.btn-reddit {\r\n        color: var(--mu-texto, #000000);\r\n        background-color: var(--mu-superficie-azul, #bcddff);\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-reddit:active,\r\n    .btn-reddit.active,\r\n    .open > .dropdown-toggle.btn-reddit {\r\n        background-image: none;\r\n    }\r\n\r\n    .btn-reddit .badge {\r\n        color: #eff7ff;\r\n        background-color: #000000;\r\n    }\r\n\r\n.btn-soundcloud {\r\n    color: #ffffff;\r\n    background-color: #ff5500;\r\n    border-color: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n    .btn-soundcloud:focus,\r\n    .btn-soundcloud.focus {\r\n        color: #ffffff;\r\n        background-color: #cc4400;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-soundcloud:hover {\r\n        color: #ffffff;\r\n        background-color: #cc4400;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-soundcloud:active,\r\n    .btn-soundcloud.active,\r\n    .open > .dropdown-toggle.btn-soundcloud {\r\n        color: #ffffff;\r\n        background-color: #cc4400;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-soundcloud:active,\r\n    .btn-soundcloud.active,\r\n    .open > .dropdown-toggle.btn-soundcloud {\r\n        background-image: none;\r\n    }\r\n\r\n    .btn-soundcloud .badge {\r\n        color: #ff5500;\r\n        background-color: var(--mu-superficie, #ffffff);\r\n    }\r\n\r\n.btn-tumblr {\r\n    color: #ffffff;\r\n    background-color: #2c4762;\r\n    border-color: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n    .btn-tumblr:focus,\r\n    .btn-tumblr.focus {\r\n        color: #ffffff;\r\n        background-color: #1c2d3f;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-tumblr:hover {\r\n        color: #ffffff;\r\n        background-color: #1c2d3f;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-tumblr:active,\r\n    .btn-tumblr.active,\r\n    .open > .dropdown-toggle.btn-tumblr {\r\n        color: #ffffff;\r\n        background-color: #1c2d3f;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-tumblr:active,\r\n    .btn-tumblr.active,\r\n    .open > .dropdown-toggle.btn-tumblr {\r\n        background-image: none;\r\n    }\r\n\r\n    .btn-tumblr .badge {\r\n        color: #2c4762;\r\n        background-color: var(--mu-superficie, #ffffff);\r\n    }\r\n\r\n.btn-twitter {\r\n    color: #ffffff;\r\n    background-color: #55acee;\r\n    border-color: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n    .btn-twitter:focus,\r\n    .btn-twitter.focus {\r\n        color: #ffffff;\r\n        background-color: #2795e9;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-twitter:hover {\r\n        color: #ffffff;\r\n        background-color: #2795e9;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-twitter:active,\r\n    .btn-twitter.active,\r\n    .open > .dropdown-toggle.btn-twitter {\r\n        color: #ffffff;\r\n        background-color: #2795e9;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-twitter:active,\r\n    .btn-twitter.active,\r\n    .open > .dropdown-toggle.btn-twitter {\r\n        background-image: none;\r\n    }\r\n\r\n    .btn-twitter .badge {\r\n        color: #55acee;\r\n        background-color: var(--mu-superficie, #ffffff);\r\n    }\r\n\r\n.btn-vimeo {\r\n    color: #ffffff;\r\n    background-color: #1ab7ea;\r\n    border-color: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n    .btn-vimeo:focus,\r\n    .btn-vimeo.focus {\r\n        color: #ffffff;\r\n        background-color: #1295bf;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-vimeo:hover {\r\n        color: #ffffff;\r\n        background-color: #1295bf;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-vimeo:active,\r\n    .btn-vimeo.active,\r\n    .open > .dropdown-toggle.btn-vimeo {\r\n        color: #ffffff;\r\n        background-color: #1295bf;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-vimeo:active,\r\n    .btn-vimeo.active,\r\n    .open > .dropdown-toggle.btn-vimeo {\r\n        background-image: none;\r\n    }\r\n\r\n    .btn-vimeo .badge {\r\n        color: #1ab7ea;\r\n        background-color: var(--mu-superficie, #ffffff);\r\n    }\r\n\r\n.btn-vk {\r\n    color: #ffffff;\r\n    background-color: #587ea3;\r\n    border-color: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n    .btn-vk:focus,\r\n    .btn-vk.focus {\r\n        color: #ffffff;\r\n        background-color: #466482;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-vk:hover {\r\n        color: #ffffff;\r\n        background-color: #466482;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-vk:active,\r\n    .btn-vk.active,\r\n    .open > .dropdown-toggle.btn-vk {\r\n        color: #ffffff;\r\n        background-color: #466482;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-vk:active,\r\n    .btn-vk.active,\r\n    .open > .dropdown-toggle.btn-vk {\r\n        background-image: none;\r\n    }\r\n\r\n    .btn-vk .badge {\r\n        color: #587ea3;\r\n        background-color: var(--mu-superficie, #ffffff);\r\n    }\r\n\r\n.btn-yahoo {\r\n    color: #ffffff;\r\n    background-color: #720e9e;\r\n    border-color: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n    .btn-yahoo:focus,\r\n    .btn-yahoo.focus {\r\n        color: #ffffff;\r\n        background-color: #500a6f;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-yahoo:hover {\r\n        color: #ffffff;\r\n        background-color: #500a6f;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-yahoo:active,\r\n    .btn-yahoo.active,\r\n    .open > .dropdown-toggle.btn-yahoo {\r\n        color: #ffffff;\r\n        background-color: #500a6f;\r\n        border-color: rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    .btn-yahoo:active,\r\n    .btn-yahoo.active,\r\n    .open > .dropdown-toggle.btn-yahoo {\r\n        background-image: none;\r\n    }\r\n\r\n    .btn-yahoo .badge {\r\n        color: #720e9e;\r\n        background-color: var(--mu-superficie, #ffffff);\r\n    }\r\n/*\r\n * Plugin: Full Calendar\r\n * ---------------------\r\n */\r\n.fc-button {\r\n    background: var(--mu-superficie-sutil, #f4f4f4);\r\n    background-image: none;\r\n    color: var(--mu-texto, #444);\r\n    border-color: var(--mu-borda-media, #ddd);\r\n    border-bottom-color: var(--mu-borda-media, #ddd);\r\n}\r\n\r\n    .fc-button:hover,\r\n    .fc-button:active,\r\n    .fc-button.hover {\r\n        background-color: var(--mu-superficie-sutil, #e9e9e9);\r\n    }\r\n\r\n.fc-header-title h2 {\r\n    font-size: 15px;\r\n    line-height: 1.6em;\r\n    color: var(--mu-texto-suave, #666);\r\n    margin-left: 10px;\r\n}\r\n\r\n.fc-header-right {\r\n    padding-right: 10px;\r\n}\r\n\r\n.fc-header-left {\r\n    padding-left: 10px;\r\n}\r\n\r\n.fc-widget-header {\r\n    background: var(--mu-superficie-sutil, #fafafa);\r\n}\r\n\r\n.fc-grid {\r\n    width: 100%;\r\n    border: 0;\r\n}\r\n\r\n.fc-widget-header:first-of-type,\r\n.fc-widget-content:first-of-type {\r\n    border-left: 0;\r\n    border-right: 0;\r\n}\r\n\r\n.fc-widget-header:last-of-type,\r\n.fc-widget-content:last-of-type {\r\n    border-right: 0;\r\n}\r\n\r\n.fc-toolbar {\r\n    padding: 10px;\r\n    margin: 0;\r\n}\r\n\r\n.fc-day-number {\r\n    font-size: 20px;\r\n    font-weight: 300;\r\n    padding-right: 10px;\r\n}\r\n\r\n.fc-color-picker {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n    .fc-color-picker > li {\r\n        float: left;\r\n        font-size: 30px;\r\n        margin-right: 5px;\r\n        line-height: 30px;\r\n    }\r\n\r\n        .fc-color-picker > li .fa {\r\n            -webkit-transition: -webkit-transform linear 0.3s;\r\n            -moz-transition: -moz-transform linear 0.3s;\r\n            -o-transition: -o-transform linear 0.3s;\r\n            transition: transform linear 0.3s;\r\n        }\r\n\r\n            .fc-color-picker > li .fa:hover {\r\n                -webkit-transform: rotate(30deg);\r\n                -ms-transform: rotate(30deg);\r\n                -o-transform: rotate(30deg);\r\n                transform: rotate(30deg);\r\n            }\r\n\r\n#add-new-event {\r\n    -webkit-transition: all linear 0.3s;\r\n    -o-transition: all linear 0.3s;\r\n    transition: all linear 0.3s;\r\n}\r\n\r\n.external-event {\r\n    padding: 5px 10px;\r\n    font-weight: bold;\r\n    margin-bottom: 4px;\r\n    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\r\n    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\r\n    border-radius: 3px;\r\n    cursor: move;\r\n}\r\n\r\n    .external-event:hover {\r\n        box-shadow: inset 0 0 90px rgba(0, 0, 0, 0.2);\r\n    }\r\n/*\r\n * Plugin: Select2\r\n * ---------------\r\n */\r\n.select2-container--default.select2-container--focus,\r\n.select2-selection.select2-container--focus,\r\n.select2-container--default:focus,\r\n.select2-selection:focus,\r\n.select2-container--default:active,\r\n.select2-selection:active {\r\n    outline: none;\r\n}\r\n\r\n.select2-container--default .select2-selection--single,\r\n.select2-selection .select2-selection--single {\r\n    border: 1px solid var(--mu-borda-forte, #d2d6de);\r\n    border-radius: 0;\r\n    /*padding: 6px 12px;*/\r\n    padding: 4px 1px 2px 0px;\r\n    height: 34px;\r\n}\r\n\r\n.select2-container--default.select2-container--open {\r\n    border-color: #3c8dbc;\r\n}\r\n\r\n.select2-dropdown {\r\n    border: 1px solid var(--mu-borda-forte, #d2d6de);\r\n    border-radius: 0;\r\n    min-width: 270px !important; /*FNX-5270*/\r\n}\r\n\r\n.select2-container--default .select2-results__option--highlighted[aria-selected] {\r\n    background-color: #3c8dbc;\r\n    color: white;\r\n}\r\n\r\n.select2-results__option {\r\n    padding: 6px 12px;\r\n    user-select: none;\r\n    -webkit-user-select: none;\r\n}\r\n\r\n.select2-container .select2-selection--single .select2-selection__rendered {\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n    height: auto;\r\n    margin-top: -4px;\r\n}\r\n\r\n.select2-container[dir=\"rtl\"] .select2-selection--single .select2-selection__rendered {\r\n    padding-right: 1px;\r\n    padding-left: 20px;\r\n}\r\n\r\n.select2-container--default .select2-selection--single .select2-selection__arrow {\r\n    height: 28px;\r\n    right: 3px;\r\n}\r\n\r\n    .select2-container--default .select2-selection--single .select2-selection__arrow b {\r\n        margin-top: 0;\r\n    }\r\n\r\n.select2-dropdown .select2-search__field,\r\n.select2-search--inline .select2-search__field {\r\n    border: 1px solid var(--mu-borda-forte, #d2d6de);\r\n}\r\n\r\n    .select2-dropdown .select2-search__field:focus,\r\n    .select2-search--inline .select2-search__field:focus {\r\n        outline: none;\r\n    }\r\n\r\n.select2-container--default.select2-container--focus .select2-selection--multiple,\r\n.select2-container--default .select2-search--dropdown .select2-search__field {\r\n    border-color: #3c8dbc !important;\r\n}\r\n\r\n.select2-container--default .select2-results__option[aria-disabled=true] {\r\n    color: var(--mu-texto-suave, #999);\r\n}\r\n\r\n.select2-container--default .select2-results__option[aria-selected=true] {\r\n    background-color: var(--mu-superficie-forte, #ddd);\r\n}\r\n\r\n    .select2-container--default .select2-results__option[aria-selected=true],\r\n    .select2-container--default .select2-results__option[aria-selected=true]:hover {\r\n        color: var(--mu-texto, #444);\r\n    }\r\n\r\n.select2-container--default .select2-selection--multiple {\r\n    border: 1px solid var(--mu-borda-forte, #d2d6de);\r\n    border-radius: 0;\r\n}\r\n\r\n    .select2-container--default .select2-selection--multiple:focus {\r\n        border-color: #3c8dbc;\r\n    }\r\n\r\n.select2-container--default.select2-container--focus .select2-selection--multiple {\r\n    border-color: var(--mu-borda-forte, #d2d6de);\r\n}\r\n\r\n.select2-container--default .select2-selection--multiple .select2-selection__choice {\r\n    background-color: #3c8dbc;\r\n    border-color: #367fa9;\r\n    padding: 1px 10px;\r\n    color: #fff;\r\n}\r\n\r\n.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {\r\n    margin-right: 5px;\r\n    color: rgba(255, 255, 255, 0.7);\r\n}\r\n\r\n    .select2-container--default .select2-selection--multiple .select2-selection__choice__remove:hover {\r\n        color: #fff;\r\n    }\r\n\r\n.select2-container .select2-selection--single .select2-selection__rendered {\r\n    padding-right: 10px;\r\n}\r\n\r\n.box .datepicker-inline,\r\n.box .datepicker-inline .datepicker-days,\r\n.box .datepicker-inline > table,\r\n.box .datepicker-inline .datepicker-days > table {\r\n    width: 100%;\r\n}\r\n\r\n    .box .datepicker-inline td:hover,\r\n    .box .datepicker-inline .datepicker-days td:hover,\r\n    .box .datepicker-inline > table td:hover,\r\n    .box .datepicker-inline .datepicker-days > table td:hover {\r\n        background-color: rgba(255, 255, 255, 0.3);\r\n    }\r\n\r\n    .box .datepicker-inline td.day.old,\r\n    .box .datepicker-inline .datepicker-days td.day.old,\r\n    .box .datepicker-inline > table td.day.old,\r\n    .box .datepicker-inline .datepicker-days > table td.day.old,\r\n    .box .datepicker-inline td.day.new,\r\n    .box .datepicker-inline .datepicker-days td.day.new,\r\n    .box .datepicker-inline > table td.day.new,\r\n    .box .datepicker-inline .datepicker-days > table td.day.new {\r\n        color: var(--mu-texto-suave, #777);\r\n    }\r\n/*\r\n * General: Miscellaneous\r\n * ----------------------\r\n */\r\n.pad {\r\n    padding: 10px;\r\n}\r\n\r\n.margin {\r\n    margin: 10px;\r\n}\r\n\r\n.margin-bottom {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.margin-bottom-none {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.margin-r-5 {\r\n    margin-right: 5px;\r\n}\r\n\r\n.inline {\r\n    display: inline;\r\n}\r\n\r\n.description-block {\r\n    display: block;\r\n    margin: 10px 0;\r\n    text-align: center;\r\n}\r\n\r\n    .description-block.margin-bottom {\r\n        margin-bottom: 25px;\r\n    }\r\n\r\n    .description-block > .description-header {\r\n        margin: 0;\r\n        padding: 0;\r\n        font-weight: 600;\r\n        font-size: 16px;\r\n    }\r\n\r\n    .description-block > .description-text {\r\n        text-transform: uppercase;\r\n    }\r\n\r\n.bg-red,\r\n.bg-yellow,\r\n.bg-aqua,\r\n.bg-blue,\r\n.bg-light-blue,\r\n.bg-green,\r\n.bg-navy,\r\n.bg-teal,\r\n.bg-olive,\r\n.bg-lime,\r\n.bg-orange,\r\n.bg-fuchsia,\r\n.bg-purple,\r\n.bg-maroon,\r\n.bg-black,\r\n.bg-red-active,\r\n.bg-yellow-active,\r\n.bg-aqua-active,\r\n.bg-blue-active,\r\n.bg-light-blue-active,\r\n.bg-green-active,\r\n.bg-navy-active,\r\n.bg-teal-active,\r\n.bg-olive-active,\r\n.bg-lime-active,\r\n.bg-orange-active,\r\n.bg-fuchsia-active,\r\n.bg-purple-active,\r\n.bg-maroon-active,\r\n.bg-black-active,\r\n.callout.callout-danger,\r\n.callout.callout-warning,\r\n.callout.callout-info,\r\n.callout.callout-success,\r\n.alert-success,\r\n.alert-danger,\r\n.alert-error,\r\n.alert-warning,\r\n.alert-info,\r\n.label-danger,\r\n.label-info,\r\n.label-warning,\r\n.label-primary,\r\n.label-success,\r\n.modal-primary .modal-body,\r\n.modal-primary .modal-header,\r\n.modal-primary .modal-footer,\r\n.modal-warning .modal-body,\r\n.modal-warning .modal-header,\r\n.modal-warning .modal-footer,\r\n.modal-info .modal-body,\r\n.modal-info .modal-header,\r\n.modal-info .modal-footer,\r\n.modal-success .modal-body,\r\n.modal-success .modal-header,\r\n.modal-success .modal-footer,\r\n.modal-danger .modal-body,\r\n.modal-danger .modal-header,\r\n.modal-danger .modal-footer {\r\n    color: #fff !important;\r\n}\r\n\r\n.bg-gray {\r\n    color: var(--mu-texto, #000);\r\n    background-color: var(--mu-superficie-forte, #d2d6de) !important;\r\n}\r\n\r\n.bg-gray-light {\r\n    background-color: var(--mu-superficie-sutil, #f7f7f7);\r\n}\r\n\r\n.bg-black {\r\n    background-color: #111111 !important;\r\n}\r\n\r\n.bg-red,\r\n.callout.callout-danger,\r\n.alert-danger,\r\n.alert-error,\r\n.label-danger,\r\n.modal-danger .modal-body {\r\n    background-color: #dd4b39 !important;\r\n}\r\n\r\n.bg-yellow,\r\n.callout.callout-warning,\r\n.alert-warning,\r\n.label-warning,\r\n.modal-warning .modal-body {\r\n    background-color: #f39c12 !important;\r\n}\r\n\r\n.bg-aqua,\r\n.callout.callout-info,\r\n.alert-info,\r\n.label-info,\r\n.modal-info .modal-body {\r\n    background-color: #00c0ef !important;\r\n}\r\n\r\n.bg-blue {\r\n    background-color: #0073b7 !important;\r\n}\r\n\r\n.bg-light-blue,\r\n.label-primary,\r\n.modal-primary .modal-body {\r\n    background-color: #3c8dbc !important;\r\n}\r\n\r\n.bg-green,\r\n.callout.callout-success,\r\n.alert-success,\r\n.label-success,\r\n.modal-success .modal-body {\r\n    background-color: #00a65a !important;\r\n}\r\n\r\n.bg-navy {\r\n    background-color: #001f3f !important;\r\n}\r\n\r\n.bg-teal {\r\n    background-color: #39cccc !important;\r\n}\r\n\r\n.bg-olive {\r\n    background-color: #3d9970 !important;\r\n}\r\n\r\n.bg-lime {\r\n    background-color: #01ff70 !important;\r\n}\r\n\r\n.bg-orange {\r\n    background-color: #ff851b !important;\r\n}\r\n\r\n.bg-fuchsia {\r\n    background-color: #f012be !important;\r\n}\r\n\r\n.bg-purple {\r\n    background-color: #605ca8 !important;\r\n}\r\n\r\n.bg-maroon {\r\n    background-color: #d81b60 !important;\r\n}\r\n\r\n.bg-gray-active {\r\n    color: var(--mu-texto, #000);\r\n    background-color: var(--mu-superficie-escura, #b5bbc8) !important;\r\n}\r\n\r\n.bg-black-active {\r\n    background-color: #000000 !important;\r\n}\r\n\r\n.bg-red-active,\r\n.modal-danger .modal-header,\r\n.modal-danger .modal-footer {\r\n    background-color: #d33724 !important;\r\n}\r\n\r\n.bg-yellow-active,\r\n.modal-warning .modal-header,\r\n.modal-warning .modal-footer {\r\n    background-color: #db8b0b !important;\r\n}\r\n\r\n.bg-aqua-active,\r\n.modal-info .modal-header,\r\n.modal-info .modal-footer {\r\n    background-color: #00a7d0 !important;\r\n}\r\n\r\n.bg-blue-active {\r\n    background-color: #005384 !important;\r\n}\r\n\r\n.bg-light-blue-active,\r\n.modal-primary .modal-header,\r\n.modal-primary .modal-footer {\r\n    background-color: #357ca5 !important;\r\n}\r\n\r\n.bg-green-active,\r\n.modal-success .modal-header,\r\n.modal-success .modal-footer {\r\n    background-color: #008d4c !important;\r\n}\r\n\r\n.bg-navy-active {\r\n    background-color: #001a35 !important;\r\n}\r\n\r\n.bg-teal-active {\r\n    background-color: #30bbbb !important;\r\n}\r\n\r\n.bg-olive-active {\r\n    background-color: #368763 !important;\r\n}\r\n\r\n.bg-lime-active {\r\n    background-color: #00e765 !important;\r\n}\r\n\r\n.bg-orange-active {\r\n    background-color: #ff7701 !important;\r\n}\r\n\r\n.bg-fuchsia-active {\r\n    background-color: #db0ead !important;\r\n}\r\n\r\n.bg-purple-active {\r\n    background-color: #555299 !important;\r\n}\r\n\r\n.bg-maroon-active {\r\n    background-color: #ca195a !important;\r\n}\r\n\r\n[class^=\"bg-\"].disabled {\r\n    opacity: 0.65;\r\n    filter: alpha(opacity=65);\r\n}\r\n\r\n.text-red {\r\n    color: #dd4b39 !important;\r\n}\r\n\r\n.text-yellow {\r\n    color: #f39c12 !important;\r\n}\r\n\r\n.text-aqua {\r\n    color: #00c0ef !important;\r\n}\r\n\r\n.text-blue {\r\n    color: #0073b7 !important;\r\n}\r\n\r\n.text-black {\r\n    color: var(--mu-texto, #111111) !important;\r\n}\r\n\r\n.text-light-blue {\r\n    color: #3c8dbc !important;\r\n}\r\n\r\n.text-green {\r\n    color: #00a65a !important;\r\n}\r\n\r\n.text-gray {\r\n    color: #d2d6de !important;\r\n}\r\n\r\n.text-navy {\r\n    color: #001f3f !important;\r\n}\r\n\r\n.text-teal {\r\n    color: #39cccc !important;\r\n}\r\n\r\n.text-olive {\r\n    color: #3d9970 !important;\r\n}\r\n\r\n.text-lime {\r\n    color: #01ff70 !important;\r\n}\r\n\r\n.text-orange {\r\n    color: #ff851b !important;\r\n}\r\n\r\n.text-fuchsia {\r\n    color: #f012be !important;\r\n}\r\n\r\n.text-purple {\r\n    color: #605ca8 !important;\r\n}\r\n\r\n.text-maroon {\r\n    color: #d81b60 !important;\r\n}\r\n\r\n.link-muted {\r\n    color: #7a869d;\r\n}\r\n\r\n    .link-muted:hover,\r\n    .link-muted:focus {\r\n        color: #606c84;\r\n    }\r\n\r\n.link-black {\r\n    color: var(--mu-texto-suave, #666);\r\n}\r\n\r\n    .link-black:hover,\r\n    .link-black:focus {\r\n        color: var(--mu-texto-suave, #999);\r\n    }\r\n\r\n.hide {\r\n    display: none !important;\r\n}\r\n\r\n.no-border {\r\n    border: 0 !important;\r\n}\r\n\r\n.no-padding {\r\n    padding: 0 !important;\r\n}\r\n\r\n.no-margin {\r\n    margin: 0 !important;\r\n}\r\n\r\n.no-shadow {\r\n    box-shadow: none !important;\r\n}\r\n\r\n.list-unstyled,\r\n.chart-legend,\r\n.contacts-list,\r\n.users-list,\r\n.mailbox-attachments {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.list-group-unbordered > .list-group-item {\r\n    border-left: 0;\r\n    border-right: 0;\r\n    border-radius: 0;\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n}\r\n\r\n.flat {\r\n    border-radius: 0 !important;\r\n}\r\n\r\n.text-bold,\r\n.text-bold.table td,\r\n.text-bold.table th {\r\n    font-weight: 700;\r\n}\r\n\r\n.text-sm {\r\n    font-size: 12px;\r\n}\r\n\r\n.jqstooltip {\r\n    padding: 5px !important;\r\n    width: auto !important;\r\n    height: auto !important;\r\n}\r\n\r\n.bg-teal-gradient {\r\n    background: #39cccc !important;\r\n    background: -webkit-gradient(linear, left bottom, left top, color-stop(0, #39cccc), color-stop(1, #7adddd)) !important;\r\n    background: -ms-linear-gradient(bottom, #39cccc, #7adddd) !important;\r\n    background: -moz-linear-gradient(center bottom, #39cccc 0%, #7adddd 100%) !important;\r\n    background: -o-linear-gradient(#7adddd, #39cccc) !important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#7adddd', endColorstr='#39cccc', GradientType=0) !important;\r\n    color: #fff;\r\n}\r\n\r\n.bg-light-blue-gradient {\r\n    background: #3c8dbc !important;\r\n    background: -webkit-gradient(linear, left bottom, left top, color-stop(0, #3c8dbc), color-stop(1, #67a8ce)) !important;\r\n    background: -ms-linear-gradient(bottom, #3c8dbc, #67a8ce) !important;\r\n    background: -moz-linear-gradient(center bottom, #3c8dbc 0%, #67a8ce 100%) !important;\r\n    background: -o-linear-gradient(#67a8ce, #3c8dbc) !important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#67a8ce', endColorstr='#3c8dbc', GradientType=0) !important;\r\n    color: #fff;\r\n}\r\n\r\n.bg-blue-gradient {\r\n    background: #0073b7 !important;\r\n    background: -webkit-gradient(linear, left bottom, left top, color-stop(0, #0073b7), color-stop(1, #0089db)) !important;\r\n    background: -ms-linear-gradient(bottom, #0073b7, #0089db) !important;\r\n    background: -moz-linear-gradient(center bottom, #0073b7 0%, #0089db 100%) !important;\r\n    background: -o-linear-gradient(#0089db, #0073b7) !important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#0089db', endColorstr='#0073b7', GradientType=0) !important;\r\n    color: #fff;\r\n}\r\n\r\n.bg-aqua-gradient {\r\n    background: #00c0ef !important;\r\n    background: -webkit-gradient(linear, left bottom, left top, color-stop(0, #00c0ef), color-stop(1, #14d1ff)) !important;\r\n    background: -ms-linear-gradient(bottom, #00c0ef, #14d1ff) !important;\r\n    background: -moz-linear-gradient(center bottom, #00c0ef 0%, #14d1ff 100%) !important;\r\n    background: -o-linear-gradient(#14d1ff, #00c0ef) !important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#14d1ff', endColorstr='#00c0ef', GradientType=0) !important;\r\n    color: #fff;\r\n}\r\n\r\n.bg-yellow-gradient {\r\n    background: #f39c12 !important;\r\n    background: -webkit-gradient(linear, left bottom, left top, color-stop(0, #f39c12), color-stop(1, #f7bc60)) !important;\r\n    background: -ms-linear-gradient(bottom, #f39c12, #f7bc60) !important;\r\n    background: -moz-linear-gradient(center bottom, #f39c12 0%, #f7bc60 100%) !important;\r\n    background: -o-linear-gradient(#f7bc60, #f39c12) !important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f7bc60', endColorstr='#f39c12', GradientType=0) !important;\r\n    color: #fff;\r\n}\r\n\r\n.bg-purple-gradient {\r\n    background: #605ca8 !important;\r\n    background: -webkit-gradient(linear, left bottom, left top, color-stop(0, #605ca8), color-stop(1, #9491c4)) !important;\r\n    background: -ms-linear-gradient(bottom, #605ca8, #9491c4) !important;\r\n    background: -moz-linear-gradient(center bottom, #605ca8 0%, #9491c4 100%) !important;\r\n    background: -o-linear-gradient(#9491c4, #605ca8) !important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#9491c4', endColorstr='#605ca8', GradientType=0) !important;\r\n    color: #fff;\r\n}\r\n\r\n.bg-green-gradient {\r\n    background: #00a65a !important;\r\n    background: -webkit-gradient(linear, left bottom, left top, color-stop(0, #00a65a), color-stop(1, #00ca6d)) !important;\r\n    background: -ms-linear-gradient(bottom, #00a65a, #00ca6d) !important;\r\n    background: -moz-linear-gradient(center bottom, #00a65a 0%, #00ca6d 100%) !important;\r\n    background: -o-linear-gradient(#00ca6d, #00a65a) !important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ca6d', endColorstr='#00a65a', GradientType=0) !important;\r\n    color: #fff;\r\n}\r\n\r\n.bg-red-gradient {\r\n    background: #dd4b39 !important;\r\n    background: -webkit-gradient(linear, left bottom, left top, color-stop(0, #dd4b39), color-stop(1, #e47365)) !important;\r\n    background: -ms-linear-gradient(bottom, #dd4b39, #e47365) !important;\r\n    background: -moz-linear-gradient(center bottom, #dd4b39 0%, #e47365 100%) !important;\r\n    background: -o-linear-gradient(#e47365, #dd4b39) !important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#e47365', endColorstr='#dd4b39', GradientType=0) !important;\r\n    color: #fff;\r\n}\r\n\r\n.bg-black-gradient {\r\n    background: #111111 !important;\r\n    background: -webkit-gradient(linear, left bottom, left top, color-stop(0, #111111), color-stop(1, #2b2b2b)) !important;\r\n    background: -ms-linear-gradient(bottom, #111111, #2b2b2b) !important;\r\n    background: -moz-linear-gradient(center bottom, #111111 0%, #2b2b2b 100%) !important;\r\n    background: -o-linear-gradient(#2b2b2b, #111111) !important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#2b2b2b', endColorstr='#111111', GradientType=0) !important;\r\n    color: #fff;\r\n}\r\n\r\n.bg-maroon-gradient {\r\n    background: #d81b60 !important;\r\n    background: -webkit-gradient(linear, left bottom, left top, color-stop(0, #d81b60), color-stop(1, #e73f7c)) !important;\r\n    background: -ms-linear-gradient(bottom, #d81b60, #e73f7c) !important;\r\n    background: -moz-linear-gradient(center bottom, #d81b60 0%, #e73f7c 100%) !important;\r\n    background: -o-linear-gradient(#e73f7c, #d81b60) !important;\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#e73f7c', endColorstr='#d81b60', GradientType=0) !important;\r\n    color: #fff;\r\n}\r\n\r\n.description-block .description-icon {\r\n    font-size: 16px;\r\n}\r\n\r\n.no-pad-top {\r\n    padding-top: 0;\r\n}\r\n\r\n.position-static {\r\n    position: static !important;\r\n}\r\n\r\n.list-header {\r\n    font-size: 15px;\r\n    padding: 10px 4px;\r\n    font-weight: bold;\r\n    color: var(--mu-texto-suave, #666);\r\n}\r\n\r\n.list-seperator {\r\n    height: 1px;\r\n    background: var(--mu-superficie-sutil, #f4f4f4);\r\n    margin: 15px 0 9px 0;\r\n}\r\n\r\n.list-link > a {\r\n    padding: 4px;\r\n    color: var(--mu-texto-suave, #777);\r\n}\r\n\r\n    .list-link > a:hover {\r\n        color: var(--mu-texto, #222);\r\n    }\r\n\r\n.font-light {\r\n    font-weight: 300;\r\n}\r\n\r\n.user-block:before,\r\n.user-block:after {\r\n    content: \" \";\r\n    display: table;\r\n}\r\n\r\n.user-block:after {\r\n    clear: both;\r\n}\r\n\r\n.user-block img {\r\n    width: 40px;\r\n    height: 40px;\r\n    float: left;\r\n}\r\n\r\n.user-block .username,\r\n.user-block .description,\r\n.user-block .comment {\r\n    display: block;\r\n    margin-left: 50px;\r\n}\r\n\r\n.user-block .username {\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n}\r\n\r\n.user-block .description {\r\n    color: var(--mu-texto-suave, #999);\r\n    font-size: 13px;\r\n}\r\n\r\n.user-block.user-block-sm .username,\r\n.user-block.user-block-sm .description,\r\n.user-block.user-block-sm .comment {\r\n    margin-left: 40px;\r\n}\r\n\r\n.user-block.user-block-sm .username {\r\n    font-size: 14px;\r\n}\r\n\r\n.img-sm,\r\n.img-md,\r\n.img-lg,\r\n.box-comments .box-comment img,\r\n.user-block.user-block-sm img {\r\n    float: left;\r\n}\r\n\r\n.img-sm,\r\n.box-comments .box-comment img,\r\n.user-block.user-block-sm img {\r\n    width: 30px !important;\r\n    height: 30px !important;\r\n}\r\n\r\n    .img-sm + .img-push {\r\n        margin-left: 40px;\r\n    }\r\n\r\n.img-md {\r\n    width: 60px;\r\n    height: 60px;\r\n}\r\n\r\n    .img-md + .img-push {\r\n        margin-left: 70px;\r\n    }\r\n\r\n.img-lg {\r\n    width: 100px;\r\n    height: 100px;\r\n}\r\n\r\n    .img-lg + .img-push {\r\n        margin-left: 110px;\r\n    }\r\n\r\n.img-bordered {\r\n    border: 3px solid var(--mu-borda-forte, #d2d6de);\r\n    padding: 3px;\r\n}\r\n\r\n.img-bordered-sm {\r\n    border: 2px solid var(--mu-borda-forte, #d2d6de);\r\n    padding: 2px;\r\n}\r\n\r\n.attachment-block {\r\n    border: 1px solid var(--mu-borda-sutil, #f4f4f4);\r\n    padding: 5px;\r\n    margin-bottom: 10px;\r\n    background: var(--mu-superficie-sutil, #f7f7f7);\r\n}\r\n\r\n    .attachment-block .attachment-img {\r\n        max-width: 100px;\r\n        max-height: 100px;\r\n        height: auto;\r\n        float: left;\r\n    }\r\n\r\n    .attachment-block .attachment-pushed {\r\n        margin-left: 110px;\r\n    }\r\n\r\n    .attachment-block .attachment-heading {\r\n        margin: 0;\r\n    }\r\n\r\n    .attachment-block .attachment-text {\r\n        color: var(--mu-texto-suave, #555);\r\n    }\r\n\r\n.connectedSortable {\r\n    min-height: 100px;\r\n}\r\n\r\n.ui-helper-hidden-accessible {\r\n    border: 0;\r\n    clip: rect(0 0 0 0);\r\n    height: 1px;\r\n    margin: -1px;\r\n    overflow: hidden;\r\n    padding: 0;\r\n    position: absolute;\r\n    width: 1px;\r\n}\r\n\r\n.sort-highlight {\r\n    background: var(--mu-superficie-sutil, #f4f4f4);\r\n    border: 1px dashed var(--mu-borda-media, #ddd);\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.full-opacity-hover {\r\n    opacity: 0.65;\r\n    filter: alpha(opacity=65);\r\n}\r\n\r\n    .full-opacity-hover:hover {\r\n        opacity: 1;\r\n        filter: alpha(opacity=100);\r\n    }\r\n\r\n.chart {\r\n    position: relative;\r\n    overflow: hidden;\r\n    width: 100%;\r\n}\r\n\r\n    .chart svg,\r\n    .chart canvas {\r\n        width: 100% !important;\r\n    }\r\n\r\n.corpo {\r\n    flex: 1 0 auto;\r\n}\r\n\r\n.footer {\r\n    flex-shrink: 0;\r\n}\r\n\r\n/*\r\n * Misc: print\r\n * -----------\r\n */\r\n@media print {\r\n    .no-print,\r\n    .main-sidebar,\r\n    .left-side,\r\n    .main-header,\r\n    .content-header {\r\n        display: none !important;\r\n    }\r\n\r\n    .content-wrapper,\r\n    .right-side,\r\n    .main-footer {\r\n        margin-left: 0 !important;\r\n        min-height: 0 !important;\r\n        -webkit-transform: translate(0, 0) !important;\r\n        -ms-transform: translate(0, 0) !important;\r\n        -o-transform: translate(0, 0) !important;\r\n        transform: translate(0, 0) !important;\r\n    }\r\n\r\n    .fixed .content-wrapper,\r\n    .fixed .right-side {\r\n        padding-top: 0 !important;\r\n    }\r\n\r\n    .invoice {\r\n        width: 100%;\r\n        border: 0;\r\n        margin: 0;\r\n        padding: 0;\r\n    }\r\n\r\n    .invoice-col {\r\n        float: left;\r\n        width: 33.3333333%;\r\n    }\r\n\r\n    .table-responsive {\r\n        overflow: auto;\r\n    }\r\n\r\n        .table-responsive > .table tr th,\r\n        .table-responsive > .table tr td {\r\n            white-space: normal !important;\r\n        }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
